(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}],2:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Breakpoint = function () {
    function Breakpoint() {
        _classCallCheck(this, Breakpoint);
    }

    _createClass(Breakpoint, null, [{
        key: "update",
        value: function update() {
            var cssBefore = window.getComputedStyle(document.querySelector('body'), ':before');
            var cssBeforeValue = cssBefore.getPropertyValue('content').replace(/[\"\']/g, '');
            exports.breakpoint = {
                desktop: cssBeforeValue === 'desktop',
                phone: cssBeforeValue === 'phone',
                tablet: cssBeforeValue === 'tablet',
                value: cssBeforeValue
            };
        }
    }]);

    return Breakpoint;
}();

exports.Breakpoint = Breakpoint;

},{}],3:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
function getBrowser() {
    var ua = window.navigator.userAgent;
    exports.browser = {
        mobile: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(ua.substr(0, 4)) ? true : false,
        ios: /iPad|iPhone|iPod/.test(ua),
        mac: navigator.platform.toUpperCase().indexOf('MAC') >= 0,
        ie: ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./),
        opera: !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0,
        firefox: ua.toLowerCase().indexOf('firefox') > -1,
        safari: /^((?!chrome|android).)*safari/i.test(ua),
        windows: window.navigator.platform.toLowerCase().indexOf('win') > -1
    };
    $('html').toggleClass('mac', !exports.browser.windows && (exports.browser.ios || exports.browser.mac)).toggleClass('windows', exports.browser.windows && !exports.browser.mac && !exports.browser.ios).toggleClass('mobile', exports.browser.mobile).toggleClass('firefox', exports.browser.firefox).toggleClass('safari', exports.browser.safari).toggleClass('ie', exports.browser.ie);
    return exports.browser;
}
exports.getBrowser = getBrowser;

var Browser = function () {
    function Browser() {
        _classCallCheck(this, Browser);
    }

    _createClass(Browser, null, [{
        key: "update",
        value: function update() {
            exports.browser = getBrowser();
        }
    }]);

    return Browser;
}();

exports.Browser = Browser;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AddExporter_1 = require("./components/AddExporter");
var RegistrationEvent_1 = require("./components/RegistrationEvent");
var Blob_1 = require("./components/Blob");
var EconomicActivity_1 = require("./components/EconomicActivity");
var HeadlinePhoto_1 = require("./components/HeadlinePhoto");
var HomeSlider_1 = require("./components/HomeSlider");
var HomeWave_1 = require("./components/HomeWave");
var Infobox_1 = require("./components/Infobox");
var InfoboxSpeaker_1 = require("./components/InfoboxSpeaker");
var InfoboxBase_1 = require("./components/InfoboxBase");
var Lightbox_1 = require("./components/Lightbox");
var Load_1 = require("./components/Load");
var More_1 = require("./components/More");
var Map_1 = require("./components/Map");
var MapSlider_1 = require("./components/MapSlider");
var Projects_1 = require("./components/Projects");
var Slider_1 = require("./components/Slider");
var SliderImage_1 = require("./components/SliderImage");
var SliderDoubleRow_1 = require("./components/SliderDoubleRow");
var Swipe_1 = require("./components/Swipe");
var Tiles_1 = require("./components/Tiles");
var Video_1 = require("./components/Video");
var Youtube_1 = require("./components/Youtube");
var Zoom_1 = require("./components/Zoom");
var Page_1 = require("./pages/Page");
exports.components = {
    AddExporter: AddExporter_1.AddExporter,
    Audio: Audio,
    RegistrationEvent: RegistrationEvent_1.RegistrationEvent,
    Blob: Blob_1.Blob,
    EconomicActivity: EconomicActivity_1.EconomicActivity,
    HeadlinePhoto: HeadlinePhoto_1.HeadlinePhoto,
    HomeSlider: HomeSlider_1.HomeSlider,
    HomeWave: HomeWave_1.HomeWave,
    Infobox: Infobox_1.Infobox,
    InfoboxSpeaker: InfoboxSpeaker_1.InfoboxSpeaker,
    InfoboxBase: InfoboxBase_1.InfoboxBase,
    Lightbox: Lightbox_1.Lightbox,
    Load: Load_1.Load,
    More: More_1.More,
    Map: Map_1.Map,
    MapSlider: MapSlider_1.MapSlider,
    Projects: Projects_1.Projects,
    Slider: Slider_1.Slider,
    SliderImage: SliderImage_1.SliderImage,
    SliderDoubleRow: SliderDoubleRow_1.SliderDoubleRow,
    Swipe: Swipe_1.Swipe,
    Tiles: Tiles_1.Tiles,
    Video: Video_1.Video,
    Youtube: Youtube_1.Youtube,
    Zoom: Zoom_1.Zoom
};
exports.pages = {
    Page: Page_1.Page
};

},{"./components/AddExporter":16,"./components/Blob":17,"./components/EconomicActivity":19,"./components/HeadlinePhoto":20,"./components/HomeSlider":21,"./components/HomeWave":22,"./components/Infobox":23,"./components/InfoboxBase":24,"./components/InfoboxSpeaker":25,"./components/Lightbox":26,"./components/Load":27,"./components/Map":28,"./components/MapSlider":29,"./components/More":30,"./components/Projects":33,"./components/RegistrationEvent":34,"./components/Slider":35,"./components/SliderDoubleRow":36,"./components/SliderImage":37,"./components/Swipe":38,"./components/Tiles":39,"./components/Video":40,"./components/Youtube":41,"./components/Zoom":42,"./pages/Page":43}],5:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Site_1 = require("./Site");
var Breakpoint_1 = require("./Breakpoint");

var Curtain = function () {
    function Curtain(view) {
        _classCallCheck(this, Curtain);

        this.view = view;
        this.isFalling = false;
        this.pixelRatio = 1;
        this.animating = false;
        this.coordinates = {
            topLeft: { x: 0, y: 0 },
            topRight: { x: 0, y: 0 },
            bottomLeft: { x: 0, y: 0 },
            bottomRight: { x: 0, y: 0 },
            radius: { val: 0 }
        };
        this.$slogan = this.view.find('.js-curtain-slogan');
        this.$decor = this.view.find('.js-curtain-decor');
        this.$wrapper = this.view.find('.js-curtain-wrapper');
        this.canvas = this.view.find('.js-canvas')[0];
        this.context = this.canvas.getContext('2d');
        this.colorSpecial = getComputedStyle(document.querySelector(':root')).getPropertyValue('--color-special');
        this.colorWcag = getComputedStyle(document.querySelector(':root')).getPropertyValue('--color-wcag');
        this.resize();
        Curtain.instance = this;
    }

    _createClass(Curtain, [{
        key: "resize",
        value: function resize(wdt, hgt, changed) {
            this.width = wdt || window.innerWidth;
            this.height = hgt || window.innerHeight;
            this.menuW = this.width * (Breakpoint_1.breakpoint.desktop ? 1.25 : 2.5);
            this.resizeBackground();
            this.drawBackground();
        }
    }, {
        key: "show",
        value: function show() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                _this.view.show();
                _this.isFalling = true;
                Site_1.$body.addClass('is-curtain');
                gsap.killTweensOf(_this.view);
                var tl = new TimelineMax();
                tl.fromTo(_this.$slogan, 0.2, {
                    opacity: 0
                }, {
                    opacity: 1,
                    ease: Site_1.easing
                }, 0.25);
                _this.setBackgroundYCoordinates(false).then(function () {
                    return resolve();
                });
            });
        }
    }, {
        key: "hide",
        value: function hide() {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                _this2.isFalling = false;
                var tl = new TimelineMax({
                    onComplete: function onComplete() {
                        $('.js-curtain-slogan p').text('');
                        gsap.set(_this2.$wrapper, {
                            clearProps: 'x'
                        });
                    }
                });
                tl.to(_this2.$slogan, 0.3, {
                    opacity: 0,
                    delay: 0.25,
                    ease: Site_1.easing
                });
                tl.call(resolve, null, '-=0.6');
                _this2.setBackgroundYCoordinates(false).then(function () {
                    return resolve();
                });
            });
        }
    }, {
        key: "drawBackground",
        value: function drawBackground() {
            var coords = this.coordinates;
            this.color = this.colorSpecial;
            if ($('body').hasClass('wcag-contrast-high')) {
                this.color = this.colorWcag;
            }
            this.context.clearRect(0, 0, this.width * this.pixelRatio, this.height * this.pixelRatio);
            this.context.beginPath();
            this.context.moveTo(this.width, this.height);
            this.context.arc(this.width, 0, this.coordinates.radius.val, 0.5 * Math.PI, 1 * Math.PI, false);
            this.context.lineTo(this.width, 0);
            this.context.fillStyle = this.color;
            this.context.fill();
        }
    }, {
        key: "resizeBackground",
        value: function resizeBackground() {
            this.canvas.width = this.width * this.pixelRatio;
            this.canvas.height = this.height * this.pixelRatio;
            $(this.canvas).css({
                height: this.height,
                width: this.width
            });
        }
    }, {
        key: "setBackgroundYCoordinates",
        value: function setBackgroundYCoordinates(fast) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var time = 0.6;
                _this3.animating = true;
                if (_this3.isFalling) {}
                gsap.timeline({
                    onComplete: function onComplete() {
                        _this3.animating = false;
                        if (!_this3.isFalling) {
                            _this3.view.hide();
                            Site_1.$body.removeClass('is-curtain');
                            Site_1.$body.removeClass('curtain-red');
                        }
                        resolve(true);
                    },
                    onUpdate: function onUpdate() {
                        return _this3.drawBackground();
                    }
                }).to(_this3.coordinates.radius, time, {
                    val: (_this3.isFalling ? _this3.menuW : 0) * _this3.pixelRatio,
                    delay: 0,
                    ease: _this3.isFalling ? 'sine.out' : 'sine.in'
                }, 0);
            });
        }
    }]);

    return Curtain;
}();

exports.Curtain = Curtain;

},{"./Breakpoint":2,"./Site":13}],6:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Handler = function () {
    function Handler() {
        _classCallCheck(this, Handler);

        this.events = {};
    }

    _createClass(Handler, [{
        key: "on",
        value: function on(eventName, handler) {
            if (!this.events[eventName]) {
                this.events[eventName] = [];
            }
            this.events[eventName].push(handler);
            return this;
        }
    }, {
        key: "off",
        value: function off(eventName, handler) {
            if (typeof eventName === 'undefined') {
                this.events = {};
                return this;
            }
            if (typeof handler === 'undefined' && this.events[eventName]) {
                this.events[eventName] = [];
                return this;
            }
            if (!this.events[eventName]) {
                return this;
            }
            var index = this.events[eventName].indexOf(handler);
            if (index > -1) {
                this.events[eventName].splice(index, 1);
            }
            return this;
        }
    }, {
        key: "trigger",
        value: function trigger(eventName) {
            var _this = this;

            for (var _len = arguments.length, extraParameters = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                extraParameters[_key - 1] = arguments[_key];
            }

            if (!this.events[eventName]) {
                return;
            }
            var args = arguments;
            this.events[eventName].forEach(function (event) {
                return event.apply(_this, [].slice.call(args, 1));
            });
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this.events = {};
        }
    }]);

    return Handler;
}();

exports.Handler = Handler;

},{}],7:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Handler_1 = require("./Handler");
var Site_1 = require("./Site");

var HeaderDesktop = function (_Handler_1$Handler) {
    _inherits(HeaderDesktop, _Handler_1$Handler);

    function HeaderDesktop(view) {
        _classCallCheck(this, HeaderDesktop);

        var _this = _possibleConstructorReturn(this, (HeaderDesktop.__proto__ || Object.getPrototypeOf(HeaderDesktop)).call(this));

        _this.view = view;
        _this.time = 0.5;
        _this.isAnimating = false;
        _this.$containerTop = _this.view.find('.header__container__top');
        _this.$buttonOptions = _this.view.find('.header__button-options');
        _this.$menu = _this.view.find('.menu');
        _this.$menu.find('> ul > li > a').append('<span></span>');
        _this.$menu.find('> ul > li > button').append('<span></span>');
        _this.view.find('.header__button').append('<span></span>');
        _this.$menu.find('> ul > li:not(:has(ul))').addClass('no-submenu');
        _this.$menu.find('> ul > li > ul:has(li)').parent().addClass('is-submenu');
        _this.$menu.find('> ul > li > ul > li > a').addClass('link-in-submenu');
        _this.bind();
        setTimeout(function () {
            _this.resize();
        }, 1);
        _this.view.data('HeaderDesktop', _this);
        return _this;
    }

    _createClass(HeaderDesktop, [{
        key: "onState",
        value: function onState() {
            this.hideAll();
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(HeaderDesktop.prototype.__proto__ || Object.getPrototypeOf(HeaderDesktop.prototype), "destroy", this).call(this);
            this.unbind();
        }
    }, {
        key: "resize",
        value: function resize() {
            if ($(window).width() < 1250) {
                $('body').addClass('is-menu-mobile');
            } else {
                $('body').removeClass('is-menu-mobile');
            }
        }
    }, {
        key: "showSubmenu",
        value: function showSubmenu(li) {
            var _this2 = this;

            li.addClass('is-open');
            li.children('button').attr('aria-expanded', 'true');
            var $submenu = li.children("ul");
            gsap.killTweensOf($submenu);
            gsap.set($submenu, { y: 0, 'display': 'block', 'opacity': 1 });
            this.isAnimating = true;
            gsap.from($submenu, this.time, {
                y: 30,
                opacity: 0,
                ease: Site_1.easing,
                onComplete: function onComplete() {
                    $submenu.attr('aria-hidden', 'false');
                    _this2.isAnimating = false;
                }
            });
        }
    }, {
        key: "hideSubmenu",
        value: function hideSubmenu(li) {
            var _this3 = this;

            li.removeClass('is-open');
            li.children('button').attr('aria-expanded', 'false');
            li.children('button').focus();
            var $submenu = li.children("ul");
            gsap.killTweensOf($submenu);
            this.isAnimating = true;
            gsap.to($submenu, this.time, {
                opacity: 0,
                y: 30,
                ease: Site_1.easing,
                onComplete: function onComplete() {
                    gsap.set($submenu, { 'display': 'none' });
                    $submenu.attr('aria-hidden', 'true');
                    _this3.isAnimating = false;
                }
            });
        }
    }, {
        key: "hideAll",
        value: function hideAll() {
            var li = this.$menu.find('.is-open');
            li.removeClass('is-open');
            li.children('button').attr('aria-expanded', 'false');
            li.children("ul").attr('aria-hidden', 'true');
            li.children("ul").hide();
            this.hideDecor(li, true);
        }
    }, {
        key: "showDecor",
        value: function showDecor(li, isline) {
            var svg = li.find('.svg-circlemenu');
            var circle = svg.find('circle').eq(0);
            var line = svg.find('line').eq(0);
            gsap.killTweensOf([circle, line]);
            gsap.to(circle, 0.4, { strokeDashoffset: "100", ease: 'sine.out' });
            if (isline) {
                gsap.to(line, 0.4, { opacity: 1, ease: 'sine.out' });
            }
        }
    }, {
        key: "hideDecor",
        value: function hideDecor(li, isline) {
            var svg = li.find('.svg-circlemenu');
            var circle = svg.find('circle').eq(0);
            var line = svg.find('line').eq(0);
            gsap.killTweensOf([circle, line]);
            gsap.to(circle, 0.4, { strokeDashoffset: "251", ease: 'sine.out' });
            if (isline) {
                gsap.to(line, 0.4, { opacity: 0, ease: 'sine.out' });
            }
        }
    }, {
        key: "mouseenterButtonCircle",
        value: function mouseenterButtonCircle(el) {
            var text1 = el.find('.submenu-text-container span').eq(0);
            var text2 = el.find('.submenu-text-container span').eq(1);
            gsap.killTweensOf([text1, text2]);
            var h = el.find('.submenu-text-container').height() * 1.2;
            var deg = 0;
            gsap.fromTo(text1, 0.35, { y: 0, rotation: 0, opacity: 1 }, { y: -h, rotation: deg, opacity: 0, ease: 'sine.out' });
            gsap.fromTo(text2, 0.35, { y: h, rotation: deg, opacity: 0 }, { y: 0, rotation: 0, opacity: 1, ease: 'sine.out' });
        }
    }, {
        key: "mouseleaveButtonCircle",
        value: function mouseleaveButtonCircle(el) {
            var text1 = el.find('.submenu-text-container span').eq(0);
            var text2 = el.find('.submenu-text-container span').eq(1);
            gsap.killTweensOf([text1, text2]);
            var h = el.find('.submenu-text-container').height() * 1.2;
            var deg = 0;
            gsap.set(text1, { y: 0, rotation: 0 });
            gsap.fromTo(text1, 0.25, { opacity: 0 }, { opacity: 1, ease: 'sine.out' });
            gsap.fromTo(text2, 0.25, { opacity: 1 }, { opacity: 0, ease: 'sine.out' });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            Site_1.$body.off('.header-desktop');
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this4 = this;

            $(document).on('keydown', function (e) {
                if ($('.is-submenu.is-open').length > 0) {
                    if (e.keyCode === 40) {
                        e.preventDefault();
                        e.stopPropagation();
                    } else if (e.keyCode === 38) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
                if (e.keyCode === 9) {
                    if (_this4.isAnimating) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
            });
            $(document).on('keyup', function (e) {
                var el = $(e.currentTarget);
                var keycode = e.keyCode || e.which;
            });
            this.$menu.find('button').on('keyup', function (e) {
                var el = $(e.currentTarget);
                var keycode = e.keyCode || e.which;
            });
            this.$menu.find('.no-submenu, .is-submenu, .link-in-submenu').off('.header-desktop').on('mouseenter.header-desktop', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var el = $(e.currentTarget);
                if (!$('body').hasClass('is-menu-mobile')) {
                    if (el.hasClass('link-in-submenu')) {
                        _this4.mouseenterButtonCircle(el);
                    } else if (el.hasClass('no-submenu')) {
                        _this4.showDecor(el);
                    } else {
                        _this4.showSubmenu(el);
                        _this4.showDecor(el, true);
                    }
                }
            }).on('click.header-desktop', function (e) {
                var el = $(e.currentTarget);
                if (!$('body').hasClass('is-menu-mobile')) {
                    if (el.hasClass('is-submenu') && !el.hasClass('is-open')) {
                        _this4.showSubmenu(el);
                        _this4.showDecor(el, true);
                    } else if (el.hasClass('is-submenu') && el.hasClass('is-open')) {
                        _this4.hideSubmenu(el);
                        _this4.hideDecor(el, true);
                    }
                }
            }).on('mouseleave.header-desktop', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var el = $(e.currentTarget);
                if (!$('body').hasClass('is-menu-mobile')) {
                    if (el.hasClass('link-in-submenu')) {
                        _this4.mouseleaveButtonCircle(el);
                    } else if (el.hasClass('no-submenu')) {
                        _this4.hideDecor(el);
                    } else {
                        _this4.hideDecor(el, true);
                        _this4.hideSubmenu(el);
                    }
                }
            }).on('keyup.header-desktop', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var el = $(e.currentTarget);
                var keycode = e.keyCode || e.which;
                if (keycode == 32) {
                    if (el.hasClass('is-submenu') && !el.hasClass('is-open')) {
                        _this4.showSubmenu(el);
                        _this4.showDecor(el, true);
                    }
                }
                if (keycode == 27) {
                    if (el.hasClass('is-submenu') && el.hasClass('is-open')) {
                        _this4.hideSubmenu(el);
                        _this4.hideDecor(el, true);
                    }
                    if (el.hasClass('link-in-submenu')) {
                        _this4.hideSubmenu(el.closest('.is-submenu'));
                        _this4.hideDecor(el.closest('.is-submenu'), true);
                    }
                }
                if (keycode == 40) {
                    if (el.hasClass('is-open') && !el.find('.link-in-submenu').is(':focus')) {
                        el.find('li').first().find('.link-in-submenu').focus();
                    }
                    if (el.hasClass('link-in-submenu')) {
                        el.parent().next().find('.link-in-submenu').focus();
                    }
                }
                if (keycode == 38) {
                    if (el.hasClass('link-in-submenu')) {
                        el.parent().prev().find('.link-in-submenu').focus();
                    }
                }
            });
            this.$menu.find('.is-submenu, .no-submenu').each(function (i, e) {
                var button = $(e).children('button, a').focus(function (e) {
                    _this4.hideAll();
                });
            });
            $('.header__button').off('.header-desktop').on('mouseenter.header-desktop', function (e) {
                var el = $(e.currentTarget);
                if (!$('body').hasClass('is-menu-mobile')) {
                    _this4.showDecor(el);
                    e.preventDefault();
                }
            }).on('mouseleave.header-desktop', function (e) {
                var el = $(e.currentTarget);
                if (!$('body').hasClass('is-menu-mobile')) {
                    _this4.hideDecor(el);
                    e.preventDefault();
                }
            }).on('keyup.header-desktop', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var el = $(e.currentTarget);
                var keycode = e.keyCode || e.which;
                if (keycode == 13) {
                    if (!el.hasClass('is-open')) {
                        _this4.showDecor(el);
                    } else {
                        _this4.hideDecor(el);
                    }
                }
            });
        }
    }]);

    return HeaderDesktop;
}(Handler_1.Handler);

exports.HeaderDesktop = HeaderDesktop;

},{"./Handler":6,"./Site":13}],8:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Handler_1 = require("./Handler");
var Site_1 = require("./Site");

var HeaderMobile = function (_Handler_1$Handler) {
    _inherits(HeaderMobile, _Handler_1$Handler);

    function HeaderMobile(view) {
        _classCallCheck(this, HeaderMobile);

        var _this = _possibleConstructorReturn(this, (HeaderMobile.__proto__ || Object.getPrototypeOf(HeaderMobile)).call(this));

        _this.view = view;
        _this.time = 0.5;
        _this.toogleSubmenu = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var li = $(e.currentTarget).closest('li');
            var ul = li.children('ul');
            var neighbors = li.closest('ul').children('li.is-open');
            if (ul.hasClass('is-open')) {
                li.removeClass('is-open');
                ul.removeClass('is-open');
                ul.find('.is-open').removeClass('is-open');
                gsap.to(ul, { duration: _this.time, height: '0px', pointerEvents: 'all', onComplete: function onComplete() {
                        gsap.set(ul, { 'display': 'none' });
                    } });
            } else {
                li.addClass('is-open');
                ul.addClass('is-open');
                gsap.set(ul, { 'display': 'block', height: '' });
                var h = ul.outerHeight(true);
                gsap.set(ul, { height: '0px' });
                gsap.to(ul, { duration: _this.time, height: h, pointerEvents: 'all', onComplete: function onComplete() {} });
                neighbors.each(function (i, el) {
                    var liN = $(el);
                    if (liN.get(0) != li.get(0)) {
                        var ulN = liN.children('ul');
                        gsap.to(ulN, { duration: _this.time, height: '0px', pointerEvents: 'all', onComplete: function onComplete() {
                                gsap.set(ulN, { 'display': 'none' });
                                liN.removeClass('is-open');
                                ulN.removeClass('is-open');
                            } });
                    }
                });
            }
        };
        _this.onToggleClickHandler = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.toggle();
        };
        _this.$toggle = $('.js-toggle-menu');
        _this.$menu = _this.view.find('.menu');
        _this.$menu.find('> ul > li > ul:has(li)').parent().addClass('submenu-big');
        _this.$menu.find('.submenu-big button').addClass('button-more');
        _this.bind();
        _this.view.data('HeaderMobile', _this);
        return _this;
    }

    _createClass(HeaderMobile, [{
        key: "onState",
        value: function onState() {
            if (!!this.shown) {
                this.hideSubmenu();
                this.hide(true, 0.5);
            }
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(HeaderMobile.prototype.__proto__ || Object.getPrototypeOf(HeaderMobile.prototype), "destroy", this).call(this);
            this.unbind();
        }
    }, {
        key: "resize",
        value: function resize() {}
    }, {
        key: "unbind",
        value: function unbind() {
            Site_1.$body.off('.header-mobile');
            this.$toggle.off('.header-mobile');
            this.$menu.find('.button-more').off('.header-mobile');
        }
    }, {
        key: "bind",
        value: function bind() {
            this.$toggle.off('.header-mobile').on('click.header-mobile', this.onToggleClickHandler);
            this.$menu.find('.button-more').off('.header-mobile').on('click.header-mobile', this.toogleSubmenu);
        }
    }, {
        key: "hideSubmenu",
        value: function hideSubmenu() {
            var li = this.$menu.find('li.is-open');
            var ul = li.children('ul');
            gsap.to(ul, { duration: this.time, height: '0px', pointerEvents: 'all', onComplete: function onComplete() {
                    gsap.set(ul, { 'display': 'none' });
                    li.removeClass('is-open');
                    ul.removeClass('is-open');
                } });
        }
    }, {
        key: "toggle",
        value: function toggle(show, fast, force) {
            var _this2 = this;

            if (typeof show !== 'undefined') {
                if (!!show && (!this.shown || !!force)) {
                    this.show(fast);
                } else if (!show && (!!this.shown || !!force)) {
                    this.hide(fast, 0);
                }
            } else {
                (!!this.shown ? function (fast) {
                    return _this2.hide(fast, 0);
                } : function (fast) {
                    return _this2.show(fast);
                })(fast);
            }
        }
    }, {
        key: "show",
        value: function show(fast) {
            this.shown = true;
            Site_1.$body.addClass('is-menu-open');
            gsap.killTweensOf(this.$menu);
            gsap.set(this.$menu, { 'display': 'block', x: '-100%' });
            gsap.to(this.$menu, { duration: !fast ? this.time : 0, x: '0%', pointerEvents: 'all', onComplete: function onComplete() {} });
        }
    }, {
        key: "hide",
        value: function hide(fast, delay) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                gsap.killTweensOf(_this3.$menu);
                gsap.to(_this3.$menu, {
                    duration: !fast ? _this3.time : 0,
                    x: '-100%',
                    pointerEvents: 'none',
                    delay: delay,
                    onComplete: function onComplete() {
                        _this3.shown = false;
                        Site_1.$body.removeClass('is-menu-open');
                        $('.hamburger').focus();
                        if (fast) {
                            resolve();
                        }
                    }
                });
                resolve();
            });
        }
    }]);

    return HeaderMobile;
}(Handler_1.Handler);

exports.HeaderMobile = HeaderMobile;

},{"./Handler":6,"./Site":13}],9:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Loader = function () {
    function Loader(view) {
        var _this = this;

        _classCallCheck(this, Loader);

        this.view = view;
        this.current = { w: 0 };
        this.update = function () {
            var w = Math.round(_this.current.w);
            var percent = Math.round(w);
            _this.percent.text(percent + '%');
        };
        this.width = 100;
        this.progress = 0;
        this.line = this.view.find('svg path').eq(0);
        this.percent = this.view.find('.loader__percent');
        this.bg = this.view.find('.loader__bg');
    }

    _createClass(Loader, [{
        key: "show",
        value: function show() {
            gsap.to(this.view, 0.25, { opacity: 1 });
        }
    }, {
        key: "hide",
        value: function hide() {
            var _this2 = this;

            gsap.to(this.current, 0.5, {
                w: this.width,
                onUpdate: function onUpdate() {
                    return _this2.update();
                },
                onComplete: function onComplete() {
                    gsap.to(_this2.view, 0.5, {
                        opacity: 0,
                        onComplete: function onComplete() {
                            gsap.set(_this2.view, { 'display': 'none' });
                        }
                    });
                }
            });
        }
    }, {
        key: "draw",
        value: function draw() {
            gsap.fromTo(this.line, 3, { strokeDashoffset: 13290 }, { strokeDashoffset: 0 });
        }
    }, {
        key: "set",
        value: function set(progress) {
            var _this3 = this;

            this.progress = progress;
            var width = this.width * progress;
            gsap.killTweensOf(this.line, ['width']);
            gsap.to(this.current, 1.5, { w: width, onUpdate: function onUpdate() {
                    return _this3.update();
                } });
        }
    }]);

    return Loader;
}();

exports.Loader = Loader;

},{}],10:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var PushStates_1 = require("./PushStates");
var Utils = require("./Utils");
var All_1 = require("./widgets/All");
var Site_1 = require("./Site");
var Lightbox_1 = require("./components/Lightbox");
var Classes_1 = require("./Classes");

var Offscreen = function () {
    function Offscreen(view) {
        _classCallCheck(this, Offscreen);

        this.view = view;
        this.lightbox = new Lightbox_1.Lightbox(this.view.find('.js-lightbox'));
        this.hide(true);
    }

    _createClass(Offscreen, [{
        key: "onState",
        value: function onState() {
            var usedInCurrentLightbox = this.lightbox.onState();
            if (!!usedInCurrentLightbox) {
                this.show();
            }
            return usedInCurrentLightbox || this.toggleByPathname() || !!this.shown;
        }
    }, {
        key: "store",
        value: function store() {
            this.cache = $('[data-lightbox-json]').toArray().map(function (el, i) {
                return $(el).data('lightbox-json');
            });
        }
    }, {
        key: "reload",
        value: function reload() {
            this.store();
            this.toggleByPathname();
        }
    }, {
        key: "toggle",
        value: function toggle(show, fast, force) {
            var _this = this;

            if (typeof show !== 'undefined') {
                if (!!show && (!this.shown || !!force)) {
                    this.show(fast);
                } else if (!show && (!!this.shown || !!force)) {
                    this.hide(fast);
                }
            } else {
                (!!this.shown ? function (fast) {
                    return _this.hide(fast);
                } : function (fast) {
                    return _this.show(fast);
                })(fast);
            }
        }
    }, {
        key: "show",
        value: function show(fast) {
            this.shown = true;
            this.view.show();
            gsap.to(this.view, {
                duration: !fast ? 0.6 : 0,
                opacity: 1,
                ease: Site_1.easing,
                onComplete: function onComplete() {}
            });
        }
    }, {
        key: "hide",
        value: function hide(fast) {
            var _this2 = this;

            if (!this.shown) {
                return;
            }
            Site_1.$body.removeClass('is-offscreen-open');
            gsap.to(this.view, {
                duration: !fast ? 0.6 : 0,
                opacity: 0,
                ease: Site_1.easing,
                onComplete: function onComplete() {
                    _this2.shown = false;
                    _this2.view.hide();
                    _this2.destroyComponents();
                    _this2.lightbox.destroy();
                }
            });
        }
    }, {
        key: "resize",
        value: function resize(wdt, hgt, breakpoint, changed) {
            this.lightbox.resize(wdt, hgt, breakpoint, changed);
        }
    }, {
        key: "toggleByPathname",
        value: function toggleByPathname() {
            var found = this.getLightboxByPathname();
            if (!!found) {
                var $lightboxEl = this.lightbox.build(found);
                this.buildComponents(this.view.find('[data-component]'));
                PushStates_1.PushStates.bind($lightboxEl[0]);
                All_1.Widgets.bind($lightboxEl[0]);
                this.show();
            } else if (!!this.shown) {
                this.hide();
            }
            return !!found;
        }
    }, {
        key: "getLightboxByPathname",
        value: function getLightboxByPathname(path) {
            path = typeof path !== 'undefined' && path !== null ? path : window.location.pathname;
            path = Utils.normalizeURL(path);
            var lightboxData = void 0;
            for (var index = 0; index < this.cache.length; index++) {
                var lightbox = this.cache[index];
                if (Utils.normalizeURL(lightbox.url) === path) {
                    return lightbox;
                } else {
                    var itemsFound = lightbox.items.filter(function (item, i) {
                        return Utils.normalizeURL(item.url) === path;
                    });
                    if (itemsFound.length > 0) {
                        return lightbox;
                    }
                }
            }
            return null;
        }
    }, {
        key: "buildComponents",
        value: function buildComponents($components) {
            this.components = [];
            for (var i = $components.length - 1; i >= 0; i--) {
                var $component = $components.eq(i);
                var componentName = $component.data('component');
                if (componentName !== undefined && Classes_1.components[componentName]) {
                    var options = $component.data('options'),
                        component = new Classes_1.components[componentName]($component, options);
                    this.components.push(component);
                } else {
                    window.console.warn('There is no `%s` component!', componentName);
                }
            }
        }
    }, {
        key: "destroyComponents",
        value: function destroyComponents() {
            if (this.components) {
                this.components.forEach(function (component) {
                    component.destroy();
                });
            }
        }
    }]);

    return Offscreen;
}();

exports.Offscreen = Offscreen;

},{"./Classes":4,"./PushStates":11,"./Site":13,"./Utils":15,"./components/Lightbox":26,"./widgets/All":44}],11:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Handler_1 = require("./Handler");
var Scrolling_1 = require("./Scrolling");
var Historyjs = History;

var PushStatesEvents = function PushStatesEvents() {
    _classCallCheck(this, PushStatesEvents);
};

exports.PushStatesEvents = PushStatesEvents;
PushStatesEvents.CHANGE = 'state';
PushStatesEvents.PROGRESS = 'progress';

var PushStates = function (_Handler_1$Handler) {
    _inherits(PushStates, _Handler_1$Handler);

    function PushStates() {
        _classCallCheck(this, PushStates);

        var _this = _possibleConstructorReturn(this, (PushStates.__proto__ || Object.getPrototypeOf(PushStates)).call(this));

        _this.onLanguageClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var alternate = $('[data-alternate]').data('alternate');
            var lang = $('html').attr('lang');
            if (alternate == undefined || alternate == '') {
                alternate == '';
                if (lang == 'pl') {
                    alternate = 'en';
                } else if (lang == 'en') {
                    alternate = 'pl';
                }
                window.location.assign(window.location.origin + '/' + alternate);
            } else {
                window.location.assign(alternate);
            }
        };
        _this.onClick = function (e) {
            e.preventDefault();
            var $self = $(e.currentTarget),
                state = $self.attr('href').replace('https://' + window.location.host, ''),
                type = $self.attr('data-history');
            if (type === 'back') {
                PushStates.back(state);
            } else if (type === 'replace') {
                Historyjs.replaceState({ randomData: Math.random() }, document.title, state);
            } else {
                Scrolling_1.Scrolling.resetScrollCache(state);
                Historyjs.pushState({ randomData: Math.random() }, document.title, state);
            }
        };
        _this.onHashClick = function (e) {
            Scrolling_1.Scrolling.scrollToElement($(e.currentTarget.hash));
        };
        _this.onState = function () {
            _this.setActiveLinks();
            if (!PushStates.noChange) {
                _this.trigger(PushStatesEvents.CHANGE);
            }
        };
        if (Historyjs) {
            _this.bindLinks();
            Historyjs.Adapter.bind(window, 'statechange', _this.onState);
        }
        PushStates.instance = _this;
        _this.setActiveLinks();
        return _this;
    }

    _createClass(PushStates, [{
        key: "load",
        value: function load() {
            var _this2 = this;

            if (this.request) {
                this.request.abort();
            }
            var path = window.location.pathname;
            var search = window.location.search || '';
            var url = path + search;
            window.clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                if (_this2.request) {
                    window.location.reload();
                }
            }, PushStates.TIME_LIMIT);
            return new Promise(function (resolve, reject) {
                _this2.request = new XMLHttpRequest();
                _this2.request.open('GET', url);
                _this2.request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                _this2.request.onload = function () {
                    if (_this2.request.status === 200) {
                        _this2.loadedData = _this2.request.responseText;
                        _this2.trigger(PushStatesEvents.PROGRESS, 1);
                        resolve();
                    } else {
                        reject(Error(_this2.request.statusText));
                        if (_this2.request.statusText !== 'abort') {
                            window.location.reload();
                        }
                    }
                    _this2.request = null;
                    window.clearTimeout(_this2.timeout);
                };
                _this2.request.onerror = function () {
                    reject(Error('Network Error'));
                    window.clearTimeout(_this2.timeout);
                    _this2.request = null;
                };
                _this2.request.onprogress = function (e) {
                    if (e.lengthComputable) {
                        _this2.trigger(PushStatesEvents.PROGRESS, e.loaded / e.total);
                    }
                };
                _this2.request.send();
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var data = this.loadedData.trim();
            var containers = $('.js-replace[id], #content').toArray();
            var renderedCount = 0;
            if (containers.length > 0) {
                containers.forEach(function (container, index) {
                    renderedCount += _this3.renderElement(container, data, index === 0 && containers.length === 1) ? 1 : 0;
                });
            }
            if (renderedCount === 0 && containers.length > 0) {
                this.renderElement($('#content')[0], data, true);
            }
            this.bindLinks();
            this.setActiveLinks();
        }
    }, {
        key: "renderElement",
        value: function renderElement(el, data, forcePlain) {
            var code = null;
            var container = '#' + el.id;
            if (!!forcePlain && data.indexOf('<article') === 0 && el.id === 'content') {
                code = data;
            } else {
                var $loadedContent = $($(data).find(container)[0] || $(data).filter(container)[0]);
                code = $loadedContent.html();
            }
            if (!code) {
                console.info("Couldn't rerender #" + el.id + " element");
                return false;
            }
            $(container).hide().empty().html(code || data).show();
            return true;
        }
    }, {
        key: "bindLink",
        value: function bindLink(target) {
            $(target).off('click').on('click.history', this.onClick);
        }
    }, {
        key: "bindLinks",
        value: function bindLinks(target) {
            target = target || 'body';
            $(target).find('a').not('[data-history="false"]').not('[data-api]').not('[download]').not('[wcag]').not('[data-modal]').not('[href*="#"]').not('[href$=".jpg"]').not('[target="_blank"]').not('[href^="mailto:"]').not('[href^="tel:"]').not('[data-poczta]').not('[data-login]').not('[data-lang]').off('.history').on('click.history', this.onClick);
            $(target).find('a[href^="https"]').not('[href^="https://' + window.location.host + '"]').off('.history');
            $(target).find('a[href*="#"]').not('[href="#"]').not('[data-wcag-skiplink]').off('.history').on('click.history', this.onHashClick);
        }
    }, {
        key: "setActiveLinks",
        value: function setActiveLinks() {
            $('a[href]').removeClass('is-active');
            $('a[href="' + window.location.pathname + '"]').addClass('is-active');
            $('a[href="' + window.location.pathname.substring(1) + '"]').addClass('is-active');
        }
    }], [{
        key: "setTitle",
        value: function setTitle(title) {
            document.title = title || $('#content > [data-title]').data('title');
        }
    }, {
        key: "goTo",
        value: function goTo(location, replace) {
            var pathname = location.replace(window.location.protocol + window.location.host, ''),
                isDifferent = pathname !== window.location.pathname;
            if (Modernizr.history) {
                if (!!replace) {
                    Historyjs.replaceState({ randomData: Math.random() }, document.title, pathname);
                } else {
                    Historyjs.pushState({ randomData: Math.random() }, document.title, pathname);
                }
            } else {
                window.location.replace(location);
            }
            return isDifferent;
        }
    }, {
        key: "changePath",
        value: function changePath(location, replace, title) {
            PushStates.noChange = true;
            var changed = PushStates.goTo(location, replace || true);
            PushStates.noChange = false;
            if (!!changed) {
                PushStates.setTitle(title || document.title);
            }
        }
    }, {
        key: "bind",
        value: function bind(target, elementItself) {
            if (!elementItself) {
                PushStates.instance.bindLinks(target);
            } else {
                PushStates.instance.bindLink(target);
            }
        }
    }, {
        key: "back",
        value: function back(url) {
            if (history.length > 2) {
                Historyjs.back();
            } else if (url) {
                Historyjs.replaceState({ randomData: Math.random() }, document.title, url);
            } else {
                Historyjs.replaceState({ randomData: Math.random() }, document.title, '/');
            }
        }
    }, {
        key: "reload",
        value: function reload() {
            PushStates.instance.trigger(PushStatesEvents.CHANGE);
        }
    }]);

    return PushStates;
}(Handler_1.Handler);

exports.PushStates = PushStates;
PushStates.TIME_LIMIT = 5000;
PushStates.noChange = false;

},{"./Handler":6,"./Scrolling":12}],12:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var PushStates_1 = require("./PushStates");
var Browser_1 = require("./Browser");
var Breakpoint_1 = require("./Breakpoint");
var Site_1 = require("./Site");
var $ = require("jquery");

var Scrolling = function () {
    function Scrolling() {
        var _this = this;

        _classCallCheck(this, Scrolling);

        this.callbacks = {
            parallax: function parallax(data, state, fast, scrollTop, windowHeight, headerHeight) {
                gsap.set(data.$el, { opacity: 1 });
                if (Breakpoint_1.breakpoint.desktop) {
                    var y = Math.max(-1, Math.min(1, (data.top - scrollTop - windowHeight * 0.5 + data.height * 0.5) / windowHeight * 2));
                    gsap.set(data.$el.children(), { y: y * 200 });
                }
            },
            parallaxDecor: function parallaxDecor(data, state, fast, scrollTop, windowHeight, headerHeight) {
                gsap.set(data.$el, { opacity: 1 });
                if (Breakpoint_1.breakpoint.desktop) {
                    var y = Math.max(-1, Math.min(1, (data.top - scrollTop - windowHeight * 0.5 + data.height * 0.5) / windowHeight * 2));
                    gsap.set(data.$el, { y: y * -300 });
                }
            },
            book: function book(data, state, fast, scrollTop, windowHeight, headerHeight) {
                gsap.set(data.$el, { opacity: 1 });
                if (Breakpoint_1.breakpoint.desktop) {
                    var y = Math.abs(data.top - scrollTop);
                    var img = data.$el.find('.js-book-img');
                    var text = data.$el.find('.js-book-text');
                    if (data.top < scrollTop && data.top + text.outerHeight() - img.outerHeight() > scrollTop) {
                        gsap.set(img, { y: y });
                    }
                }
            },
            relativeParallax: function relativeParallax(data, state, fast, scrollTop, windowHeight, headerHeight) {
                gsap.set(data.$el, { opacity: 1 });
                if (!!_this.settings.disableTouchDevices && !!Modernizr.touchevents || Browser_1.browser.ie) {
                    return;
                }
                if (Breakpoint_1.breakpoint.desktop) {
                    var availableSpace = data.childHeight - data.height;
                    var maxShift = Math.min(availableSpace, data.height + headerHeight);
                    var percent = (scrollTop - data.top + windowHeight) / (windowHeight + data.height);
                    var y = Math.round((1 - percent) * maxShift);
                    y = y < 0 ? 0 : y;
                    y = y > maxShift ? maxShift : y;
                    gsap.set(data.$child, {
                        y: -y
                    });
                }
            },
            scrollFixed: function scrollFixed(data, state, fast, scrollTop, windowHeight, headerHeight) {
                gsap.set(data.$el, { opacity: 1 });
                if (Breakpoint_1.breakpoint.desktop) {
                    var top = Scrolling.customScroll ? Scrolling.customScroll.scrollTop + data.$el.offset().top : data.$el.offset().top;
                    var start = top;
                    var end = data.$el.height();
                    if (scrollTop == 0) {
                        gsap.to(data.$el, 0.1, { y: 0 });
                    } else if (start < scrollTop) {
                        var y = scrollTop - top;
                        gsap.to(data.$el, 0.1, { y: y });
                    } else {
                        gsap.set(data.$el, { clearProps: "transform" });
                    }
                } else {
                    gsap.set(data.$el, { clearProps: "transform" });
                }
            },
            scrollButtonRegisterFixed: function scrollButtonRegisterFixed(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (Breakpoint_1.breakpoint.desktop) {
                    var start = 0;
                    var end = $('#headline-registration-form').offset().top - 400;
                    if (scrollTop < start || scrollTop > end) {
                        gsap.to(data.$el, 0.25, { opacity: 0 });
                    } else if (scrollTop >= start) {
                        gsap.to(data.$el, 0.25, { opacity: 1 });
                    }
                }
            },
            scrollImage: function scrollImage(data, state, fast, scrollTop, windowHeight, headerHeight) {
                gsap.set(data.$el, { opacity: 1 });
                if (Breakpoint_1.breakpoint.desktop) {
                    var paddingTop = 100;
                    var imgH = data.$el.find('img').height();
                    var elText = $('[data-to-scroll]');
                    var top = Scrolling.customScroll ? Scrolling.customScroll.scrollTop + elText.offset().top : elText.offset().top;
                    var start = top - paddingTop;
                    var end = start + elText.height() - imgH;
                    if (Scrolling.customScroll) {
                        if (end < scrollTop) {
                            var y = end - top + paddingTop;
                            gsap.set(data.$el, { y: y });
                        } else if (start < scrollTop) {
                            var _y = scrollTop - top + paddingTop;
                            gsap.set(data.$el, { y: _y });
                        } else {
                            gsap.set(data.$el, { clearProps: "transform" });
                        }
                    } else {
                        if (end < scrollTop) {
                            data.$el.css('position', 'fixed');
                            data.$el.css('top', paddingTop + 'px');
                        } else if (start < scrollTop) {
                            data.$el.css('position', 'fixed');
                            data.$el.css('top', paddingTop + 'px');
                        } else {
                            gsap.set(data.$el, { clearProps: "transform" });
                            data.$el.css('position', 'absolute');
                        }
                    }
                } else {
                    gsap.set(data.$el, { clearProps: "transform" });
                    data.$el.css('position', 'relative');
                    data.$el.css('top', '');
                }
            },
            infinite: function infinite(data, state) {
                if (state === 0 && data.$el.is('[data-component="More"]')) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.data('More').load();
                }
            },
            slide: function slide(data, state, fast) {
                if (!!_this.settings.disableTouchDevices && !!Modernizr.touchevents || Browser_1.browser.ie) {
                    return;
                }
                if (!data.shown || state !== 0 && data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    var duration = state !== 0 ? 0 : 0.5;
                    var delay = state === 0 ? data.delay : 0;
                    data.shown = state === 0;
                    gsap.killTweensOf(data.$el, { y: true });
                    gsap.to(data.$el, {
                        duration: duration,
                        y: state * 80,
                        ease: 'sine.out',
                        delay: delay,
                        clearProps: state === 0 ? 'transform' : ''
                    });
                }
            },
            fade: function fade(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    var delay = data.delay ? data.delay : 0;
                    gsap.killTweensOf(data.$el, { opacity: true });
                    gsap.fromTo(data.$el, { opacity: 0 }, { duration: Scrolling.time, opacity: 1, ease: 'sineIn', delay: delay });
                }
            },
            fadeUp: function fadeUp(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    var delay = data.delay ? data.delay : 0;
                    gsap.killTweensOf(data.$el, { opacity: true });
                    gsap.fromTo(data.$el, { opacity: 0, y: 60 }, { duration: Scrolling.time, opacity: 1, y: 0, ease: 'sineIn', delay: delay });
                }
            },
            fadeLeft: function fadeLeft(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    var delay = data.delay ? data.delay : 0;
                    gsap.killTweensOf(data.$el, { opacity: true });
                    gsap.fromTo(data.$el, { opacity: 0, x: 60 }, { duration: Scrolling.time, opacity: 1, x: 0, ease: 'sineIn', delay: delay });
                }
            },
            fadeRight: function fadeRight(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    var delay = data.delay ? data.delay : 0;
                    gsap.killTweensOf(data.$el, { opacity: true });
                    gsap.fromTo(data.$el, { opacity: 0, x: -60 }, { duration: Scrolling.time, opacity: 1, x: 0, ease: 'sineIn', delay: delay });
                }
            },
            listAsymmetric: function listAsymmetric(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    var delay = state === 0 ? data.delay : 0;
                    data.$el.addClass('shown');
                    data.shown = true;
                    gsap.set(data.$el, { opacity: 1 });
                    var h2 = data.$el.find('h2');
                    var p = data.$el.find('p');
                    var line = data.$el.find('.list-asymmetric__line span');
                    var logo = data.$el.find('.list-asymmetric__logo');
                    gsap.timeline().fromTo(line, { height: '0%' }, { duration: 1.5, height: '100%', ease: 'sineIn', delay: Breakpoint_1.breakpoint.desktop ? delay + 0.5 : delay }).fromTo(logo, { opacity: 0, y: 60 }, { duration: 1, opacity: 1, y: 0, ease: 'sineIn' }, '-=1.5').fromTo(h2, { opacity: 0, y: 60 }, { duration: 1, opacity: 1, y: 0, ease: 'sineIn' }, '-=1.5').fromTo(p, { opacity: 0, y: 60 }, { duration: 1, opacity: 1, y: 0, ease: 'sineIn' }, '-=1');
                }
            },
            headlineText: function headlineText(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    var delay = data.delay ? data.delay : 1;
                    data.shown = true;
                    var h1 = data.$el.find('h1');
                    var p = data.$el.find('p');
                    if (Breakpoint_1.breakpoint.desktop) {
                        gsap.timeline().fromTo(h1, { opacity: 0, y: 40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut' }, '').fromTo(p, { opacity: 0, y: 40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut' }, '-=0.75');
                    }
                }
            },
            headlineTextBonus: function headlineTextBonus(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    var delay = data.delay ? data.delay : 1;
                    data.shown = true;
                    var ht = data.$el.find('.headline__text');
                    var hb = data.$el.find('.headline-big ');
                    var p = data.$el.find('p');
                    if (Breakpoint_1.breakpoint.desktop) {
                        gsap.timeline().fromTo(ht, { opacity: 0, y: 40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut' }, '').fromTo(hb, { opacity: 0, y: 40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut' }, '-=0.75').fromTo(p, { opacity: 0, y: 40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut' }, '-=0.75');
                    }
                }
            },
            headlineImage: function headlineImage(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    var delay = data.delay ? data.delay : 0.5;
                    var texts = data.$el.find('.heading__texts');
                    var curtain = data.$el.find('.heading__curtain');
                    data.shown = true;
                    if (!Breakpoint_1.breakpoint.desktop) {
                        gsap.timeline().to(curtain, { y: '-100%', duration: 1, ease: 'sineOut', delay: delay }).fromTo(texts, { opacity: 0, y: 40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut' }, '-=0.5');
                    } else {
                        gsap.timeline().fromTo(texts, { opacity: 0, y: 40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut', delay: delay }).to(curtain, { x: '100%', duration: 1, ease: 'sineOut' }, '-=0.5');
                    }
                }
            },
            headline: function headline(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    var delay = data.delay ? data.delay : 0.5;
                    var splitText = new SplitText(data.$el, { type: "chars, words, lines" });
                    gsap.timeline().from(splitText.chars, 1, { opacity: 0, x: -10, y: 10, transformOrigin: '0% 100%', ease: 'power3', stagger: 0.05, delay: delay }, '+=0.0');
                }
            },
            firstElements: function firstElements(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    var delay = 0;
                    for (var i = 0; i < data.$el.parent().children().length; i++) {
                        if (data.$el.index() < 20) {
                            delay = data.$el.index() * 0.15;
                        }
                    }
                    data.shown = true;
                    gsap.killTweensOf(data.$el, { opacity: true });
                    gsap.fromTo(data.$el, { opacity: 0, y: 60 }, { duration: Scrolling.time, opacity: 1, y: 0, ease: 'sineIn', delay: delay });
                }
            },
            partsPerson: function partsPerson(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    var delay = data.delay ? data.delay : 1;
                    var delayPart = 0;
                    for (var i = 0; i < data.$el.parent().children().length; i++) {
                        if (data.$el.index() < 12) {
                            delayPart = data.$el.index() * 0.15;
                        }
                    }
                    data.shown = true;
                    gsap.killTweensOf(data.$el, { opacity: true });
                    gsap.fromTo(data.$el, { opacity: 0, y: 60 }, { duration: Scrolling.time, opacity: 1, y: 0, ease: 'sineIn', delay: delay + delayPart });
                }
            },
            part: function part(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    var delay = data.delay ? data.delay : 0.5;
                    for (var i = 0; i < data.$el.children().length; i++) {
                        if (i < 12) {
                            var part = data.$el.children().eq(i);
                            var delayPart = i * 0.15;
                            gsap.killTweensOf(part, { opacity: true });
                            gsap.fromTo(part, { opacity: 0, y: 60 }, { duration: Scrolling.time, opacity: 1, y: 0, ease: 'sineIn', delay: delay + delayPart });
                        }
                    }
                }
            },
            partProject: function partProject(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    gsap.set(data.$el.children().find('.part__content'), { opacity: 0, y: 30 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    var delay = data.delay ? data.delay : 0.5;
                    for (var i = 0; i < data.$el.children().length; i++) {
                        if (i < 12) {
                            var part = data.$el.children().eq(i);
                            var delayPart = i * 0.15;
                            gsap.to(part.find('.part__content'), { duration: Scrolling.time, opacity: 1, y: 0, ease: 'sineIn', delay: delay + delayPart });
                        }
                    }
                }
            },
            conference: function conference(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    var delay = 0;
                    data.shown = true;
                    gsap.killTweensOf(data.$el, { opacity: true });
                    var $day = data.$el.find('[data-day]');
                    var NewVal = parseInt($day.data('day'));
                    var Cont = { val: NewVal + 50 };
                    TweenLite.to(Cont, 2, {
                        val: NewVal,
                        roundProps: "val",
                        ease: 'sineInOut',
                        onUpdate: function onUpdate() {
                            $day.text(Cont.val);
                        }
                    });
                    var image = data.$el.find('.conference__image');
                    var town = data.$el.find('.conference__image p');
                    var description = data.$el.find('.conference__content p');
                    var button = data.$el.find('.button');
                    gsap.timeline().fromTo(image, { x: 40 }, { duration: 2, opacity: 1, x: 0, ease: 'sineOut', delay: delay }).fromTo(town, { opacity: 0, y: -40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut' }, '-=0.5').fromTo(description, { opacity: 0, y: 40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut' }, '-=0.5').fromTo(button, { opacity: 0, y: 40 }, { duration: 1, opacity: 1, y: 0, ease: 'sineOut' }, '-=0.5');
                }
            },
            slider: function slider(data, state, fast) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    var item = data.$el.find('.js-slider-item');
                    gsap.timeline().fromTo(item, { opacity: 0, x: 60 }, { duration: Scrolling.time, opacity: 1, x: 0, ease: 'sineIn', stagger: 0.25, delay: 0.5 });
                }
            },
            quoteProject: function quoteProject(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    data.$el = data.$el.closest('section');
                    var delay = data.delay ? data.delay : 1;
                    var $quote = data.$el.find('.js-quote-words');
                    var $quoteSubtitle = data.$el.find('.js-quote-subtitle');
                    var $quoteText = data.$el.find('.js-quote-text');
                    var $quoteButton = data.$el.find('.js-quote-button');
                    gsap.set([$quote, data.$el, $quoteSubtitle, $quoteText], { opacity: 1 });
                    var child = $quote.children();
                    var splitQuote = new SplitText($quote, { type: 'chars,words,lines' });
                    gsap.timeline({
                        autoRemoveChildren: true
                    }).set($quote, { opacity: 1 }).fromTo($quoteSubtitle, Scrolling.time, { opacity: 0, y: -60 }, { opacity: 1, y: 0, ease: 'sineIn', delay: delay }).from(splitQuote.chars, 0.5, { opacity: 0, y: 15, transformOrigin: '0% 100%', ease: 'power3', stagger: 0.015, onComplete: function onComplete() {
                            splitQuote.revert();
                        } }, 0.1).fromTo($quoteText, Scrolling.time, { opacity: 0, y: 60 }, { opacity: 1, y: 0, ease: 'sineIn' }, '-=' + 0.6).fromTo($quoteButton, Scrolling.time, { opacity: 0, y: 60 }, { opacity: 1, y: 0, ease: 'sineIn' }, '-=' + 0.6);
                }
            },
            quote: function quote(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (state === 0 && !data.shown || state === -0.5 && !data.shown) {
                    gsap.set(data.$el, { opacity: 1 });
                    data.$el.addClass('shown');
                    data.shown = true;
                    var $quote = data.$el.find('.js-quote-words');
                    var $quoteIcon = data.$el.find('.js-quote-icon');
                    var $quotePhoto = data.$el.find('.js-quote-photo');
                    var $quoteProfession = data.$el.find('.js-quote-profession');
                    var $quoteAuthor = data.$el.find('.js-quote-author');
                    var $quoteTitle = data.$el.find('.js-quote-title');
                    gsap.set([$quote, data.$el, $quoteIcon, $quotePhoto, $quoteAuthor, $quoteTitle, $quoteProfession], { opacity: 1 });
                    var child = $quote.children();
                    var splitQuote = new SplitText($quote, { type: 'chars,words,lines' });
                    gsap.timeline({
                        autoRemoveChildren: true
                    }).set($quote, { opacity: 1 }).fromTo($quotePhoto, Scrolling.time, { opacity: 0 }, { opacity: 1, ease: 'sineIn', delay: 0.5 }).fromTo($quoteIcon, Scrolling.time, { opacity: 0, y: -60 }, { opacity: 1, y: 0, ease: 'sineIn' }, '-=' + 0.6).fromTo(child, 0.5, { opacity: 0 }, { opacity: 1, ease: 'power3' }, '-=' + 0.6).from(splitQuote.chars, 0.5, { opacity: 0, y: 15, transformOrigin: '0% 100%', ease: 'power3', stagger: 0.01 }, 0.1).fromTo($quoteProfession, Scrolling.time, { opacity: 0 }, { opacity: 1, ease: 'sineIn' }, '-=' + 0.6).fromTo($quoteAuthor, Scrolling.time, { opacity: 0 }, { opacity: 1, ease: 'sineIn' }, '-=' + 0.6).fromTo($quoteTitle, Scrolling.time, { opacity: 0 }, { opacity: 1, ease: 'sineIn' }, '-=' + 0.6);
                }
            },
            header: function header(data, state, fast, scrollTop, windowHeight, headerHeight) {
                gsap.set(data.$el, { opacity: 1 });
                if (!Site_1.$body.hasClass('is-menu-open') && (scrollTop >= 25 && !data.$el.hasClass('is-show') || scrollTop < 25 && data.$el.hasClass('is-show'))) {
                    var hc = data.$el.find('.header__bg');
                    var timeHc = 1;
                    if (scrollTop >= 25 && !data.$el.hasClass('is-show')) {
                        data.$el.addClass('is-show');
                        gsap.timeline({ autoRemoveChildren: true }).fromTo(hc, timeHc, { opacity: 0 }, { opacity: 1, ease: 'sineInOut' });
                    } else if (scrollTop < 25 && data.$el.hasClass('is-show')) {
                        data.$el.removeClass('is-show');
                        gsap.timeline({ autoRemoveChildren: true }).fromTo(hc, timeHc, { opacity: 1 }, { opacity: 0, ease: 'sineInOut' });
                    }
                }
            },
            logo: function logo(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (!Site_1.$body.hasClass('is-menu-open') && (scrollTop >= 25 && !data.$el.hasClass('is-show') || scrollTop < 25 && data.$el.hasClass('is-show'))) {
                    gsap.set(data.$el, { opacity: 1 });
                    var logoText = data.$el.find('#logotyp_logo');
                    var timeLogo = 0.25;
                    if (scrollTop >= 25 && !data.$el.hasClass('is-show')) {
                        data.$el.addClass('is-show');
                        gsap.timeline({ autoRemoveChildren: true }).fromTo(logoText, timeLogo, { opacity: 1, x: 0, y: 0 }, { opacity: 0, x: -5, y: 5, transformOrigin: '0% 100%', ease: 'power3', stagger: -0.025 });
                    } else if (scrollTop < 25 && data.$el.hasClass('is-show')) {
                        data.$el.removeClass('is-show');
                        gsap.timeline({ autoRemoveChildren: true }).fromTo(logoText, timeLogo, { opacity: 0, x: -5, y: 5 }, { opacity: 1, x: 0, y: 0, transformOrigin: '0% 100%', ease: 'power3', stagger: 0.025 });
                    }
                }
            },
            scrollHome: function scrollHome(data, state, fast, scrollTop, windowHeight, headerHeight) {
                if (scrollTop >= 50 && !data.$el.hasClass('is-show') || scrollTop < 50 && data.$el.hasClass('is-show')) {
                    var timeLogo = 0.25;
                    if (scrollTop >= 50 && !data.$el.hasClass('is-show')) {
                        data.$el.addClass('is-show');
                        gsap.timeline({ autoRemoveChildren: true }).fromTo(data.$el, timeLogo, { opacity: 1, y: 0 }, { opacity: 0, y: 0 });
                    } else if (scrollTop < 50 && data.$el.hasClass('is-show')) {
                        data.$el.removeClass('is-show');
                        gsap.timeline({ autoRemoveChildren: true }).fromTo(data.$el, timeLogo, { opacity: 0, y: 0 }, { opacity: 1, y: 0 });
                    }
                }
            }
        };
        this.scrollCache = {};
        this.resize = function (wdt, hgt, breakpoint) {
            Scrolling.windowHeight = hgt;
            Scrolling.headerHeight = 0;
            _this.saveCache();
        };
        this.saveCache = function () {
            if (!_this.elements) {
                return;
            }
            var cache = [];
            for (var i = 0; i < _this.elements.length; ++i) {
                var $el = _this.elements.eq(i);
                var role = $el.data('scroll');
                var top = Scrolling.customScroll ? Scrolling.customScroll.scrollTop + $el.offset().top : $el.offset().top;
                var height = $el.outerHeight();
                var delay = $el.data('delay') || 0;
                var title = $el.data('title') || false;
                var path = $el.data('path') || false;
                var data = {
                    $el: $el,
                    role: role,
                    top: top,
                    height: height,
                    bottom: top + height,
                    path: path,
                    title: title,
                    $child: $el.children().first(),
                    childHeight: $el.children().first().height(),
                    children: {},
                    delay: delay,
                    shown: $el.hasClass('shown') || false
                };
                cache.push(data);
                $el.data('cache', i);
            }
            _this.cache = cache;
            _this.onScroll();
        };
        this.onScroll = function () {
            var fast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (Scrolling.disabled && !Scrolling.customScroll) {
                return;
            }
            var sT = window.scrollY ? window.scrollY : Scrolling.customScroll ? Scrolling.customScroll.scrollTop + Site_1.$window.scrollTop() : Site_1.$window.scrollTop();
            var screenCenter = sT + Scrolling.windowHeight * 0.33;
            var headerHeight = Scrolling.headerHeight;
            var windowHeight = Scrolling.windowHeight;
            var windowBottom = windowHeight + sT;
            var inView = [];
            if (!Scrolling.disabled) {
                Site_1.$body.toggleClass('is-scrolled', sT > 0);
                Site_1.$body.toggleClass('is-scrolling-down', sT > _this.lastY && sT > 0);
                Site_1.$body.toggleClass('scrolled-window-height', sT > windowHeight);
                Site_1.$body.toggleClass('scrolled-header-height', sT > Scrolling.headerHeight);
            }
            Scrolling.isScrollingDown = sT > _this.lastY && sT > 0;
            _this.lastY = sT;
            if (Breakpoint_1.breakpoint.desktop) {
                if (sT > 200 && !Scrolling.isScrollingDown) {
                    gsap.to($('.header--fixed'), { duration: 0.5, y: '0%', ease: 'sineOut' });
                } else {
                    gsap.to($('.header--fixed'), { duration: 0.5, y: '-100%', ease: 'sineOut' });
                }
            }
            if (!_this.cache || !!Scrolling.disabled) {
                return;
            }
            _this.scrollCache[window.location.pathname] = sT;
            for (var i = 0; i < _this.cache.length; i++) {
                var item = _this.cache[i];
                if (item.top < screenCenter && item.top + item.height > screenCenter) {
                    item.$el.addClass('is-in-center');
                    if (item.path && !Scrolling.animating) {
                        _this.changingPath = true;
                        PushStates_1.PushStates.changePath(item.path, true, item.title);
                        _this.changingPath = false;
                    }
                } else {
                    item.$el.removeClass('is-in-center');
                }
                item.$el.toggleClass('is-past-fold', item.top < sT + headerHeight);
                item.$el.toggleClass('is-in-view', item.top < sT + windowHeight && item.top + item.height >= sT);
                item.$el.toggleClass('is-aligned', item.top === sT);
                item.$el.toggleClass('is-past-bottom', item.top + item.height <= windowHeight + sT);
                if (item.role in _this.callbacks) {
                    if (item.top < windowBottom && item.bottom >= sT && !item.shown) {
                        _this.callbacks[item.role](item, 0, fast, sT, windowHeight, headerHeight);
                    } else if (item.top > windowBottom && (!!item.shown || !item.initialized)) {
                        _this.callbacks[item.role](item, 1, fast, sT, windowHeight, headerHeight);
                    } else if (item.bottom < sT && (!!item.shown || !item.initialized)) {
                        _this.callbacks[item.role](item, -0.5, fast, sT, windowHeight, headerHeight);
                    }
                }
            }
        };
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        Scrolling.isCustomScroll = $('body').data('scrollbar') && !Browser_1.browser.ie && Breakpoint_1.breakpoint.desktop;
        if (Scrolling.isCustomScroll && Breakpoint_1.breakpoint.desktop) {
            var options = {
                damping: 0.1,
                thumbMinSize: 20,
                renderByPixels: true,
                alwaysShowTracks: true,
                continuousScrolling: true
            };
            $('html').addClass('has-smooth-scroll');
            Scrolling.customScroll = Scrollbar.init($('#wrapper')[0], options);
            Scrolling.customScroll.addListener(function (status) {
                _this.onScroll();
            });
            this.resize();
        } else {
            Site_1.$window.off('.scrolling').on('scroll.scrolling', function () {
                return _this.onScroll();
            });
        }
        this.settings = {
            disableTouchDevices: true
        };
        Scrolling.instance = this;
    }

    _createClass(Scrolling, [{
        key: "onState",
        value: function onState() {
            if (!!this.changingPath) {
                return false;
            }
            return Scrolling.scrollToPath();
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this.cache = [];
            Site_1.$window.off('.scrolling');
        }
    }, {
        key: "load",
        value: function load() {
            var _this2 = this;

            this.elements = $('[data-scroll]');
            this.saveCache();
            Site_1.$window.off('.scrolling').on('scroll.scrolling', function () {
                return _this2.onScroll();
            });
        }
    }, {
        key: "stop",
        value: function stop() {
            Scrolling.disable();
        }
    }, {
        key: "start",
        value: function start() {
            Scrolling.enable();
            Scrolling.instance.onScroll(true);
        }
    }, {
        key: "scrollToCached",
        value: function scrollToCached() {
            Scrolling.scroll({
                y: this.scrollCache[window.location.pathname] || 0,
                speed: 0,
                animate: false
            });
        }
    }], [{
        key: "disable",
        value: function disable() {
            this.disabled = true;
        }
    }, {
        key: "enable",
        value: function enable() {
            this.disabled = false;
        }
    }, {
        key: "isVisible",
        value: function isVisible(element) {
            if (Scrolling.customScroll) {
                return Scrolling.customScroll.isVisible(element);
            } else {
                var windowHeight = window.innerHeight;
                var top = element.getBoundingClientRect().top;
                var bottom = top + element.offsetHeight;
                return top < windowHeight && bottom > 0;
            }
        }
    }, {
        key: "scrollToPath",
        value: function scrollToPath(fast) {
            var $target = $('[data-path="' + window.location.pathname + '"]');
            if ($target[0]) {
                Scrolling.scrollToElement($target, fast);
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: "scrollToElement",
        value: function scrollToElement($el, fast, offset, scrollToView, elementHeight) {
            if (!$el[0]) {
                return;
            }
            Scrolling.animating = true;
            var customScroll = Scrolling.customScroll ? Scrolling.customScroll.scrollTop : 0;
            var sT = window.scrollY ? window.scrollY : Site_1.$window.scrollTop() || customScroll;
            var itemTop = $el.offset().top;
            var itemHeight = elementHeight || $el.outerHeight();
            var itemBottom = itemTop + itemHeight;
            var y = itemTop - Scrolling.headerHeight + (offset || 0);
            if (Scrolling.isCustomScroll) {
                y = sT + itemTop + (offset || 0);
                Scrolling.customScroll.scrollTo(0, y, 1000);
            } else {
                return this.scroll({
                    y: y,
                    speed: !!fast ? 0 : 1,
                    animate: !fast
                }).then(function () {
                    Scrolling.animating = false;
                });
            }
        }
    }, {
        key: "scrollTop",
        value: function scrollTop(quick) {
            return Scrolling.scroll({ y: 0, speed: !quick ? 0.5 : 0, ease: 'sine.out' });
        }
    }, {
        key: "scroll",
        value: function scroll(params) {
            return new Promise(function (resolve, reject) {
                params = $.extend({
                    x: 0,
                    y: 0,
                    speed: 1.2,
                    ease: 'power1.inOut',
                    animate: true,
                    relativeSpeed: false
                }, params);
                if (Scrolling.customScroll) {
                    Scrolling.customScroll.scrollTo(params.x, params.y, params.speed * 1000, { callback: resolve });
                    return;
                }
                Scrolling.obj = {
                    x: Math.max(document.body.scrollLeft, window.pageXOffset),
                    y: Math.max(document.body.scrollTop, window.pageYOffset)
                };
                var distance = Math.max(Math.abs(params.y - Scrolling.obj.y));
                if (!!params.animate && params.speed > 0 && distance > 1) {
                    var speedFactor = Math.min(distance / Site_1.$window.height(), 1.5);
                    var speed = !params.relativeSpeed ? params.speed : params.speed * speedFactor;
                    gsap.killTweensOf(Scrolling.obj);
                    gsap.to(Scrolling.obj, {
                        duration: speed,
                        onUpdate: function onUpdate() {
                            window.scrollTo(Scrolling.obj.x, Scrolling.obj.y);
                        },
                        x: params.x,
                        y: params.y,
                        ease: params.ease,
                        onComplete: function onComplete() {
                            resolve();
                        }
                    });
                } else {
                    window.scrollTo(params.x, params.y);
                    resolve();
                }
            });
        }
    }, {
        key: "resetScrollCache",
        value: function resetScrollCache(pathname) {
            Scrolling.instance.scrollCache[pathname] = 0;
        }
    }]);

    return Scrolling;
}();

exports.Scrolling = Scrolling;
Scrolling.disabled = false;
Scrolling.animating = false;
Scrolling.time = 1;
Scrolling.sTLast = -1;

},{"./Breakpoint":2,"./Browser":3,"./PushStates":11,"./Site":13,"jquery":1}],13:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var PushStates_1 = require("./PushStates");
var Breakpoint_1 = require("./Breakpoint");
var HeaderDesktop_1 = require("./HeaderDesktop");
var HeaderMobile_1 = require("./HeaderMobile");
var Loader_1 = require("./Loader");
var Curtain_1 = require("./Curtain");
var Offscreen_1 = require("./Offscreen");
var Scrolling_1 = require("./Scrolling");
var Visibility_1 = require("./widgets/Visibility");
var Analytics_1 = require("./widgets/Analytics");
var All_1 = require("./widgets/All");
var Page_1 = require("./pages/Page");
var Browser_1 = require("./Browser");
var Utils = require("./Utils");

var Site = function () {
    function Site() {
        var _this = this;

        _classCallCheck(this, Site);

        this.onResize = function () {
            Breakpoint_1.Breakpoint.update();
            Utils.setVwUnit();
            var width = exports.$window.width();
            var height = exports.$window.height();
            var changed = !_this.lastBreakpoint || _this.lastBreakpoint.value !== Breakpoint_1.breakpoint.value;
            _this.lastBreakpoint = Breakpoint_1.breakpoint;
            if (_this.currentPage) {
                _this.currentPage.resize(width, height, Breakpoint_1.breakpoint, changed);
            }
            _this.scrolling.resize(width, height);
            exports.curtain.resize();
            _this.headerDesktop.resize();
            _this.headerMobile.resize();
            All_1.Widgets.resize();
        };
        this.onState = function () {
            _this.headerDesktop.onState();
            _this.headerMobile.onState();
            var scrollingChangedState = _this.scrolling.onState();
            var pageChangedState = _this.currentPage.onState();
            var offscreenChangedState = _this.offscreen.onState();
            if (!scrollingChangedState && !offscreenChangedState && !pageChangedState) {
                Analytics_1.Analytics.sendPageview(window.location.pathname);
                var pushStatesLoadPromise = _this.pushStates.load();
                var animateOutPromise = _this.currentPage.animateOut();
                var curtainPromise = exports.curtain.show();
                _this.scrolling.stop();
                var loadingPromises = [pushStatesLoadPromise, animateOutPromise, curtainPromise];
                Promise.all(loadingPromises).then(_this.render);
            }
        };
        this.onLoadProgress = function (progress) {
            _this.loader.set(0.5 * progress);
        };
        this.onPageProgress = function (progress) {
            _this.loader.set(0.5 + 0.5 * progress);
        };
        this.onPageAppend = function (el) {
            PushStates_1.PushStates.bind(el[0]);
            All_1.Widgets.bind(el[0]);
            _this.scrolling.load();
        };
        this.render = function () {
            if (_this.currentPage) {
                _this.currentPage.off();
                _this.currentPage.destroy();
                _this.currentPage = null;
            }
            _this.scrolling.destroy();
            _this.pushStates.render();
            _this.setCurrentPage().then(_this.onPageLoaded);
            PushStates_1.PushStates.setTitle();
        };
        this.onPageLoaded = function () {
            exports.$body.removeClass('is-not-ready');
            Utils.setVwUnit();
            exports.curtain.hide().then(function () {
                _this.currentPage.animateIn();
            });
            _this.scrolling.scrollToCached();
            Scrolling_1.Scrolling.scrollToPath(true);
            _this.scrolling.load();
            _this.scrolling.start();
            _this.loader.hide();
        };
        Site.instance = this;
        exports.lang = $('html').attr('lang');
        exports.pixelRatio = window.devicePixelRatio || 1;
        exports.debug = window.location.search.indexOf('dev') >= 0;
        exports.easing = CustomEase.create('custom', 'M0,0,C0.5,0,0.3,1,1,1');
        gsap.config({ nullTargetWarn: false });
    }

    _createClass(Site, [{
        key: "init",
        value: function init() {
            var _this2 = this;

            exports.$doc = $(document);
            exports.$window = $(window);
            exports.$body = $('body');
            Breakpoint_1.Breakpoint.update();
            Browser_1.Browser.update();
            this.pushStates = new PushStates_1.PushStates();
            this.pushStates.on(PushStates_1.PushStatesEvents.CHANGE, this.onState);
            this.pushStates.on(PushStates_1.PushStatesEvents.PROGRESS, this.onLoadProgress);
            this.scrolling = new Scrolling_1.Scrolling();
            this.loader = new Loader_1.Loader($('.js-loader'));
            this.loader.show();
            this.loader.set(0.5);
            exports.curtain = new Curtain_1.Curtain($('.js-curtain'));
            this.headerDesktop = new HeaderDesktop_1.HeaderDesktop($('.header--desktop'));
            this.headerMobile = new HeaderMobile_1.HeaderMobile($('.header--mobile'));
            this.offscreen = new Offscreen_1.Offscreen($('.js-offscreen'));
            this.visibility = new Visibility_1.Visibility();
            this.visibility.on(Visibility_1.VisibilityState.HIDDEN, function (state) {
                _this2.currentPage.turnOff();
            }).on(Visibility_1.VisibilityState.VISIBLE, function (state) {
                _this2.currentPage.turnOn();
            });
            Promise.all([this.setCurrentPage()]).then(this.onPageLoaded);
            Analytics_1.Analytics.TRACKING_ID = $('[data-tracking]').data('tracking');
            if (exports.debug) {
                Utils.stats();
            }
            exports.$window.on('resize', this.onResize);
        }
    }, {
        key: "setCurrentPage",
        value: function setCurrentPage() {
            var $pageEl = $('[data-page]'),
                pageName = $pageEl.data('page') || 'Page',
                pageOptions = $pageEl.data('options');
            if (pageName === undefined) {
                if (pageName !== 'undefined') {
                    console.warn('There is no "%s" in Pages!', pageName);
                }
                pageName = 'Page';
            }
            if ($pageEl.length > 1) {} else if ($pageEl.length === 0) {
                $pageEl = $($('#content').find('article')[0] || $('#content').children().first()[0]);
            }
            var page = new Page_1.Page($pageEl, pageOptions);
            this.currentPage = page;
            page.on(Page_1.PageEvents.PROGRESS, this.onPageProgress);
            page.on(Page_1.PageEvents.CHANGE, this.onPageAppend);
            All_1.Widgets.bind();
            this.offscreen.reload();
            this.onResize();
            $('body').removeClass('wcag-tab');
            exports.$body.find('.skip-links li a').first().focus();
            return page.preload();
        }
    }]);

    return Site;
}();

exports.Site = Site;
$(document).ready(function () {
    exports.site = new Site();
    exports.site.init();
});

},{"./Breakpoint":2,"./Browser":3,"./Curtain":5,"./HeaderDesktop":7,"./HeaderMobile":8,"./Loader":9,"./Offscreen":10,"./PushStates":11,"./Scrolling":12,"./Utils":15,"./pages/Page":43,"./widgets/All":44,"./widgets/Analytics":45,"./widgets/Visibility":59}],14:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var TemplateNames = function TemplateNames() {
    _classCallCheck(this, TemplateNames);
};

exports.TemplateNames = TemplateNames;
TemplateNames.LIVESEARCH = 'search-live';
TemplateNames.PLAYER = 'player';
TemplateNames.PLAYLIST = 'playlist';
TemplateNames.PLAYERCC = 'player-captions';
TemplateNames.PROJECT = 'project';
TemplateNames.FORM_RESPONSE = 'form-response';

var Templates = function () {
    function Templates() {
        _classCallCheck(this, Templates);
    }

    _createClass(Templates, null, [{
        key: "get",
        value: function get(name) {
            var $tmpl = $('#tmpl-' + name);
            if (!$tmpl[0]) {
                console.warn('There is no `%s` template!', name);
                return null;
            }
            return Twig.twig({ data: $tmpl.text() });
        }
    }]);

    return Templates;
}();

exports.Templates = Templates;

},{}],15:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: true });
function setVwUnit() {
    var vw = document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--vw', vw + "px");
}
exports.setVwUnit = setVwUnit;
function generateUID() {
    return '' + new Date().getTime() + Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
exports.generateUID = generateUID;
function normalizeURL(url) {
    return '/' + url.replace(/#.*$/, '').replace(/^\/|\/$/g, '').replace(/\?.*$/, '');
}
exports.normalizeURL = normalizeURL;
function getCurrentURL() {
    return normalizeURL(window.location.pathname);
}
exports.getCurrentURL = getCurrentURL;
function downloadFile(url, name) {
    var a = document.createElement('A');
    a.href = url;
    if (name) {
        a.download = name;
    }
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
exports.downloadFile = downloadFile;
function shake($el) {
    gsap.fromTo($el, {
        xPercent: -3
    }, {
        duration: 0.5,
        xPercent: 0,
        clearProps: 'transform',
        ease: 'elastic.out(2, 0.2)'
    });
}
exports.shake = shake;
exports.translations = {
    'invalid-email': {
        'en': 'Invalid email address format',
        'pl': 'Niepoprawny format adresu e-mail'
    },
    'required-field': {
        'en': 'Required field',
        'pl': 'Pole obowiązkowe'
    }
};
exports.keys = {
    enter: 13,
    esc: 27,
    space: 32,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    pageUp: 33,
    pageDown: 34,
    end: 35,
    home: 36,
    minus: 109,
    plus: 107
};
function serialize($el) {
    var object = $el.serializeObject();
    var result = Object.keys(object).map(function (key) {
        var value = object[key];
        var type = typeof value === "undefined" ? "undefined" : _typeof(value);
        return value !== '' ? key.replace('[]', '') + '=' + (type === 'object' ? value.join(',') : value) : null;
    }).filter(function (v) {
        return v !== null;
    });
    return result ? result.join('&') : '';
}
exports.serialize = serialize;
function parseToTime(sec) {
    var totalSec = parseInt('' + sec, 10);
    var hours = parseInt('' + totalSec / 3600, 10) % 24;
    var minutes = parseInt('' + totalSec / 60, 10) % 60;
    var seconds = totalSec % 60;
    var hrsDisplay = (hours < 10 ? '0' + hours : hours) + ':';
    return (hours > 0 ? hrsDisplay : '') + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
}
exports.parseToTime = parseToTime;
function getParams(url) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
}
exports.getParams = getParams;
function updateQueryParam(uri, param, paramVal) {
    var url = uri || window.location.href;
    var newAdditionalURL = '';
    var tempArray = url.split('?');
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = '';
    var rowsTxt = '';
    if (additionalURL) {
        tempArray = additionalURL.split('&');
        for (var i = 0; i < tempArray.length; i++) {
            if (tempArray[i].split('=')[0] !== param) {
                newAdditionalURL += temp + tempArray[i];
                temp = '&';
            }
        }
    }
    rowsTxt = temp + '' + param + '=' + paramVal;
    return baseURL + '?' + newAdditionalURL + rowsTxt;
}
exports.updateQueryParam = updateQueryParam;
function removeQueryParam(url, param) {
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(param) + '=',
            pars = urlparts[1].split(/[&;]/g);
        for (var i = pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }
        url = urlparts[0] + '?' + pars.join('&');
        return url;
    } else {
        return url;
    }
}
exports.removeQueryParam = removeQueryParam;
function stats() {
    var stats = new Stats();
    stats.showPanel(0);
    $(stats.dom).css('pointer-events', 'none');
    document.body.appendChild(stats.dom);
    function animate() {
        stats.begin();
        stats.end();
        requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
    return stats;
}
exports.stats = stats;
function isImageOk(img) {
    if (!img.complete) {
        return false;
    }
    if (typeof img.naturalWidth !== 'undefined' && img.naturalWidth === 0) {
        return false;
    }
    return true;
}
exports.isImageOk = isImageOk;
function setCookie(name, value, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    var cookie = name + '=' + value + ';' + expires + ';path=/';
    document.cookie = cookie;
}
exports.setCookie = setCookie;
function getCookie(name) {
    name = name + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}
exports.getCookie = getCookie;
function setStorageItem(key, value) {
    localStorage.setItem(key, value);
}
exports.setStorageItem = setStorageItem;
function getStorageItem(key) {
    return localStorage.getItem(key);
}
exports.getStorageItem = getStorageItem;
function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {
    if (arguments.length === 2) {
        x = y = 0;
        w = ctx.canvas.width;
        h = ctx.canvas.height;
    }
    offsetX = typeof offsetX === 'number' ? offsetX : 0.5;
    offsetY = typeof offsetY === 'number' ? offsetY : 0.5;
    if (offsetX < 0) {
        offsetX = 0;
    }
    if (offsetY < 0) {
        offsetY = 0;
    }
    if (offsetX > 1) {
        offsetX = 1;
    }
    if (offsetY > 1) {
        offsetY = 1;
    }
    var iw = img.width;
    var ih = img.height;
    var r = Math.min(w / iw, h / ih);
    var nw = iw * r;
    var nh = ih * r;
    var cx = void 0,
        cy = void 0,
        cw = void 0,
        ch = void 0,
        ar = 1;
    if (nw < w) {
        ar = w / nw;
    }
    if (Math.abs(ar - 1) < 1e-14 && nh < h) {
        ar = h / nh;
    }
    nw *= ar;
    nh *= ar;
    cw = iw / (nw / w);
    ch = ih / (nh / h);
    cx = (iw - cw) * offsetX;
    cy = (ih - ch) * offsetY;
    if (cx < 0) {
        cx = 0;
    }
    if (cy < 0) {
        cy = 0;
    }
    if (cw > iw) {
        cw = iw;
    }
    if (ch > ih) {
        ch = ih;
    }
    ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
}
exports.drawImageProp = drawImageProp;

},{}],16:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");

var AddExporter = function (_Component_1$Componen) {
    _inherits(AddExporter, _Component_1$Componen);

    function AddExporter(view) {
        _classCallCheck(this, AddExporter);

        var _this = _possibleConstructorReturn(this, (AddExporter.__proto__ || Object.getPrototypeOf(AddExporter)).call(this, view));

        _this.view = view;
        _this.isWantContactChecked = false;
        _this.jsonCountries = new Array();
        _this.maxH = 400;
        _this.$wantContact = _this.view.find('.wantcontact');
        _this.$inputWantContact = $("input[name='wantcontact']");
        _this.$formCountries = _this.view.find('.form__row--countries');
        _this.$formCountriesContainer = _this.$formCountries.find('.form__container');
        Promise.all([_this.setjsonCountries()]).then(function () {
            _this.setCountries();
            _this.unbind();
            _this.bind();
        });
        return _this;
    }

    _createClass(AddExporter, [{
        key: "setjsonCountries",
        value: function setjsonCountries() {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                $.getJSON(_this2.view.data('json-countries'), function (data) {
                    _this2.jsonCountries = data;
                    resolve();
                });
            });
        }
    }, {
        key: "setCountries",
        value: function setCountries() {
            var _this3 = this;

            this.$formCountriesContainer.html('');
            var svg = '<svg class="svg-check" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><path d="M9,21.035l-9-8.638l5.844,0.009L8.947,15.4l9.444-9.619l5.609,0L9,21.035z"></path></svg>';
            $.each(this.jsonCountries, function (key, value) {
                var name = value.name_pl;
                _this3.$formCountriesContainer.append('<label class="label__radio"><input type="checkbox"  name="location" class="t-wantcontact" data-value="' + name + '" value="' + name + '" data-parsley-maxcheck="3" data-parsley-multiple="location" ><span class="check">' + svg + '</span><span class="paragraph">' + name + '</span></label>');
            });
            setTimeout(function () {
                var h = _this3.$formCountriesContainer.outerHeight(true);
                gsap.set(_this3.$formCountriesContainer, { height: _this3.maxH });
                _this3.$formCountriesContainer.removeClass('scroll');
                if (h > _this3.maxH) {
                    h = _this3.maxH;
                    _this3.$formCountriesContainer.addClass('scroll');
                }
                _this3.$wantContact.hide();
            }, 100);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this4 = this;

            this.$inputWantContact.off('.add-exporter').on('change.add-exporter', function (e) {
                _this4.isWantContactChecked = _this4.$inputWantContact.is(':checked');
                if (_this4.isWantContactChecked) {
                    _this4.$wantContact.show();
                    $(".t-wantcontact").attr("required", "");
                } else {
                    _this4.$wantContact.hide();
                    $(".t-wantcontact").removeAttr('required');
                }
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.$inputWantContact.off('.add-exporter');
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            var _this5 = this;

            return new Promise(function (resolve) {
                gsap.to(_this5.view, 5, {
                    onComplete: function onComplete() {
                        resolve(true);
                    }
                });
            });
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(AddExporter.prototype.__proto__ || Object.getPrototypeOf(AddExporter.prototype), "destroy", this).call(this);
        }
    }]);

    return AddExporter;
}(Component_1.Component);

exports.AddExporter = AddExporter;

},{"./Component":18}],17:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");

var Blob = function (_Component_1$Componen) {
    _inherits(Blob, _Component_1$Componen);

    function Blob(view) {
        _classCallCheck(this, Blob);

        var _this = _possibleConstructorReturn(this, (Blob.__proto__ || Object.getPrototypeOf(Blob)).call(this, view));

        _this.view = view;
        return _this;
    }

    _createClass(Blob, [{
        key: "onState",
        value: function onState() {
            return false;
        }
    }, {
        key: "destroy",
        value: function destroy() {
            clearTimeout(this.timeout);
            _get(Blob.prototype.__proto__ || Object.getPrototypeOf(Blob.prototype), "destroy", this).call(this);
        }
    }]);

    return Blob;
}(Component_1.Component);

exports.Blob = Blob;

},{"./Component":18}],18:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Handler_1 = require("../Handler");

var ComponentEvents = function ComponentEvents() {
    _classCallCheck(this, ComponentEvents);
};

exports.ComponentEvents = ComponentEvents;
ComponentEvents.CHANGE = 'change';

var Component = function (_Handler_1$Handler) {
    _inherits(Component, _Handler_1$Handler);

    function Component(view, options) {
        _classCallCheck(this, Component);

        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));

        _this.view = view;
        _this.options = options;
        _this.resize = function (wdt, hgt, breakpoint, bpChanged) {};
        if (!view[0]) {
            console.warn('component built without view');
        }
        _this.view.data('comp', _this);
        return _this;
    }

    _createClass(Component, [{
        key: "preloadImages",
        value: function preloadImages() {
            return [];
        }
    }, {
        key: "onState",
        value: function onState() {
            return false;
        }
    }, {
        key: "animateIn",
        value: function animateIn(index, delay) {}
    }, {
        key: "animateOut",
        value: function animateOut() {
            return Promise.resolve(null);
        }
    }, {
        key: "turnOff",
        value: function turnOff() {}
    }, {
        key: "turnOn",
        value: function turnOn() {}
    }, {
        key: "destroy",
        value: function destroy() {
            this.view.data('comp', null);
            this.view.off();
            _get(Component.prototype.__proto__ || Object.getPrototypeOf(Component.prototype), "destroy", this).call(this);
        }
    }]);

    return Component;
}(Handler_1.Handler);

exports.Component = Component;

},{"../Handler":6}],19:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Breakpoint_1 = require("../Breakpoint");
var Scrolling_1 = require("../Scrolling");

var EconomicActivity = function (_Component_1$Componen) {
    _inherits(EconomicActivity, _Component_1$Componen);

    function EconomicActivity(view) {
        _classCallCheck(this, EconomicActivity);

        var _this = _possibleConstructorReturn(this, (EconomicActivity.__proto__ || Object.getPrototypeOf(EconomicActivity)).call(this, view));

        _this.view = view;
        _this.isAnimating = false;
        _this.actualId = -1;
        _this.resize = function () {};
        _this.$infoboxSimplelist = _this.view.find('.infobox--simplelist');
        _this.$info = _this.view.find('.economic-activity__info');
        _this.$infoScroll = _this.view.find('.js-info-scroll');
        _this.$infoTitle = _this.view.find('.economic-activity__info__title');
        _this.$infoDescription = _this.view.find('.economic-activity__info__description');
        _this.$map = _this.view.find('.economic-activity__map');
        _this.$infoboxSimplelist.each(function (index, el) {
            var id = $(el).data('id');
            var x = $(el).data('x');
            var y = $(el).data('y');
            _this.$map.append('<div class="economic-activity__area" data-id="' + id + '" style="top: ' + y + '%; left: ' + x + '%;"></div>');
        });
        _this.$areas = _this.view.find('.economic-activity__area');
        _this.bind();
        return _this;
    }

    _createClass(EconomicActivity, [{
        key: "onState",
        value: function onState() {
            return false;
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this.unbind();
            _get(EconomicActivity.prototype.__proto__ || Object.getPrototypeOf(EconomicActivity.prototype), "destroy", this).call(this);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this2 = this;

            this.$areas.off('.economicactivity').on('click.economicactivity', function (e) {
                _this2.area(e);
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.$areas.off('.economicactivity');
        }
    }, {
        key: "area",
        value: function area(e) {
            var _this3 = this;

            var area = $(e.currentTarget);
            var areaId = area.data('id');
            this.$infoboxSimplelist.each(function (index, el) {
                var id = $(el).data('id');
                if (!_this3.isAnimating && areaId == id && _this3.actualId != id) {
                    _this3.isAnimating = true;
                    _this3.actualId = id;
                    _this3.$areas.each(function (index, el) {
                        $(el).removeClass('is-active');
                    });
                    area.addClass('is-active');
                    var title = $(el).find('.infobox__title p').text();
                    var description = $(el).find('.infobox__container p').text();
                    _this3.$infoTitle.html(title);
                    _this3.$infoDescription.html(description);
                    gsap.fromTo(_this3.$info, { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, ease: 'sineIn', delay: 0, onComplete: function onComplete() {
                            _this3.isAnimating = false;
                        } });
                    if (!Breakpoint_1.breakpoint.desktop) {
                        Scrolling_1.Scrolling.scrollToElement(_this3.$infoScroll, false, -100);
                    }
                }
            });
        }
    }]);

    return EconomicActivity;
}(Component_1.Component);

exports.EconomicActivity = EconomicActivity;

},{"../Breakpoint":2,"../Scrolling":12,"./Component":18}],20:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Site_1 = require("../Site");
var Breakpoint_1 = require("../Breakpoint");

var HeadlinePhoto = function (_Component_1$Componen) {
    _inherits(HeadlinePhoto, _Component_1$Componen);

    function HeadlinePhoto(view) {
        _classCallCheck(this, HeadlinePhoto);

        var _this = _possibleConstructorReturn(this, (HeadlinePhoto.__proto__ || Object.getPrototypeOf(HeadlinePhoto)).call(this, view));

        _this.view = view;
        _this.time = 0.5;
        _this.isAnimating = false;
        _this.h = 0;
        _this.resize = function () {
            _this.setSize();
        };
        _this.$container = _this.view.find('.headline-photo__container');
        _this.$buttonImageinfo = _this.view.find('.button--imageinfo');
        _this.$imageinfo = _this.view.find('.headline-photo__imageinfo');
        _this.$imageinfoScroll = _this.view.find('.headline-photo__imageinfo__scroll');
        _this.bind();
        _this.resize();
        setTimeout(function () {
            _this.resize();
        }, 1);
        return _this;
    }

    _createClass(HeadlinePhoto, [{
        key: "onState",
        value: function onState() {
            return false;
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(HeadlinePhoto.prototype.__proto__ || Object.getPrototypeOf(HeadlinePhoto.prototype), "destroy", this).call(this);
            this.unbind();
        }
    }, {
        key: "setSize",
        value: function setSize() {
            gsap.set(this.$imageinfo, { display: 'block', height: '' });
            this.h = this.$imageinfo.outerHeight(true);
            this.$imageinfo.removeClass('scroll');
            var maxH = this.$container.height() - (Breakpoint_1.breakpoint.desktop ? 140 : 80);
            if (this.h > maxH) {
                this.h = maxH;
                gsap.set(this.$imageinfo, { height: maxH + 'px' });
                this.$imageinfoScroll.addClass('scroll');
            } else {
                this.$imageinfoScroll.removeClass('scroll');
            }
        }
    }, {
        key: "toggle",
        value: function toggle(show, fast, force) {
            var _this2 = this;

            if (typeof show !== 'undefined') {
                if (!!show && (!this.shown || !!force)) {
                    this.show(fast);
                } else if (!show && (!!this.shown || !!force)) {
                    this.hide(fast, 0);
                }
            } else {
                (!!this.shown ? function (fast) {
                    return _this2.hide(fast, 0);
                } : function (fast) {
                    return _this2.show(fast);
                })(fast);
            }
        }
    }, {
        key: "show",
        value: function show(fast) {
            var _this3 = this;

            if (!this.isAnimating) {
                this.isAnimating = true;
                this.shown = true;
                this.$buttonImageinfo.find('.svg-info').hide();
                this.$buttonImageinfo.find('.svg-closer').show();
                gsap.to(this.$imageinfo, {
                    duration: !fast ? this.time : 0,
                    y: '0',
                    ease: Site_1.easing,
                    onComplete: function onComplete() {
                        _this3.isAnimating = false;
                    }
                });
                gsap.to(this.$buttonImageinfo, {
                    duration: !fast ? this.time : 0,
                    y: -this.h,
                    ease: Site_1.easing
                });
            }
        }
    }, {
        key: "hide",
        value: function hide(fast, delay) {
            var _this4 = this;

            if (!this.isAnimating) {
                this.isAnimating = true;
                gsap.to(this.$imageinfo, {
                    duration: !fast ? this.time : 0,
                    y: '100%',
                    ease: Site_1.easing,
                    delay: delay,
                    onComplete: function onComplete() {
                        _this4.shown = false;
                        _this4.$buttonImageinfo.find('.svg-info').show();
                        _this4.$buttonImageinfo.find('.svg-closer').hide();
                        _this4.isAnimating = false;
                    }
                });
                gsap.to(this.$buttonImageinfo, {
                    duration: !fast ? this.time : 0,
                    y: 0,
                    ease: Site_1.easing
                });
            }
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.$buttonImageinfo.off('.heading');
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this5 = this;

            this.$buttonImageinfo.off('.heading').on('click.heading', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this5.toggle();
            });
        }
    }]);

    return HeadlinePhoto;
}(Component_1.Component);

exports.HeadlinePhoto = HeadlinePhoto;

},{"../Breakpoint":2,"../Site":13,"./Component":18}],21:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Site_1 = require("../Site");
var Breakpoint_1 = require("../Breakpoint");
var PushStates_1 = require("../PushStates");

var HomeSlider = function (_Component_1$Componen) {
    _inherits(HomeSlider, _Component_1$Componen);

    function HomeSlider(view) {
        _classCallCheck(this, HomeSlider);

        var _this = _possibleConstructorReturn(this, (HomeSlider.__proto__ || Object.getPrototypeOf(HomeSlider)).call(this, view));

        _this.view = view;
        _this.jsonItems = new Array();
        _this.currentIndex = -1;
        _this.amount = -1;
        _this.isAnimating = false;
        _this.time = 1;
        _this.tempObject = { dashoffset: 0 };
        _this.autoplayTime = 5;
        _this.resize = function () {};
        _this.setJsonItems().then(function () {
            return _this.init();
        });
        _this.$text = _this.view.find('.js-slider-text');
        _this.$name = _this.view.find('.js-slider-name');
        _this.$img = _this.view.find('.js-slider-img');
        _this.$link = _this.view.find('.js-slider-link');
        _this.$linkAdditional = _this.view.find('.js-additional-link');
        _this.$progress = _this.view.find('.js-slider-progress');
        _this.$arrowPrev = _this.view.find('.js-slider-prev');
        _this.$arrowNext = _this.view.find('.js-slider-next');
        _this.$arrowArrows = _this.view.find('.js-slider-nav');
        _this.$index = _this.view.find('.js-index');
        _this.$curtain = _this.view.find('.js-slider-curtain');
        _this.timeoutID = setTimeout(function () {
            _this.autoplayLoop();
        }, 1);
        _this.bind();
        return _this;
    }

    _createClass(HomeSlider, [{
        key: "destroy",
        value: function destroy() {
            this.stopAutoplay();
            this.unbind();
            _get(HomeSlider.prototype.__proto__ || Object.getPrototypeOf(HomeSlider.prototype), "destroy", this).call(this);
        }
    }, {
        key: "stopAutoplay",
        value: function stopAutoplay() {
            gsap.killTweensOf(this.tempObject);
            clearTimeout(this.timeoutID);
        }
    }, {
        key: "autoplayLoop",
        value: function autoplayLoop() {
            var indexNew = this.currentIndex + 1;
            this.goTo(indexNew, 'next', false);
            if (Breakpoint_1.breakpoint.desktop) {
                this.startAutoplay();
            }
        }
    }, {
        key: "startAutoplay",
        value: function startAutoplay() {
            var _this2 = this;

            gsap.fromTo(this.tempObject, this.autoplayTime, { dashoffset: 0 }, {
                dashoffset: 100,
                ease: "none",
                onUpdate: function onUpdate() {
                    _this2.$progress.css("height", "");
                    gsap.set(_this2.$progress, { width: _this2.tempObject.dashoffset + '%' });
                },
                onUpdateParams: [this.tempObject.dashoffset],
                onComplete: function onComplete() {
                    _this2.autoplayLoop();
                }
            });
        }
    }, {
        key: "init",
        value: function init() {
            var _this3 = this;

            this.items = new Array();
            $.each(this.jsonItems['items'], function (key1, value1) {
                _this3.items.push(value1);
            });
            this.amount = this.items.length;
            if (this.amount < 2) {
                this.$arrowArrows.remove();
            }
            this.goTo(0, 'next', true);
        }
    }, {
        key: "goTo",
        value: function goTo(index, direction, fast) {
            var _this4 = this;

            if (!this.isAnimating) {
                if (this.currentIndex != index) {
                    this.isAnimating = true;
                    if (this.amount - 1 < index) {
                        index = 0;
                    } else if (0 > index) {
                        index = this.amount - 1;
                    }
                    this.currentIndex = index;
                    var hOld = this.$name.outerHeight(true);
                    gsap.to(this.$text, this.time, {
                        opacity: '0',
                        y: 30,
                        ease: Site_1.easing,
                        onComplete: function onComplete() {
                            _this4.$name.html(_this4.items[_this4.currentIndex]['name']);
                            gsap.to(_this4.$text, _this4.time, { opacity: '1', y: 0, ease: Site_1.easing });
                            if (!Breakpoint_1.breakpoint.phone) {
                                var imgH = _this4.$img.height();
                                gsap.set(_this4.$name, { display: 'block', height: '', 'font-size': '' });
                                var h = _this4.$name.outerHeight(true);
                                var fontSize = 80;
                                var i = 0;
                                while (h > imgH && fontSize > 12) {
                                    _this4.$name.css({ 'font-size': fontSize });
                                    fontSize--;
                                    i++;
                                    h = _this4.$name.outerHeight(true);
                                }
                            } else {}
                            _this4.$link.attr('href', _this4.items[_this4.currentIndex]['link']);
                            _this4.$link.attr('title', 'link ' + _this4.items[_this4.currentIndex]['name']);
                            _this4.$link.attr('aria-label', 'link ' + _this4.items[_this4.currentIndex]['name']);
                            _this4.$linkAdditional.attr('data-href', _this4.items[_this4.currentIndex]['link']);
                            _this4.$linkAdditional.each(function (i, el) {
                                if ($(el).attr('data-href')) {
                                    $(el).off().on('click', function () {
                                        PushStates_1.PushStates.goTo($(el).attr('data-href'));
                                    });
                                }
                            });
                            _this4.$index.html(_this4.currentIndex + 1 + "<span>/" + _this4.amount + "</span>");
                            gsap.to([_this4.$index], _this4.time, { opacity: '1', ease: Site_1.easing });
                        }
                    });
                    gsap.to(this.$img, 0.5, {
                        opacity: 0,
                        onComplete: function onComplete() {
                            _this4.$img.attr('src', _this4.items[_this4.currentIndex]['img']);
                            _this4.$img.attr('alt', _this4.items[_this4.currentIndex]['alt']);
                            gsap.to(_this4.$img, 0.5, {
                                opacity: 1,
                                onComplete: function onComplete() {
                                    _this4.isAnimating = false;
                                }
                            });
                        }
                    });
                }
            }
        }
    }, {
        key: "setJsonItems",
        value: function setJsonItems() {
            var _this5 = this;

            return new Promise(function (resolve, reject) {
                _this5.jsonItems = _this5.view.data('json');
                resolve();
            });
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this6 = this;

            this.$arrowPrev.off('.slider-double-row').on('click.slider-double-row', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this6.stopAutoplay();
                _this6.goTo(_this6.currentIndex - 1, 'prev', false);
                _this6.autoplayLoop();
            });
            this.$arrowNext.off('.slider-double-row').on('click.slider-double-row', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this6.stopAutoplay();
                _this6.goTo(_this6.currentIndex + 1, 'next', false);
                _this6.autoplayLoop();
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.$arrowPrev.off('.slider-double-row');
            this.$arrowNext.off('.slider-double-row');
        }
    }]);

    return HomeSlider;
}(Component_1.Component);

exports.HomeSlider = HomeSlider;

},{"../Breakpoint":2,"../PushStates":11,"../Site":13,"./Component":18}],22:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Breakpoint_1 = require("../Breakpoint");

var HomeWave = function (_Component_1$Componen) {
    _inherits(HomeWave, _Component_1$Componen);

    function HomeWave(view) {
        _classCallCheck(this, HomeWave);

        var _this = _possibleConstructorReturn(this, (HomeWave.__proto__ || Object.getPrototypeOf(HomeWave)).call(this, view));

        _this.view = view;
        _this.resize = function () {};
        _this.timeout = setTimeout(function () {
            _this.startWave();
        }, 1000);
        return _this;
    }

    _createClass(HomeWave, [{
        key: "onState",
        value: function onState() {
            return false;
        }
    }, {
        key: "startWave",
        value: function startWave() {
            var count = 10;
            if (Breakpoint_1.breakpoint.desktop) {
                count = 20;
            } else if (Breakpoint_1.breakpoint.tablet) {
                count = 20;
            }
            var waves = new SineWaves({
                el: document.getElementById('wave-1'),
                speed: 1,
                width: function width() {
                    var w = $(window).width() / 2;
                    if (Breakpoint_1.breakpoint.phone) {
                        w = $(window).width();
                    }
                    return w;
                },
                height: function height() {
                    var h = $(window).height() * 0.6;
                    return h;
                },
                ease: 'SineInOut',
                wavesWidth: '120%',
                waves: function () {
                    var _w = [];
                    for (var i = 1; i <= count; i++) {
                        var num = 100 + i * 3;
                        _w.push({
                            timeModifier: 2,
                            lineWidth: 1,
                            amplitude: num * -1,
                            wavelength: num
                        });
                    }
                    return _w;
                }(),
                resizeEvent: function resizeEvent() {
                    var gradient = this.ctx.createLinearGradient(0, 0, this.width, 0);
                    gradient.addColorStop(0, "rgba(104, 214, 237, 0)");
                    gradient.addColorStop(0.5, "rgba(104, 214, 237, 1)");
                    gradient.addColorStop(1, "rgba(104, 214, 237, 0)");
                    var index = -1;
                    var length = this.waves.length;
                    while (++index < length) {
                        this.waves[index].strokeStyle = gradient;
                    }
                    index = void 0;
                    length = void 0;
                }
            });
        }
    }, {
        key: "destroy",
        value: function destroy() {
            clearTimeout(this.timeout);
            _get(HomeWave.prototype.__proto__ || Object.getPrototypeOf(HomeWave.prototype), "destroy", this).call(this);
        }
    }]);

    return HomeWave;
}(Component_1.Component);

exports.HomeWave = HomeWave;

},{"../Breakpoint":2,"./Component":18}],23:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Site_1 = require("../Site");

var Infobox = function (_Component_1$Componen) {
    _inherits(Infobox, _Component_1$Componen);

    function Infobox(view) {
        _classCallCheck(this, Infobox);

        var _this = _possibleConstructorReturn(this, (Infobox.__proto__ || Object.getPrototypeOf(Infobox)).call(this, view));

        _this.view = view;
        _this.isAnimating = false;
        _this.time = 0.8;
        _this.timeIcon = 0.25;
        _this.resize = function () {
            if (_this.view.hasClass('is-open')) {
                _this.hide();
            }
        };
        _this.$container = _this.view.find('.infobox__container');
        _this.$title = _this.view.find('.infobox__title');
        _this.$icon = _this.view.find('svg');
        _this.$pathV = _this.$icon.find('path').eq(0);
        _this.$pathHLeft = _this.$icon.find('path').eq(1);
        _this.$pathHRight = _this.$icon.find('path').eq(2);
        _this.bind();
        _this.view.data('Infobox', _this);
        return _this;
    }

    _createClass(Infobox, [{
        key: "destroy",
        value: function destroy() {
            this.unbind();
            _get(Infobox.prototype.__proto__ || Object.getPrototypeOf(Infobox.prototype), "destroy", this).call(this);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this2 = this;

            this.view.off('.infobox').on('click.infobox', function (e) {
                if (_this2.view.hasClass('is-open')) {
                    _this2.hide();
                } else {
                    if (_this2.view.closest('.infoboxs').find('.infobox.is-open').data('Infobox') != undefined) {
                        _this2.view.closest('.infoboxs').find('.infobox.is-open').data('Infobox').hide();
                    }
                    _this2.show();
                }
            });
            this.$title.on('mouseenter.infobox', function (e) {
                if (!_this2.view.hasClass('is-open')) {
                    gsap.to([_this2.$pathHLeft, _this2.$pathHRight], _this2.timeIcon, { opacity: 0, ease: Site_1.easing });
                }
            }).on('mouseleave.infobox', function (e) {
                gsap.to([_this2.$pathHLeft, _this2.$pathHRight], _this2.timeIcon, { opacity: 1, ease: Site_1.easing });
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.view.off('.infobox');
            this.$title.off('.infobox');
        }
    }, {
        key: "show",
        value: function show(fast) {
            var _this3 = this;

            if (!this.isAnimating) {
                this.isAnimating = true;
                this.view.addClass('is-open');
                gsap.set(this.$container, { display: 'block', height: '' });
                var h = this.$container.outerHeight(true);
                gsap.set(this.$container, { height: '0px' });
                gsap.to(this.$container, this.time, {
                    height: h,
                    ease: Site_1.easing,
                    onComplete: function onComplete() {
                        _this3.isAnimating = false;
                    }
                });
                gsap.to(this.$pathV, this.timeIcon, { rotate: '90deg', ease: Site_1.easing, transformOrigin: '50% 50%' });
                gsap.to(this.$pathHLeft, this.timeIcon, { y: 0, x: 0, rotate: '0deg', transformOrigin: '50% 50%', ease: Site_1.easing });
                gsap.to(this.$pathHRight, this.timeIcon, { y: 0, x: 0, rotate: '0deg', transformOrigin: '50% 50%', ease: Site_1.easing });
                var pItems = this.$container.find('p');
                gsap.killTweensOf(pItems);
                gsap.fromTo(pItems, { opacity: 0 }, { duration: this.time, opacity: 1, ease: 'sineIn', delay: 0, stagger: 0.25 });
            }
        }
    }, {
        key: "hide",
        value: function hide(fast) {
            var _this4 = this;

            if (!this.isAnimating) {
                this.isAnimating = true;
                gsap.to(this.$container, this.time, {
                    height: 0,
                    ease: Site_1.easing,
                    onComplete: function onComplete() {
                        gsap.set(_this4.$container, { display: 'none' });
                        _this4.view.removeClass('is-open');
                        _this4.isAnimating = false;
                    }
                });
                gsap.to(this.$pathV, this.timeIcon, { rotate: '0deg', ease: Site_1.easing, transformOrigin: '50% 50%' });
                var pItems = this.$container.find('p');
                gsap.killTweensOf(pItems);
                gsap.to(pItems, { duration: this.time, opacity: 0, ease: 'sineIn', delay: 0, stagger: -0.25 });
            }
        }
    }]);

    return Infobox;
}(Component_1.Component);

exports.Infobox = Infobox;

},{"../Site":13,"./Component":18}],24:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Breakpoint_1 = require("../Breakpoint");
var Site_1 = require("../Site");

var InfoboxBase = function (_Component_1$Componen) {
    _inherits(InfoboxBase, _Component_1$Componen);

    function InfoboxBase(view) {
        _classCallCheck(this, InfoboxBase);

        var _this = _possibleConstructorReturn(this, (InfoboxBase.__proto__ || Object.getPrototypeOf(InfoboxBase)).call(this, view));

        _this.view = view;
        _this.isAnimating = false;
        _this.time = 0.8;
        _this.timeIcon = 0.25;
        _this.resize = function () {
            if (Breakpoint_1.breakpoint.desktop) {
                if (_this.view.hasClass('is-open')) {
                    _this.hide();
                }
                _this.init();
            }
        };
        _this.$container = _this.view.find('.infobox__container');
        _this.$description = _this.view.find('.infobox__description');
        _this.$button = _this.view.find('.button');
        _this.$icon = _this.view.find('svg');
        _this.$pathV = _this.$icon.find('path').eq(0);
        _this.$pathHLeft = _this.$icon.find('path').eq(1);
        _this.$pathHRight = _this.$icon.find('path').eq(2);
        _this.bind();
        _this.init();
        return _this;
    }

    _createClass(InfoboxBase, [{
        key: "destroy",
        value: function destroy() {
            this.unbind();
            _get(InfoboxBase.prototype.__proto__ || Object.getPrototypeOf(InfoboxBase.prototype), "destroy", this).call(this);
        }
    }, {
        key: "init",
        value: function init() {
            var _this2 = this;

            setTimeout(function () {
                var cH = _this2.$container.outerHeight(true);
                var dH = _this2.$description.outerHeight(true);
                if (dH <= cH) {
                    _this2.$button.hide();
                } else {
                    _this2.hide();
                }
            }, 100);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this3 = this;

            this.$button.off('.infobox').on('click.infobox', function (e) {
                if (_this3.view.hasClass('is-open')) {
                    _this3.hide();
                } else {
                    if (_this3.view.closest('.infoboxs').find('.infobox.is-open').data('Infobox') != undefined) {
                        _this3.view.closest('.infoboxs').find('.infobox.is-open').data('Infobox').hide();
                    }
                    _this3.show();
                }
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.view.off('.infobox');
        }
    }, {
        key: "show",
        value: function show(fast) {
            var _this4 = this;

            if (!this.isAnimating) {
                this.isAnimating = true;
                this.view.addClass('is-open');
                gsap.set(this.$description, { display: 'block' });
                gsap.set(this.$container, { height: 'auto' });
                var h = this.$container.outerHeight(true);
                gsap.set(this.$container, { height: '0px' });
                gsap.to(this.$container, this.time, {
                    height: h,
                    ease: Site_1.easing,
                    onComplete: function onComplete() {
                        _this4.isAnimating = false;
                        _this4.$button.find('.button__text span').text(_this4.$button.data('hide'));
                    }
                });
                gsap.to(this.$pathV, this.timeIcon, { rotate: '90deg', ease: Site_1.easing, transformOrigin: '50% 50%' });
                gsap.to(this.$pathHLeft, this.timeIcon, { y: 0, x: 0, rotate: '0deg', transformOrigin: '50% 50%', ease: Site_1.easing });
                gsap.to(this.$pathHRight, this.timeIcon, { y: 0, x: 0, rotate: '0deg', transformOrigin: '50% 50%', ease: Site_1.easing });
                var pItems = this.$container.find('p');
                gsap.killTweensOf(pItems);
            }
        }
    }, {
        key: "hide",
        value: function hide(fast) {
            var _this5 = this;

            if (!this.isAnimating) {
                this.isAnimating = true;
                gsap.to(this.$container, this.time, {
                    height: 0,
                    ease: Site_1.easing,
                    onComplete: function onComplete() {
                        gsap.set(_this5.$description, { display: '-webkit-box' });
                        _this5.view.removeClass('is-open');
                        _this5.isAnimating = false;
                        _this5.$button.find('.button__text span').text(_this5.$button.data('show'));
                    }
                });
                gsap.to(this.$pathV, this.timeIcon, { rotate: '0deg', ease: Site_1.easing, transformOrigin: '50% 50%' });
                var pItems = this.$container.find('p');
                gsap.killTweensOf(pItems);
            }
        }
    }]);

    return InfoboxBase;
}(Component_1.Component);

exports.InfoboxBase = InfoboxBase;

},{"../Breakpoint":2,"../Site":13,"./Component":18}],25:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Breakpoint_1 = require("../Breakpoint");
var Site_1 = require("../Site");

var InfoboxSpeaker = function (_Component_1$Componen) {
    _inherits(InfoboxSpeaker, _Component_1$Componen);

    function InfoboxSpeaker(view) {
        _classCallCheck(this, InfoboxSpeaker);

        var _this = _possibleConstructorReturn(this, (InfoboxSpeaker.__proto__ || Object.getPrototypeOf(InfoboxSpeaker)).call(this, view));

        _this.view = view;
        _this.isAnimating = false;
        _this.time = 0.8;
        _this.timeIcon = 0.25;
        _this.resize = function () {
            if (Breakpoint_1.breakpoint.desktop) {
                if (_this.view.hasClass('is-open')) {
                    _this.hide();
                }
                _this.init();
            }
        };
        _this.$container = _this.view.find('.infobox__container');
        _this.$description = _this.view.find('.infobox__description');
        _this.$button = _this.view.find('.button');
        _this.$icon = _this.view.find('svg');
        _this.$pathV = _this.$icon.find('path').eq(0);
        _this.$pathHLeft = _this.$icon.find('path').eq(1);
        _this.$pathHRight = _this.$icon.find('path').eq(2);
        _this.bind();
        _this.init();
        return _this;
    }

    _createClass(InfoboxSpeaker, [{
        key: "destroy",
        value: function destroy() {
            this.unbind();
            _get(InfoboxSpeaker.prototype.__proto__ || Object.getPrototypeOf(InfoboxSpeaker.prototype), "destroy", this).call(this);
        }
    }, {
        key: "init",
        value: function init() {
            var _this2 = this;

            setTimeout(function () {
                var cH = _this2.$container.outerHeight(true);
                var dH = _this2.$description.outerHeight(true);
                if (dH <= cH) {
                    _this2.$button.hide();
                } else {
                    _this2.hide();
                }
            }, 100);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this3 = this;

            this.$button.off('.infobox').on('click.infobox', function (e) {
                if (_this3.view.hasClass('is-open')) {
                    _this3.hide();
                } else {
                    _this3.show();
                }
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.view.off('.infobox');
        }
    }, {
        key: "show",
        value: function show(fast) {
            var _this4 = this;

            if (!this.isAnimating) {
                this.isAnimating = true;
                this.view.addClass('is-open');
                gsap.set(this.$description, { display: 'block' });
                gsap.set(this.$container, { height: 'auto' });
                var h = this.$container.outerHeight(true);
                gsap.set(this.$container, { height: '76px' });
                gsap.to(this.$container, this.time, {
                    height: h,
                    ease: Site_1.easing,
                    onComplete: function onComplete() {
                        _this4.isAnimating = false;
                        _this4.$button.find('.button__text span').text(_this4.$button.data('hide'));
                    }
                });
                gsap.to(this.$pathV, this.timeIcon, { rotate: '90deg', ease: Site_1.easing, transformOrigin: '50% 50%' });
                gsap.to(this.$pathHLeft, this.timeIcon, { y: 0, x: 0, rotate: '0deg', transformOrigin: '50% 50%', ease: Site_1.easing });
                gsap.to(this.$pathHRight, this.timeIcon, { y: 0, x: 0, rotate: '0deg', transformOrigin: '50% 50%', ease: Site_1.easing });
                var pItems = this.$container.find('p');
                gsap.killTweensOf(pItems);
            }
        }
    }, {
        key: "hide",
        value: function hide(fast) {
            var _this5 = this;

            if (!this.isAnimating) {
                this.isAnimating = true;
                gsap.to(this.$container, this.time, {
                    height: 76,
                    ease: Site_1.easing,
                    onComplete: function onComplete() {
                        gsap.set(_this5.$description, { display: '-webkit-box' });
                        _this5.view.removeClass('is-open');
                        _this5.isAnimating = false;
                        _this5.$button.find('.button__text span').text(_this5.$button.data('show'));
                    }
                });
                gsap.to(this.$pathV, this.timeIcon, { rotate: '0deg', ease: Site_1.easing, transformOrigin: '50% 50%' });
                var pItems = this.$container.find('p');
                gsap.killTweensOf(pItems);
            }
        }
    }]);

    return InfoboxSpeaker;
}(Component_1.Component);

exports.InfoboxSpeaker = InfoboxSpeaker;

},{"../Breakpoint":2,"../Site":13,"./Component":18}],26:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Player_1 = require("./Player");
var Utils = require("../Utils");
var Site_1 = require("../Site");
var Templates_1 = require("../Templates");
var PushStates_1 = require("../PushStates");
var Swipe_1 = require("./Swipe");

var Lightbox = function (_Component_1$Componen) {
    _inherits(Lightbox, _Component_1$Componen);

    function Lightbox(view, options) {
        _classCallCheck(this, Lightbox);

        var _this = _possibleConstructorReturn(this, (Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call(this, view, options));

        _this.view = view;
        _this.resize = function (wdt, hgt, breakpoint, changed) {
            _this.checkZoomAvailability();
        };
        _this.onImageClick = function (e) {
            if (_this.isReloading) {
                return;
            }
            $(e.currentTarget).closest('.js-item').toggleClass('is-adapted');
            _this.view.toggleClass('has-adapted', _this.view.find('.is-adapted').length > 0);
        };
        _this.onKeyUp = function (e) {
            switch (e.keyCode || e.which) {
                case Utils.keys.right:
                    _this.go(+1);
                    break;
                case Utils.keys.left:
                    _this.go(-1);
                    break;
                case Utils.keys.esc:
                    PushStates_1.PushStates.back();
                    break;
                default:
                    break;
            }
        };
        _this.onSwipeEnd = function (data) {
            if (_this.view.hasClass('has-adapted')) {
                return;
            }
            if (data.direction && data.direction !== 'none' && data.direction !== 'click') {
                _this.go({ 'left': 1, 'right': -1 }[data.direction]);
            }
        };
        _this.settings = $.extend({
            loop: false
        }, options || {});
        if (_this.view.children().length) {
            _this.init();
        }
        return _this;
    }

    _createClass(Lightbox, [{
        key: "onState",
        value: function onState() {
            return this.toggleByPathname();
        }
    }, {
        key: "build",
        value: function build(data) {
            var $el = this.render(data);
            this.init();
            return $el;
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this.unbind();
            this.$arrowPrev = this.view.find('.js-prev');
            this.$arrowNext = this.view.find('.js-next');
            this.$close = this.view.find('.js-close');
            this.$caption = this.view.find('.js-caption');
            this.$count = this.view.find('.js-count');
            this.$list = this.view.find('.js-list');
            this.$items = this.view.find('[data-lightbox-path]');
            $('.js-full[href="' + this.firstPath + '"]').focus();
            this.amount = null;
            this.cache = null;
            _get(Lightbox.prototype.__proto__ || Object.getPrototypeOf(Lightbox.prototype), "destroy", this).call(this);
        }
    }, {
        key: "init",
        value: function init() {
            this.store();
            this.swipe = new Swipe_1.Swipe(this.$list, { vertical: true });
            this.firstPath = window.location.pathname;
            this.toggleByPathname(window.location.pathname, true);
            if (this.$zoom[0]) {
                this.checkZoomAvailability();
            }
            setTimeout(function () {
                $('.js-lightbox-focus-start').focus();
            }, 1);
            this.bind();
        }
    }, {
        key: "render",
        value: function render(data) {
            var template = Templates_1.Templates.get('lightbox');
            var html = template.render(data);
            this.view.html(html);
            return this.view;
        }
    }, {
        key: "store",
        value: function store() {
            this.$arrowPrev = this.view.find('.js-prev');
            this.$arrowNext = this.view.find('.js-next');
            this.$close = this.view.find('.js-close');
            this.$caption = this.view.find('.js-caption');
            this.$count = this.view.find('.js-count');
            this.$list = this.view.find('.js-list');
            this.$zoom = this.view.find('.js-zoom');
            this.$items = this.view.find('[data-lightbox-path]');
            this.amount = this.$items.length;
            this.cache = this.$items.toArray().map(function (item, index) {
                var $el = $(item);
                return {
                    $el: $el,
                    index: index,
                    path: $el.data('lightbox-path')
                };
            });
        }
    }, {
        key: "toggleByPathname",
        value: function toggleByPathname(pathname, force) {
            var item = this.getItemByPathname(pathname);
            if (!!item) {
                this.goToItem(item);
            } else if (!!force) {
                this.goToItem(this.cache[0]);
            }
            return !!item || !!force;
        }
    }, {
        key: "getItemByPathname",
        value: function getItemByPathname(pathname) {
            if (!this.cache || !this.cache.length) {
                return null;
            }
            pathname = typeof pathname !== 'undefined' && pathname !== null ? pathname : window.location.pathname;
            pathname = Utils.normalizeURL(pathname);
            var item = this.cache.filter(function (item) {
                return item.path === pathname;
            })[0];
            return item;
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this2 = this;

            this.swipe.off().on(Swipe_1.SwipeEvents.END, this.onSwipeEnd);
            this.$arrowPrev.off('.lightbox').on('click.lightbox', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this2.go(-1);
            });
            this.$arrowNext.off('.lightbox').on('click.lightbox', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this2.go(+1);
            });
            this.$caption.off('.lightbox').on('click.lightbox', '.js-caption-toggle', function (e) {
                _this2.$caption.toggleClass('is-open');
            });
            Site_1.$doc.off('.lightbox').on('keyup.lightbox', this.onKeyUp);
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.swipe.off();
            this.$items.off('.lightbox');
            this.$arrowPrev.off('.lightbox');
            this.$arrowNext.off('.lightbox');
            this.$caption.off('.lightbox');
            Site_1.$doc.off('.lightbox');
        }
    }, {
        key: "go",
        value: function go(dir) {
            var targetIndex = this.currentIndex + dir;
            if (!this.settings.loop && (targetIndex < 0 || targetIndex > this.amount - 1)) {
                return;
            }
            PushStates_1.PushStates.goTo(this.cache[targetIndex].path, true);
        }
    }, {
        key: "goToItem",
        value: function goToItem(item, fast) {
            var _this3 = this;

            if (!item) {
                return;
            }
            this.placeImages(item.index);
            this.isReloading = true;
            this.hideItem(this.currentIndex, fast).then(function () {
                return _this3.showItem(item.index, fast);
            });
        }
    }, {
        key: "hideItem",
        value: function hideItem(index, fast) {
            var _this4 = this;

            return new Promise(function (resolve, reject) {
                if (!!_this4.animating) {
                    reject();
                    return;
                }
                var $item = _this4.$items.eq(index);
                _this4.$items.removeClass('is-current');
                _this4.animating = true;
                gsap.to($item, {
                    duration: !fast ? 0.3 : 0.01,
                    opacity: 0,
                    ease: 'sine.out',
                    onComplete: function onComplete() {
                        $item.removeClass('is-adapted');
                        _this4.view.removeClass('has-adapted');
                        _this4.animating = false;
                        resolve();
                    }
                });
                Player_1.Player.pauseAllIn(_this4.view);
                _this4.$caption.removeClass('is-open');
            });
        }
    }, {
        key: "showItem",
        value: function showItem(index, fast) {
            var _this5 = this;

            this.currentIndex = index < 0 ? this.amount - 1 : index >= this.amount ? 0 : index;
            if (this.currentIndex === undefined) {
                this.currentIndex = 0;
            }
            var $item = this.$items.eq(this.currentIndex);
            $item.addClass('is-current').siblings().removeClass('is-current');
            gsap.fromTo($item, {
                opacity: 0
            }, {
                opacity: 1,
                duration: !fast ? 0.6 : 0.01,
                ease: 'sine.out',
                onComplete: function onComplete() {
                    _this5.isReloading = false;
                }
            });
            this.updateArrows();
            this.updateCaption();
        }
    }, {
        key: "placeImages",
        value: function placeImages(index) {
            var images = this.$list.find('img[data-src]').toArray();
            if (index) {
                images = images.symmetricSort(index);
            }
            images.forEach(function (img) {
                var image = new Image();
                image.src = img.dataset['src'];
            });
            images.forEach(function (img) {
                img.src = img.dataset['src'];
                img.removeAttribute('data-src');
            });
        }
    }, {
        key: "updateArrows",
        value: function updateArrows() {
            this.$arrowPrev.toggleClass('is-disabled', this.amount === 0 || !this.settings.loop && this.currentIndex <= 0);
            this.$arrowNext.toggleClass('is-disabled', this.amount === 0 || !this.settings.loop && this.currentIndex >= this.amount - 1);
        }
    }, {
        key: "updateCaption",
        value: function updateCaption() {
            var $currentItem = this.$items.eq(this.currentIndex);
            this.$count.text(this.currentIndex + 1 + '/' + this.amount);
            var $caption = $currentItem.find('figcaption');
            this.$caption.empty().html($caption.html()).removeClass('is-open').toggleClass('has-description', $caption.find('.caption__text').length > 0);
        }
    }, {
        key: "checkZoomAvailability",
        value: function checkZoomAvailability() {
            this.$items.each(function (i, item) {
                var $images = $(item).find('img');
                $images.toggleClass('is-zoom-available', $images.toArray().some(function (img) {
                    var hgt = parseInt(img.dataset.bigHeight, 10) || parseInt(img.height, 10);
                    var wdt = parseInt(img.dataset.bigWidth, 10) || parseInt(img.width, 10);
                    return hgt > window.innerHeight || wdt > window.innerWidth;
                }));
            });
        }
    }]);

    return Lightbox;
}(Component_1.Component);

exports.Lightbox = Lightbox;

},{"../PushStates":11,"../Site":13,"../Templates":14,"../Utils":15,"./Component":18,"./Player":31,"./Swipe":38}],27:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Utils = require("../Utils");
var Site_1 = require("../Site");
var PushStates_1 = require("../PushStates");
var Scrolling_1 = require("../Scrolling");

var Load = function (_Component_1$Componen) {
    _inherits(Load, _Component_1$Componen);

    function Load(view, options) {
        _classCallCheck(this, Load);

        var _this = _possibleConstructorReturn(this, (Load.__proto__ || Object.getPrototypeOf(Load)).call(this, view, options));

        _this.view = view;
        _this.options = options;
        _this.onSubmit = function (e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            var loadPath = _this.view.attr('action') || window.location.pathname;
            var extraData = _this.settings.extra ? Utils.serialize($(_this.settings.extra)) : null;
            var data = Utils.serialize(_this.view);
            data = data === '' ? null : data;
            if (data || extraData) {
                loadPath += '?' + [extraData, data].filter(function (s) {
                    return !!s;
                }).join('&');
            }
            if (window.location.search === loadPath) {
                return;
            }
            PushStates_1.PushStates.changePath(loadPath, true);
            Promise.all([Scrolling_1.Scrolling.scrollTop(), _this.hideContent(), _this.load(loadPath)]).then(function () {
                _this.render();
                _this.showContent();
            });
        };
        _this.onClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var loadPath = e.currentTarget.href;
            PushStates_1.PushStates.changePath(loadPath, true);
            Promise.all([_this.hideContent(), _this.load(loadPath)]).then(function () {
                _this.render();
                _this.showContent();
            });
        };
        _this.settings = $.extend({
            contentSelector: '.js-load-content',
            attrSelector: '.js-load-attr',
            live: false
        }, options || {});
        _this.isContentHidden = false;
        _this.$contentElements = $(_this.settings.contentSelector).filter('[id]');
        _this.$attrElements = $(_this.settings.attrSelector).filter('[id]');
        if ($(_this.settings.contentSelector).not('[id]').length > 0) {
            console.log('There are some content-to-change elements without id given', $(_this.settings.contentSelector).not('[id]'));
        }
        if ($(_this.settings.attrSelector).not('[id]').length > 0) {
            console.log('There are some attribute-to-change elements without id given', $(_this.settings.attrSelector).not('[id]'));
        }
        _this.bind();
        return _this;
    }

    _createClass(Load, [{
        key: "destroy",
        value: function destroy() {
            this.unbind();
            _get(Load.prototype.__proto__ || Object.getPrototypeOf(Load.prototype), "destroy", this).call(this);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this2 = this;

            var isForm = this.view.is('form');
            this.view.off('.load');
            this.view.on((isForm ? 'submit' : 'click') + '.load', isForm ? this.onSubmit : this.onClick);
            if (!!this.settings.live) {
                this.view.find(':input').not('[type=search]').off('.load').on('change.load', function () {
                    window.clearTimeout(_this2.liveTimeout);
                    _this2.liveTimeout = setTimeout(_this2.onSubmit, 1000);
                });
                this.view.find('[type=search]').off('.load').on('keyup.load', function (e) {
                    window.clearTimeout(_this2.liveTimeout);
                    if (e.currentTarget.value.length >= 3 && parseInt(e.key, 10) !== Utils.keys.enter) {
                        _this2.liveTimeout = setTimeout(_this2.onSubmit, 250);
                    }
                });
            }
        }
    }, {
        key: "hideContent",
        value: function hideContent() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                if (!_this3.isContentHidden) {
                    gsap.to(_this3.$contentElements, {
                        opacity: 0,
                        duration: 0.4,
                        ease: Site_1.easing,
                        onComplete: function onComplete() {
                            _this3.isContentHidden = true;
                            resolve();
                        }
                    });
                } else {
                    resolve();
                }
            });
        }
    }, {
        key: "showContent",
        value: function showContent() {
            this.isContentHidden = false;
            gsap.fromTo(this.$contentElements, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.6,
                ease: Site_1.easing
            });
        }
    }, {
        key: "load",
        value: function load(url) {
            var _this4 = this;

            window.clearTimeout(this.liveTimeout);
            this.view.addClass('is-pending');
            return new Promise(function (resolve, reject) {
                var xhruid = _this4.xhruid = new Date().getTime();
                $.ajax({
                    url: url,
                    global: false,
                    type: 'POST',
                    dataType: 'html',
                    async: true
                }).done(function (response) {
                    if (xhruid === _this4.xhruid) {
                        _this4.loadedHtml = response;
                        resolve();
                    } else {
                        reject();
                    }
                }).fail(function (e) {
                    console.warn('Load error: ' + e.statusText);
                    reject();
                }).always(function () {
                    _this4.view.removeClass('is-pending');
                });
            });
        }
    }, {
        key: "render",
        value: function render() {
            var $loaded = $(this.loadedHtml);
            if (this.$contentElements.length > 0) {
                this.$contentElements.each(function (index, el) {
                    el.innerHTML = $loaded.find('#' + el.id).html();
                });
            }
            if (this.$attrElements.length > 0) {
                this.$attrElements.each(function (index, el) {
                    var $el = $(el);
                    var $loadedEl = $loaded.find('#' + el.id);
                    Array.prototype.slice.call($loadedEl[0].attributes).forEach(function (attr) {
                        $el.attr(attr.name, attr.value);
                    });
                });
            }
            var tiles = this.$contentElements.find('[data-component="Tiles"]').data('Tiles');
            if (tiles && typeof tiles['onAppend'] === 'function') {
                tiles.onAppend(this.$contentElements.find('.js-tile'));
            }
            this.trigger(Component_1.ComponentEvents.CHANGE, this.$contentElements);
            $loaded.remove();
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.view.off('.load');
            this.view.find(':input').off('.load');
        }
    }]);

    return Load;
}(Component_1.Component);

exports.Load = Load;

},{"../PushStates":11,"../Scrolling":12,"../Site":13,"../Utils":15,"./Component":18}],28:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Breakpoint_1 = require("../Breakpoint");

var Map = function (_Component_1$Componen) {
    _inherits(Map, _Component_1$Componen);

    function Map(view) {
        _classCallCheck(this, Map);

        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, view));

        _this.view = view;
        _this.mapData = [];
        _this.resize = function () {};
        _this.$map = _this.view.find('svg');
        _this.$path = _this.$map.find('path');
        _this.$tooltip = _this.view.find('#map-tooltip');
        _this.$tooltipClose = _this.view.find('.tooltip-close');
        _this.loadJSON();
        return _this;
    }

    _createClass(Map, [{
        key: "destroy",
        value: function destroy() {
            this.unbind();
            _get(Map.prototype.__proto__ || Object.getPrototypeOf(Map.prototype), "destroy", this).call(this);
        }
    }, {
        key: "loadJSON",
        value: function loadJSON() {
            var _this2 = this;

            $.getJSON(this.view.data('json-map')).done(function (data) {
                _this2.mapData = data;
                _this2.bind();
            }).fail(function () {
                console.error("❌ Błąd podczas wczytywania /application/jsons/map.json");
            });
        }
    }, {
        key: "showTooltipMulti",
        value: function showTooltipMulti(items, e) {
            var $tooltip = $('#map-tooltip');
            var $container = this.view;
            var containerRect = $container.get(0).getBoundingClientRect();
            var tooltipWidth = 300;
            var tooltipHeight = 60 + (items.length - 1) * 120;
            var top = 0;
            var left = 0;
            var ev = e.originalEvent;
            if (Breakpoint_1.breakpoint.desktop) {
                var clickX = ev.clientX;
                var clickY = ev.clientY;
                top = clickY - containerRect.top - tooltipHeight / 2;
                left = 0;
            } else if (Breakpoint_1.breakpoint.tablet) {
                var _clickX = ev.clientX;
                var _clickY = ev.clientY;
                top = _clickY - containerRect.top - tooltipHeight - 10;
                left = _clickX - containerRect.left - tooltipWidth / 2;
            } else {
                var _clickY2 = ev.clientY;
                top = _clickY2 - containerRect.top - tooltipHeight - 50;
                left = 0;
                console.log(window.innerWidth, tooltipWidth);
            }
            $tooltip.css({
                top: top + "px",
                left: left + "px",
                display: "block"
            });
            var html = items.map(function (item) {
                return "\n        <div class=\"tooltip-entry\">\n            <div class=\"tooltip-image\">\n                <img src=\"" + item.photo + "\" alt=\"Herb " + item.title + "\">\n            </div>\n            <div class=\"tooltip-info\">\n                <p>" + item.title + "</p>\n                <a href=\"" + item.link + "\" class=\"button\" target=\"_blank\" title=\"Przejd\u017A do strony zewn\u0119trzenej " + item.title + "\" aria-label=\"Przejd\u017A do strony zewn\u0119trzenej " + item.title + "\">\n                    <span></span><span></span>przejd\u017A\n                </a>\n            </div>\n        </div>\n    ";
            }).join('');
            $tooltip.find('.tooltip-content').html("" + html);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this3 = this;

            this.$path.off('.map').on('click.mouseleave', function (e) {
                var allUnder = document.elementsFromPoint(e.clientX, e.clientY);
                var clickedRegions = allUnder.filter(function (el) {
                    return el.tagName.toLowerCase() === 'path' && el.id;
                }).map(function (el) {
                    return el.id;
                });
                if (!clickedRegions.length) return;
                var items = clickedRegions.map(function (id) {
                    return _this3.mapData.find(function (el) {
                        return el.id === id;
                    });
                }).filter(Boolean).reverse();
                if (items.length > 0) {
                    _this3.showTooltipMulti(items, e);
                }
            });
            this.$map.off('.map').on('mousemove.map', function (e) {
                var ev = e.originalEvent;
                if (!ev) return;
                var allUnder = document.elementsFromPoint(ev.clientX, ev.clientY);
                var hoveredRegions = allUnder.filter(function (el) {
                    return el.tagName.toLowerCase() === 'path' && el.id;
                }).map(function (el) {
                    return el;
                });
                _this3.$path.removeClass('active');
                hoveredRegions.forEach(function (el) {
                    $(el).addClass('active');
                });
            }).on('mouseleave.map', function () {
                _this3.$path.removeClass('active');
            });
            this.$tooltipClose.off('click.close').on('click.close', function () {
                _this3.$tooltip.hide();
            });
            this.$tooltip.off('click.link').on('click.link', '.js-additional-link', function () {
                var href = $(this).data('href');
                if (href) window.open(href, '_blank');
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.$path.off('.map');
            this.$map.off('.map');
            this.$tooltip.off('.close');
            this.$tooltip.off('.link');
        }
    }]);

    return Map;
}(Component_1.Component);

exports.Map = Map;

},{"../Breakpoint":2,"./Component":18}],29:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");

var MapSlider = function (_Component_1$Componen) {
    _inherits(MapSlider, _Component_1$Componen);

    function MapSlider(view) {
        _classCallCheck(this, MapSlider);

        var _this = _possibleConstructorReturn(this, (MapSlider.__proto__ || Object.getPrototypeOf(MapSlider)).call(this, view));

        _this.view = view;
        _this.mapData = [];
        _this.resize = function () {};
        _this.$sliderContainer = _this.view.find('.map__slider__container');
        _this.loadJSON();
        return _this;
    }

    _createClass(MapSlider, [{
        key: "destroy",
        value: function destroy() {
            this.unbind();
            _get(MapSlider.prototype.__proto__ || Object.getPrototypeOf(MapSlider.prototype), "destroy", this).call(this);
        }
    }, {
        key: "loadJSON",
        value: function loadJSON() {
            var _this2 = this;

            $.getJSON(this.view.data('json-map')).done(function (data) {
                _this2.mapData = data;
                _this2.addSlider();
                _this2.initLoopSliderTriple();
                _this2.bind();
            }).fail(function () {
                console.error("❌ Błąd podczas wczytywania /application/jsons/map.json");
            });
        }
    }, {
        key: "initLoopSliderTriple",
        value: function initLoopSliderTriple() {
            var $container = $('.map__slider__container');
            var $items = $container.children('.map__slider__item');
            if (!$container.length || !$items.length) return;
            var $clones = $items.clone();
            $clones.attr('aria-hidden', 'true');
            $clones.find('a, button, [tabindex]').attr('tabindex', '-1');
            $clones.find('img').attr('alt', '');
            $container.append($clones);
            $container.append($clones);
            var totalItems = $container.children('.map__slider__item').length;
            var originalCount = $items.length;
            var itemWidth = $('.map__slider__item').outerWidth(true);
            var singleSetWidth = itemWidth * originalCount;
            console.log(originalCount, totalItems, itemWidth, singleSetWidth);
            $container.css('width', itemWidth * totalItems + "px");
            var translateX = 0;
            var speed = 0.5;
            function animate() {
                translateX -= speed;
                if (-translateX >= singleSetWidth) {
                    translateX = 0;
                }
                $container.css('transform', "translateX(" + translateX + "px)");
                requestAnimationFrame(animate);
            }
            setTimeout(function () {
                animate();
            }, 1);
            window.addEventListener('resize', function () {
                var itemWidthNew = $('.map__slider__item').outerWidth(true);
                var totalItemsNew = $container.children('.map__slider__item').length;
                $container.css('width', itemWidthNew * totalItemsNew + "px");
            });
        }
    }, {
        key: "addSlider",
        value: function addSlider() {
            if (!this.$sliderContainer) return;
            var html = this.mapData.map(function (item) {
                return "\n            <div class=\"map__slider__item\">\n            <a href=\"" + item.link + "\" target=\"_blank\" title=\"Przejd\u017A do strony zewn\u0119trzenej " + item.title + "\" aria-label=\"Przejd\u017A do strony zewn\u0119trzenej " + item.title + "\"></a>\n                <div class=\"map__slider__item__image\">\n                    <img src=\"" + item.photo + "\" alt=\"Herb " + item.title + "\">\n                </div>\n                <div class=\"map__slider__item__info\">\n                    <p>" + item.title + "</p>\n\n                </div>\n            </div>\n        ";
            }).join('');
            this.$sliderContainer.append(html);
        }
    }, {
        key: "bind",
        value: function bind() {}
    }, {
        key: "unbind",
        value: function unbind() {}
    }]);

    return MapSlider;
}(Component_1.Component);

exports.MapSlider = MapSlider;

},{"./Component":18}],30:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Site_1 = require("../Site");
var PushStates_1 = require("../PushStates");

var More = function (_Component_1$Componen) {
    _inherits(More, _Component_1$Componen);

    function More(view, options) {
        _classCallCheck(this, More);

        var _this = _possibleConstructorReturn(this, (More.__proto__ || Object.getPrototypeOf(More)).call(this, view, options));

        _this.view = view;
        _this.options = options;
        _this.pending = false;
        _this.finished = false;
        _this.onClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.load();
        };
        _this.settings = $.extend({}, options);
        _this.contentEl = $(_this.settings.contentSelector);
        console.assert(_this.contentEl.length > 0, 'There is no wrap element to load more content!', true);
        if (_this.contentEl.length > 0) {
            _this.view.off('.more').on('click.more', _this.onClick);
        } else {
            _this.view.hide();
        }
        if (_this.view.is('[data-scroll="infinite"]') && !Modernizr.touchevents) {
            Site_1.$body.addClass('has-pending-infinite');
            _this.view.addClass('is-hidden').html('');
        }
        _this.view.data('More', _this);
        return _this;
    }

    _createClass(More, [{
        key: "destroy",
        value: function destroy() {
            Site_1.$body.removeClass('has-pending-infinite');
            _get(More.prototype.__proto__ || Object.getPrototypeOf(More.prototype), "destroy", this).call(this);
        }
    }, {
        key: "load",
        value: function load() {
            var _this2 = this;

            if (!!this.pending || !!this.finished) {
                return;
            }
            var url = this.view.attr('href');
            this.pending = true;
            this.view.addClass('is-doing-request');
            PushStates_1.PushStates.changePath(url);
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'html',
                data: {
                    partial: true
                }
            }).done(function (data) {
                var selector = _this2.settings.contentSelector;
                var $loadedContent = $($(data).find(selector)[0] || $(data).filter(selector));
                var $newContent = $($loadedContent.html());
                _this2.contentEl.append($newContent);
                var $newButton = $(data).find('[data-component="More"]');
                var newURL = $newButton.attr('href');
                if ($newButton.length > 0 && newURL !== '') {
                    _this2.view.attr('href', newURL);
                } else {
                    Site_1.$body.removeClass('has-pending-infinite');
                    _this2.view.hide();
                    _this2.finished = true;
                }
                if (_this2.contentEl.data('Tiles')) {
                    var tiles = _this2.contentEl.data('Tiles');
                    tiles.onAppend($newContent, _this2.finished);
                } else {
                    Site_1.$window.trigger('resize');
                }
                _this2.trigger(Component_1.ComponentEvents.CHANGE, _this2.contentEl);
            }).fail(function (e) {
                console.warn('error', e);
            }).always(function () {
                _this2.view.removeClass('is-doing-request');
                setTimeout(function () {
                    _this2.pending = false;
                }, 250);
            });
        }
    }]);

    return More;
}(Component_1.Component);

exports.More = More;

},{"../PushStates":11,"../Site":13,"./Component":18}],31:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Playlist_1 = require("./Playlist");
var Utils = require("../Utils");
var Browser_1 = require("../Browser");
var Templates_1 = require("../Templates");
var Site_1 = require("../Site");
var Analytics_1 = require("../widgets/Analytics");

var PlayerEvents = function PlayerEvents() {
    _classCallCheck(this, PlayerEvents);
};

exports.PlayerEvents = PlayerEvents;
PlayerEvents.END = 'end';
PlayerEvents.NEXT = 'next';
PlayerEvents.PREV = 'prev';

var PlayerSize = function PlayerSize() {
    _classCallCheck(this, PlayerSize);
};

exports.PlayerSize = PlayerSize;
PlayerSize.COVER = 'cover';
PlayerSize.CONTAIN = 'contain';
PlayerSize.AUTO = 'auto';

var Player = function (_Component_1$Componen) {
    _inherits(Player, _Component_1$Componen);

    function Player(view, options) {
        _classCallCheck(this, Player);

        var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, view, options));

        _this.view = view;
        _this.isReady = false;
        _this.resize = function () {
            if (!_this.settings.ratio && _this.settings.width && _this.settings.height) {
                _this.settings.ratio = _this.settings.width / _this.settings.height;
            }
            var size = _this.settings.size;
            var mediaRatio = !!Browser_1.browser.mobile && _this.settings.ratio_mobile ? _this.settings.ratio_mobile : _this.settings.ratio;
            switch (size) {
                case PlayerSize.AUTO:
                    _this.view.css('padding-top', 100 / mediaRatio + '%').addClass('is-proportional');
                    break;
                case PlayerSize.CONTAIN:
                case PlayerSize.COVER:
                    var wrap = _this.view.parent();
                    var wrapWidth = wrap.width();
                    var wrapHeight = wrap.height();
                    var wrapRatio = wrapWidth / wrapHeight;
                    var wdt = void 0;
                    if (size === PlayerSize.CONTAIN) {
                        wdt = wrapRatio < mediaRatio ? wrapWidth : wrapHeight * mediaRatio;
                    } else if (size === PlayerSize.COVER) {
                        wdt = wrapRatio < mediaRatio ? wrapHeight * mediaRatio : wrapWidth;
                    }
                    var hgt = wdt / mediaRatio;
                    var marginLeft = Math.min(0, (wrapWidth - wdt) * 0.5);
                    var marginTop = Math.min(0, (wrapHeight - hgt) * 0.5);
                    _this.view.removeClass('is-proportional').css({
                        width: wdt,
                        height: hgt,
                        marginLeft: marginLeft,
                        marginTop: marginTop,
                        paddingTop: ''
                    });
                    break;
                default:
                    break;
            }
        };
        _this.onFullClick = function (e) {
            e.stopPropagation();
            _this.toggleFullscreen();
        };
        _this.onNextClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!_this.playlist.next()) {
                _this.trigger(PlayerEvents.NEXT);
            }
        };
        _this.onClick = function (e) {
            if ($(e.target).closest('.player__bar').length === 0 && $(e.target).closest('.playlist').length === 0) {
                e.preventDefault();
                e.stopPropagation();
                _this.toggle();
            }
        };
        _this.onKeyDown = function (e) {
            if (!!_this.settings.hotkeys && (e.keyCode || e.which) === Utils.keys.space) {
                e.preventDefault();
                e.stopPropagation();
                _this.toggle();
                return false;
            }
        };
        _this.onMouseUp = function (e) {
            if (!!_this.scrubbing) {
                e.stopPropagation();
                var seek = (e.pageX - _this.controls.scrubber.offset().left) / _this.controls.scrubber.width();
                _this.seek(seek);
            }
            _this.scrubbing = false;
            _this.volumeUpdating = false;
            _this.view.removeClass('is-scrubbing');
        };
        _this.onMouseLeave = function (e) {
            _this.scrubbing = false;
            _this.volumeUpdating = false;
            _this.view.removeClass('is-scrubbing');
        };
        _this.onMouseMove = function (e) {
            _this.view.addClass('is-mousemove');
            window.clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function () {
                _this.hideBar();
            }, 2000);
            if (!!_this.scrubbing) {
                e.stopPropagation();
                var posX = e.pageX - _this.controls.scrubber.offset().left;
                var width = _this.controls.scrubber.width();
                var value = Math.max(0, Math.min(1, posX / width));
                _this.controls.progress.width(value * 100 + '%');
                _this.seek(value);
            }
            if (!!_this.volumeUpdating) {
                e.stopPropagation();
                var _posX = e.pageX - _this.controls.volumeBar.offset().left;
                var _width = _this.controls.volumeBar.width();
                var _value = Math.max(0, Math.min(1, _posX / _width));
                _this.setVolume(_value);
            }
        };
        _this.onVolumeClick = function (e) {
            e.stopPropagation();
            var offset = _this.controls.volumeBar.offset(),
                valuePos = e.clientX - offset.left,
                value = valuePos / _this.controls.volumeBar.outerWidth();
            _this.setVolume(value);
        };
        _this.onVolumeButtonClick = function (e) {
            e.preventDefault();
            _this.toggleMute();
        };
        _this.onVolumeDown = function (e) {
            e.stopPropagation();
            _this.volumeUpdating = true;
        };
        _this.onScrubberDown = function (e) {
            e.stopPropagation();
            _this.scrubbing = true;
            _this.view.addClass('is-scrubbing');
        };
        _this.onScrubberClick = function (e) {
            e.stopPropagation();
            var seek = (e.pageX - $(e.currentTarget).offset().left) / $(e.currentTarget).width();
            _this.seek(seek);
        };
        _this.onToggleClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.toggle();
        };
        _this.onPrevClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!_this.playlist.prev()) {
                _this.trigger(PlayerEvents.PREV);
            }
        };
        _this.settings = $.extend({
            autoplay: false,
            loop: false,
            muted: false,
            controls: false,
            volume: 1,
            width: 480,
            height: 270,
            size: PlayerSize.AUTO,
            ready_time: 0.001,
            hotkeys: true
        }, options || view.data('options') || {});
        _this.uid = Utils.generateUID();
        _this.setup();
        _this.resize();
        _this.view.data('player', _this);
        if (typeof Player.instances === 'undefined') {
            Player.instances = [];
        }
        Player.instances.push(_this);
        _this.view.addClass('is-initialized');
        return _this;
    }

    _createClass(Player, [{
        key: "hide",
        value: function hide() {
            this.view.hide();
        }
    }, {
        key: "show",
        value: function show() {
            this.view.show();
        }
    }, {
        key: "loadPlaylist",
        value: function loadPlaylist(data) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                _this2.view.addClass('has-playlist');
                _this2.playlist.load(data);
                resolve(data[0]);
            });
        }
    }, {
        key: "unloadPlaylist",
        value: function unloadPlaylist() {
            this.view.removeClass('has-playlist is-playlist-open');
            this.playlist.unload();
        }
    }, {
        key: "turnOff",
        value: function turnOff() {
            if (!this.isPaused()) {
                this.wasPlaying = true;
                this.pause();
            } else {
                this.wasPlaying = false;
            }
        }
    }, {
        key: "turnOn",
        value: function turnOn() {
            if (!!this.wasPlaying) {
                this.play();
            }
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            this.showPlayerBar();
        }
    }, {
        key: "destroy",
        value: function destroy() {
            gsap.killTweensOf(this.view);
            Player.instances.splice(Player.instances.indexOf(this), 1);
            this.unbind();
            this.unload();
            this.view.data('Player', null);
            _get(Player.prototype.__proto__ || Object.getPrototypeOf(Player.prototype), "destroy", this).call(this);
        }
    }, {
        key: "toggleFullscreen",
        value: function toggleFullscreen() {
            if (screenfull.isEnabled) {
                screenfull.toggle(this.view[0]);
            }
        }
    }, {
        key: "buildUI",
        value: function buildUI() {
            var _this3 = this;

            var template = Templates_1.Templates.get(Templates_1.TemplateNames.PLAYER);
            var html = template.render({});
            this.view.append(html);
            this.controls = {};
            this.controls.poster = this.view.find('.player__poster');
            this.controls.title = this.view.find('.player__title');
            this.controls.playerBar = this.view.find('.player__bar');
            this.controls.toggleBtn = this.view.find('.player__playpause');
            this.controls.playBtn = this.view.find('.player__toggle');
            this.controls.fullBtn = this.view.find('.player__full');
            this.controls.volume = this.view.find('.player__volume');
            this.controls.volumeBar = this.view.find('.volume__bar');
            this.controls.volumeValue = this.view.find('.volume__value');
            this.controls.volumeButton = this.view.find('.volume__button');
            this.controls.scrubber = this.view.find('.player__scrubber');
            this.controls.duration = this.view.find('.player__duration');
            this.controls.time = this.view.find('.player__played');
            this.controls.loaded = this.view.find('.player__loaded');
            this.controls.progress = this.view.find('.player__progress');
            this.controls.prev = this.view.find('.player__prev');
            this.controls.next = this.view.find('.player__next');
            this.controls.captions = this.view.find('.player__captions');
            this.controls.cc = this.view.find('.player__cc');
            this.playlist = new Playlist_1.Playlist(this.view.find('.playlist'));
            this.playlist.on(Playlist_1.PlaylistEvents.TOGGLE, function (open) {
                _this3.view.toggleClass('is-playlist-open', open);
            });
            this.playlist.on(Playlist_1.PlaylistEvents.CHANGE, function (data) {
                _this3.load(data);
                _this3.play();
            });
            if (this.settings.playlist) {
                this.loadPlaylist(this.settings.playlist);
            }
            if (!!this.settings.autoplay) {
                this.view.addClass('has-autoplay');
            }
            this.view.addClass('has-controls');
            if (this.settings.muted) {
                this.setVolume(0);
            }
            this.loadPoster();
        }
    }, {
        key: "bind",
        value: function bind() {
            if (this.controls) {
                this.controls.toggleBtn.on('click', this.onToggleClick);
                this.controls.playBtn.on('click', this.onToggleClick);
                this.controls.fullBtn.on('click', this.onFullClick);
                this.controls.prev.on('click', this.onPrevClick);
                this.controls.next.on('click', this.onNextClick);
                this.controls.volumeButton.on('click', this.onVolumeButtonClick);
                this.controls.volumeBar.on('mousedown', this.onVolumeDown).on('click', this.onVolumeClick);
                this.controls.scrubber.on('mousedown', this.onScrubberDown).on('click', this.onScrubberClick);
            }
            this.view.off('.player').on('mousemove.player', this.onMouseMove).on('mouseup.player', this.onMouseUp).on('mouseleave.player', this.onMouseLeave).on('click.player', this.onClick);
            Site_1.$doc.off('.player-' + this.uid).on('keydown.player-' + this.uid, this.onKeyDown);
            this.bindPlayer();
        }
    }, {
        key: "unbind",
        value: function unbind() {
            if (this.controls) {
                this.controls.toggleBtn.off();
                this.controls.playBtn.off();
                this.controls.scrubber.off();
                this.controls.fullBtn.off();
                this.controls.volumeBar.off();
            }
            this.unbindPlayer();
        }
    }, {
        key: "onDurationChange",
        value: function onDurationChange(data) {}
    }, {
        key: "onProgress",
        value: function onProgress(data) {}
    }, {
        key: "onTimeupdate",
        value: function onTimeupdate(data) {}
    }, {
        key: "onCanplay",
        value: function onCanplay() {
            this.view.addClass('is-canplay').removeClass('is-error');
        }
    }, {
        key: "onPlay",
        value: function onPlay() {
            if (!this.view.hasClass('is-played') && this.settings.tracking) {
                Analytics_1.Analytics.sendEvent(this.settings.tracking[0], !this.settings.autoplay ? 'play' : 'autoplay', this.settings.tracking[1]);
            }
            this.view.addClass('is-played').removeClass('is-ended is-error');
            Player.pauseAll(this.uid);
        }
    }, {
        key: "onPlaying",
        value: function onPlaying() {
            this.view.addClass('is-playing').removeClass('is-loading is-error');
        }
    }, {
        key: "onPause",
        value: function onPause() {
            this.view.removeClass('is-playing');
        }
    }, {
        key: "onWaiting",
        value: function onWaiting() {
            this.view.removeClass('is-playing').addClass('is-loading');
        }
    }, {
        key: "onEnd",
        value: function onEnd() {
            this.view.removeClass('is-playing is-played is-started').addClass('is-ended');
            if (!this.settings.autoplay || !this.playlist.next()) {
                this.trigger(PlayerEvents.END);
            }
        }
    }, {
        key: "onError",
        value: function onError(e) {
            if (this.view && e.target.networkState && e.target.networkState === 3) {
                console.warn('Can\'t load media ' + e.target.src);
                this.view.addClass('is-error');
            }
        }
    }, {
        key: "loadPoster",
        value: function loadPoster() {
            if (this.settings.poster) {
                var poster = !!Browser_1.browser.mobile && this.settings.poster_mobile && this.settings.poster_mobile !== '' ? this.settings.poster_mobile : this.settings.poster;
                if (this.controls && this.controls.poster) {
                    this.controls.poster.css('background-image', 'url(' + poster + ')');
                }
            }
            this.view.toggleClass('has-poster', !!this.settings.poster);
        }
    }, {
        key: "resetTimeline",
        value: function resetTimeline() {
            if (this.controls) {
                this.controls.time.text(Utils.parseToTime(0));
                this.controls.progress.width(0);
                this.controls.loaded.width(0);
            }
        }
    }, {
        key: "updateTimeline",
        value: function updateTimeline(duration, buffered, current) {
            if (!duration || !this.controls) {
                return;
            }
            this.controls.duration.text(Utils.parseToTime(duration));
            if (current) {
                this.controls.time.text(Utils.parseToTime(current || 0));
            }
            if (buffered) {
                this.controls.loaded.width(Math.max(buffered, current || 0) / duration * 100 + '%');
            }
            if (current) {
                this.controls.progress.width((current || 0) / duration * 100 + '%');
                this.view.toggleClass('is-started', current > this.settings.ready_time);
            }
        }
    }, {
        key: "updateVolume",
        value: function updateVolume(volume) {
            this.view.toggleClass('is-muted', volume < 0.1);
            if (this.controls && this.controls.volumeValue) {
                this.controls.volumeValue.css({ width: volume * 100 + '%' });
            }
        }
    }, {
        key: "showPlayerBar",
        value: function showPlayerBar() {
            var _this4 = this;

            this.view.addClass('show-playerbar');
            setTimeout(function () {
                _this4.view.removeClass('show-playerbar');
            }, 2500);
        }
    }, {
        key: "hideBar",
        value: function hideBar() {
            this.view.removeClass('is-mousemove');
        }
    }], [{
        key: "pauseAll",
        value: function pauseAll(uid) {
            Player.instances.forEach(function (item) {
                if ((typeof uid === "undefined" ? "undefined" : _typeof(uid)) === undefined || uid !== item.uid) {
                    item.pause();
                }
            });
        }
    }, {
        key: "pauseAllIn",
        value: function pauseAllIn($el) {
            Player.instances.forEach(function (item) {
                if (item.view.closest($el)[0]) {
                    item.pause();
                }
            });
        }
    }]);

    return Player;
}(Component_1.Component);

exports.Player = Player;
Player.instances = [];

},{"../Browser":3,"../Site":13,"../Templates":14,"../Utils":15,"../widgets/Analytics":45,"./Component":18,"./Playlist":32}],32:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");

var PlaylistEvents = function PlaylistEvents() {
    _classCallCheck(this, PlaylistEvents);
};

exports.PlaylistEvents = PlaylistEvents;
PlaylistEvents.CHANGE = 'change';
PlaylistEvents.TOGGLE = 'toggle';

var Playlist = function (_Component_1$Componen) {
    _inherits(Playlist, _Component_1$Componen);

    function Playlist(view, options) {
        _classCallCheck(this, Playlist);

        var _this = _possibleConstructorReturn(this, (Playlist.__proto__ || Object.getPrototypeOf(Playlist)).call(this, view, options));

        _this.view = view;
        _this.options = options;
        _this.isOpen = false;
        _this.onPlaylistClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var index = $(e.currentTarget).closest('li').index();
            _this.update(index);
        };
        _this.onPlaylistToggleClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.isOpen = !_this.isOpen;
            _this.trigger(PlaylistEvents.TOGGLE, _this.isOpen);
        };
        _this.onDropdownChange = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var index = e.currentTarget.selectedIndex;
            var data = _this.data[index];
            _this.select(index);
            _this.trigger(PlaylistEvents.CHANGE, data);
        };
        _this.list = _this.view.find('ol');
        _this.toggle = _this.view.closest('.player').find('.js-playlist-toggle');
        _this.dropdown = _this.view.find('select');
        return _this;
    }

    _createClass(Playlist, [{
        key: "destroy",
        value: function destroy() {
            this.unload();
            _get(Playlist.prototype.__proto__ || Object.getPrototypeOf(Playlist.prototype), "destroy", this).call(this);
        }
    }, {
        key: "load",
        value: function load(data) {
            this.data = data;
            this.render(data);
            this.select(0);
            this.bind();
        }
    }, {
        key: "unload",
        value: function unload() {
            this.isOpen = false;
            this.list.empty();
            this.data = null;
            this.unbind();
            this.currentIndex = 0;
        }
    }, {
        key: "hide",
        value: function hide() {
            this.isOpen = false;
            this.trigger(PlaylistEvents.TOGGLE, false);
        }
    }, {
        key: "play",
        value: function play(index) {
            if (this.data && index <= this.data.length - 1 && index >= 0) {
                this.currentIndex = index;
                this.update(index);
            }
        }
    }, {
        key: "prev",
        value: function prev() {
            var index = this.currentIndex - 1;
            if (this.data && index >= 0) {
                this.currentIndex--;
                this.update(index);
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: "next",
        value: function next() {
            var index = this.currentIndex + 1;
            if (this.data && index <= this.data.length - 1) {
                this.currentIndex++;
                this.update(index);
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: "update",
        value: function update(index) {
            var data = this.data[index];
            this.select(index);
            this.trigger(PlaylistEvents.CHANGE, data);
        }
    }, {
        key: "render",
        value: function render(data) {
            var html = Twig.twig({
                data: $('#tmpl-playlist').text()
            }).render({ playlist: data });
            this.list.html(html);
            if (this.dropdown[0]) {
                var options = '';
                data.forEach(function (spot) {
                    options += '<option>' + spot.name + '</option>';
                });
                this.dropdown.html(options);
            }
        }
    }, {
        key: "select",
        value: function select(index) {
            this.currentIndex = index;
            this.list.find('li').eq(index).addClass('is-current').siblings().removeClass('is-current');
            this.toggle.html('<span>' + this.data[index].name + '</span>');
        }
    }, {
        key: "bind",
        value: function bind() {
            this.list.find('li a').off().on('click', this.onPlaylistClick);
            this.toggle.off().on('click', this.onPlaylistToggleClick);
            this.dropdown.off().on('change', this.onDropdownChange);
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.list.find('li a').off();
            this.toggle.off();
        }
    }]);

    return Playlist;
}(Component_1.Component);

exports.Playlist = Playlist;

},{"./Component":18}],33:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Breakpoint_1 = require("../Breakpoint");
var Templates_1 = require("../Templates");

var Projects = function (_Component_1$Componen) {
    _inherits(Projects, _Component_1$Componen);

    function Projects(view) {
        _classCallCheck(this, Projects);

        var _this = _possibleConstructorReturn(this, (Projects.__proto__ || Object.getPrototypeOf(Projects)).call(this, view));

        _this.view = view;
        _this.jsonProjects = new Array();
        _this.maxH = 200;
        _this.resize = function () {
            _this.setMargin();
        };
        console.log('Constructor Projects');
        _this.$projectContainer = _this.view.find('.projects__container');
        _this.$notfound = _this.view.find('.projects__notfound');
        _this.$buttonResetfilter = _this.view.find('.button--resetfilter');
        _this.$form = _this.view.find('form');
        _this.$scSector = _this.view.find('.sc__sector');
        _this.$scSponsor = _this.view.find('.sc__sponsor');
        _this.$scTime = _this.view.find('.sc__time');
        Promise.all([_this.setjsonProjects()]).then(function () {
            console.log('each sonProjects build template');
            var template = Templates_1.Templates.get(Templates_1.TemplateNames.PROJECT);
            $.each(_this.jsonProjects, function (key, value) {
                var html = template.render({ 'id': value.id, 'title': value.title, 'link': value.link, 'photo': value.photo, 'sector': value.sector });
                _this.$projectContainer.append(html);
            });
            setTimeout(function () {
                _this.setMargin();
            }, 10);
            _this.setOption(_this.$scSector);
            _this.setOption(_this.$scSponsor);
            _this.setOption(_this.$scTime);
            _this.$selected = _this.view.find('.selected');
            _this.$option = _this.view.find('.option');
            _this.unbind();
            _this.bind();
        });
        return _this;
    }

    _createClass(Projects, [{
        key: "onState",
        value: function onState() {
            return false;
        }
    }, {
        key: "setjsonProjects",
        value: function setjsonProjects() {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                console.log('start setjsonProjects');
                $.getJSON(_this2.view.data('json-projects'), function (data) {
                    _this2.jsonProjects = data;
                    console.log('________________________ set jsonProjects resolve');
                    console.log(_this2.jsonProjects);
                    resolve();
                });
            });
        }
    }, {
        key: "getMonthAbbreviation",
        value: function getMonthAbbreviation(monthNumber) {
            var months = ["STY", "LUT", "MAR", "KWI", "MAJ", "CZE", "LIP", "SIE", "WRZ", "PAŹ", "LIS", "GRU"];
            if (monthNumber < 1 || monthNumber > 12) {
                return "NIEZN";
            }
            return months[monthNumber - 1];
        }
    }, {
        key: "setOption",
        value: function setOption($el) {
            var _this3 = this;

            var temp = new Array();
            $.each(this.jsonProjects, function (key, value) {
                var val = void 0;
                if ($el.is(_this3.$scSector)) {
                    $.each(value.sector, function (key2, value2) {
                        val = value2;temp.push(val);
                    });
                }
                if ($el.is(_this3.$scSponsor)) {
                    $.each(value.sponsor, function (key2, value2) {
                        val = value2;temp.push(val);
                    });
                }
                if ($el.is(_this3.$scTime)) {}
            });
            temp = [].concat(_toConsumableArray(new Set(temp)));
            $.each(temp, function (key, value) {
                $el.find('.options').append('<button class="option button-novalidate" data-value="' + value + '" >' + value + '</button>');
                $el.find('select').append('<option tabindex="-1" value="' + value + '" >' + value + '</option>');
            });
            setTimeout(function () {
                var $options = $el.find('.options');
                var h = $options.outerHeight(true);
                $options.removeClass('scroll');
                console.log("h: " + h + " maxH: " + _this3.maxH);
                if (h >= _this3.maxH) {
                    h = _this3.maxH;
                    $options.addClass('scroll');
                    console.log("Dodano scroll");
                }
            }, 100);
        }
    }, {
        key: "filter",
        value: function filter() {
            var _this4 = this;

            console.log('_______________________________FILTER');
            var temp = new Array();
            $.each(this.jsonProjects, function (key, value) {
                $('[data-project-id="' + value.id + '"]').show();
                _this4.filterCheckArray(_this4.$scSector.find('select').val(), value.sector, value.id);
                _this4.filterCheckArray(_this4.$scSponsor.find('select').val(), value.sponsor, value.id);
                _this4.filterCheckArray(_this4.$scTime.find('select').val(), value.time, value.id);
            });
            console.log(this.$projectContainer.find('.part:visible').length);
            if (this.$projectContainer.find('.part:visible').length == 0) {
                this.$notfound.show();
            } else {
                this.$notfound.hide();
            }
            this.setMargin();
        }
    }, {
        key: "setMargin",
        value: function setMargin() {
            $('.part-margin').removeClass('part-margin');
            this.$projectContainer.find('.part:visible').each(function (index, el) {
                if (Breakpoint_1.breakpoint.desktop) {
                    if ((index + 1 - 2) % 3 === 0) {
                        $(el).addClass('part-margin');
                    }
                }
                if (Breakpoint_1.breakpoint.tablet) {
                    if ((index + 1) % 2 === 1) {
                        $(el).addClass('part-margin');
                    }
                }
            });
        }
    }, {
        key: "filterCheck",
        value: function filterCheck(optionSelected, value, id) {
            if (optionSelected != value && optionSelected != 'all') {
                $('[data-project-id="' + id + '"]').hide();
            }
        }
    }, {
        key: "filterCheckArray",
        value: function filterCheckArray(optionSelected, value, id) {
            if (!value.includes(optionSelected) && optionSelected !== 'all') {
                console.log(value + 'jest w ' + optionSelected + '<br><br>');
                $('[data-project-id="' + id + '"]').hide();
            }
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this.unbind();
            _get(Projects.prototype.__proto__ || Object.getPrototypeOf(Projects.prototype), "destroy", this).call(this);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this5 = this;

            this.$selected.off('.projects').on('click.projects', function (e) {
                return _this5.selectToggle(e);
            });
            this.$option.off('.projects').on('click.projects', function (e) {
                return _this5.optionClick(e);
            });
            this.$buttonResetfilter.off('.projects').on('click.projects', function (e) {
                return _this5.resetFilter(e);
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.$selected.off('.projects');
            this.$option.off('.projects');
        }
    }, {
        key: "resetFilter",
        value: function resetFilter(e) {
            e.preventDefault();
            this.$form[0].reset();
            this.$form.find('.select__container').each(function () {
                var $container = $(this);
                var $select = $container.find('select');
                var selectedValue = $select.val();
                var selectedText = $select.find('option:selected').text();
                $container.find('.selected .paragraph').text(selectedText);
                $container.find('.option').removeClass('option-hide');
                $container.find('.option').each(function () {
                    var $option = $(this);
                    if ($option.data('value') == selectedValue) {
                        $option.addClass('option-hide');
                    }
                });
            });
            this.filter();
        }
    }, {
        key: "selectToggle",
        value: function selectToggle(e) {
            e.preventDefault();
            e.stopPropagation();
            var select = $(e.currentTarget).closest('.select');
            var options = select.find('.options');
            var option = select.find('.option');
            var arrow = select.find('.select__arrow');
            if (select.hasClass('active')) {
                select.removeClass('active');
                gsap.to(arrow, 0.4, { rotation: 0, ease: 'sine.easeOut' });
                gsap.to(options, 0.4, {
                    'height': '0px',
                    'opacity': 0,
                    ease: 'sine.easeOut',
                    onComplete: function onComplete() {
                        $(window).resize();
                    }
                });
            } else {
                options.removeAttr('style');
                gsap.set(options, { 'display': 'block' });
                var optionsHeight = options.height();
                gsap.set(options, { 'height': '0px' });
                select.addClass('active');
                gsap.to(arrow, 0.4, { rotation: 180, ease: 'sine.easeOut' });
                gsap.to(options, 0.4, {
                    'opacity': 1,
                    'height': optionsHeight,
                    ease: 'sine.easeOut',
                    onComplete: function onComplete() {
                        $(window).resize();
                        gsap.set(options, { 'height': 'auto' });
                    }
                });
                gsap.fromTo(option, 0.4, { y: 20, opacity: 0 }, { y: 0, 'opacity': 1, delay: 0.1, stagger: 0.05, ease: 'sine.easeOut' });
            }
        }
    }, {
        key: "optionClick",
        value: function optionClick(e) {
            e.preventDefault();
            e.stopPropagation();
            var option = $(e.currentTarget);
            var dataValue = option.data('value');
            var textValue = option.text();
            var container = option.closest('.select__container');
            var selectDefault = container.find('select');
            var optionsDefault = selectDefault.find('option');
            var select = option.closest('.select');
            var options = select.find('.options');
            var selectedP = select.find('.selected .paragraph');
            selectedP.text(textValue);
            optionsDefault.each(function (i, el) {
                if ($(el).val() == dataValue) {
                    selectDefault.val(dataValue).change();
                }
            });
            this.selectToggle(e);
            this.filter();
            setTimeout(function () {
                options.find('.option').removeClass('option-hide');
                option.addClass('option-hide');
            }, 400);
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            var _this6 = this;

            return new Promise(function (resolve) {
                gsap.to(_this6.view, 0, {
                    onComplete: function onComplete() {
                        setTimeout(function () {
                            _this6.filter();
                        }, 100);
                        resolve(true);
                    }
                });
            });
        }
    }, {
        key: "animateOut",
        value: function animateOut() {
            return new Promise(function (resolve, reject) {
                resolve();
            });
        }
    }]);

    return Projects;
}(Component_1.Component);

exports.Projects = Projects;

},{"../Breakpoint":2,"../Templates":14,"./Component":18}],34:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");

var RegistrationEvent = function (_Component_1$Componen) {
    _inherits(RegistrationEvent, _Component_1$Componen);

    function RegistrationEvent(view) {
        _classCallCheck(this, RegistrationEvent);

        var _this = _possibleConstructorReturn(this, (RegistrationEvent.__proto__ || Object.getPrototypeOf(RegistrationEvent)).call(this, view));

        _this.view = view;
        _this.$selectTypeUser = $("select[name='type_user']");
        _this.$selected = _this.view.find('.selected');
        _this.$option = _this.view.find('.option');
        _this.$typeOrganization = _this.view.find('.type--organization');
        _this.siteLang = $('html').attr('lang');
        _this.unbind();
        _this.bind();
        $("#type_organization").removeAttr('required');
        $("#name_organization").removeAttr('required');
        _this.$typeOrganization.hide();
        return _this;
    }

    _createClass(RegistrationEvent, [{
        key: "bind",
        value: function bind() {
            var _this2 = this;

            this.$selected.off('.add-object').on('click.add-object', function (e) {
                return _this2.selectToggle(e);
            });
            this.$option.off('.add-object').on('click.add-object', function (e) {
                return _this2.optionClick(e);
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.$selected.off('.add-object');
            this.$option.off('.add-object');
            this.$selectTypeUser.off('.add-object');
        }
    }, {
        key: "selectToggle",
        value: function selectToggle(e) {
            e.preventDefault();
            e.stopPropagation();
            var select = $(e.currentTarget).closest('.select');
            var options = select.find('.options');
            var option = select.find('.option');
            var arrow = select.find('.select__arrow');
            if (select.hasClass('active')) {
                select.removeClass('active');
                gsap.to(arrow, 0.4, { rotation: 0, ease: 'sine.easeOut' });
                gsap.to(options, 0.4, {
                    'height': '0px',
                    'opacity': 0,
                    ease: 'sine.easeOut',
                    onComplete: function onComplete() {
                        $(window).resize();
                    }
                });
            } else {
                options.removeAttr('style');
                gsap.set(options, { 'display': 'block' });
                var optionsHeight = options.height();
                gsap.set(options, { 'height': '0px' });
                select.addClass('active');
                gsap.to(arrow, 0.4, { rotation: 180, ease: 'sine.easeOut' });
                gsap.to(options, 0.4, {
                    'opacity': 1,
                    'height': optionsHeight,
                    ease: 'sine.easeOut',
                    onComplete: function onComplete() {
                        $(window).resize();
                        gsap.set(options, { 'height': 'auto' });
                    }
                });
                gsap.fromTo(option, 0.4, { y: 20, opacity: 0 }, { y: 0, 'opacity': 1, delay: 0.1, stagger: 0.05, ease: 'sine.easeOut' });
            }
        }
    }, {
        key: "optionClick",
        value: function optionClick(e) {
            e.preventDefault();
            e.stopPropagation();
            var option = $(e.currentTarget);
            var dataValue = option.data('value');
            var textValue = option.text();
            var container = option.closest('.select__container');
            var selectDefault = container.find('select');
            var optionsDefault = selectDefault.find('option');
            var select = option.closest('.select');
            var options = select.find('.options');
            var selectedP = select.find('.selected .paragraph');
            selectedP.text(textValue);
            optionsDefault.each(function (i, el) {
                if ($(el).val() == dataValue) {
                    selectDefault.val(dataValue).change();
                }
            });
            if (container.hasClass('sc__typeuser')) {
                if (dataValue == 'Organizacja') {
                    this.$typeOrganization.show();
                    $("#type_organization").attr("required", "");
                    $("#name_organization").attr("required", "");
                } else if (dataValue == 'Osoba fizyczna') {
                    this.$typeOrganization.hide();
                    $("#type_organization").removeAttr('required');
                    $("#name_organization").removeAttr('required');
                }
                this.unbind();
                this.bind();
            }
            this.selectToggle(e);
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            var _this3 = this;

            return new Promise(function (resolve) {
                gsap.to(_this3.view, 5, {
                    onComplete: function onComplete() {
                        resolve(true);
                    }
                });
            });
        }
    }, {
        key: "destroy",
        value: function destroy() {
            _get(RegistrationEvent.prototype.__proto__ || Object.getPrototypeOf(RegistrationEvent.prototype), "destroy", this).call(this);
        }
    }]);

    return RegistrationEvent;
}(Component_1.Component);

exports.RegistrationEvent = RegistrationEvent;

},{"./Component":18}],35:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Site_1 = require("../Site");
var Swipe_1 = require("./Swipe");
var Utils = require("../Utils");
var Breakpoint_1 = require("../Breakpoint");
var Scrolling_1 = require("../Scrolling");

var Slider = function (_Component_1$Componen) {
    _inherits(Slider, _Component_1$Componen);

    function Slider(view, options) {
        _classCallCheck(this, Slider);

        var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, view));

        _this.view = view;
        _this.options = options;
        _this.transform = {
            skewY: 0,
            scaleY: 1,
            translateY: 0
        };
        _this.disabled = false;
        _this.initialized = false;
        _this.animating = false;
        _this.current = { x: 0, startX: 0 };
        _this.targetX = 0;
        _this.shiftX = 0;
        _this.pixelRatio = 1;
        _this.infinite = false;
        _this.cache = [];
        _this.autoplayDisabled = false;
        _this.resize = function () {
            if (_this.wrap.length < 1 || _this.amount < 1) {
                return;
            }
            _this.disabled = _this.amount < 2 || _this.settings.breakpoints.indexOf(Breakpoint_1.breakpoint.value) < 0;
            _this.swipe.toggle(!_this.disabled);
            _this.width = _this.items.eq(1).outerWidth(true);
            var margin = parseInt(_this.items.eq(1).css("margin-left"));
            _this.totalWidth = _this.width * _this.amount - margin;
            _this.saveCache();
            _this.alignPosition(true);
        };
        _this.updatePosition = function () {
            var x = _this.current.x;
            var bounceFactor = !!_this.swipe.swiping ? 0.25 : 0.6;
            var rightDiff = !!_this.settings.bounce ? (x + _this.totalWidth - _this.width) * bounceFactor : 0;
            var leftDiff = !!_this.settings.bounce ? x * bounceFactor : 0;
            x = x < -_this.totalWidth + _this.width ? -_this.totalWidth + _this.width + rightDiff : x;
            x = x > 0 ? 0 + leftDiff : x;
            _this.current.x = x;
            gsap.set(_this.wrap, { x: _this.current.x + _this.shiftX });
            var index = _this.getCurrentIndex();
            _this.numberEl.text(index + 1 + '.');
            _this.items.eq(index).add(_this.items.eq(index + _this.amount));
            if (_this.cache.length > 1) {
                var start = !_this.infinite ? Math.max(0, index - 1) : 0,
                    end = !_this.infinite ? index + 2 : _this.children.length;
            } else {
                gsap.set(_this.children, { x: 0 });
            }
            _this.updateArrows(index);
        };
        _this.settings = $.extend({
            valignImages: true,
            showSiblings: true,
            item: '.js-slider-item',
            child: '.js-slider-child',
            wrap: '.js-slider-wrap',
            prev: '.js-slider-prev',
            next: '.js-slider-next',
            number: '.js-slider-number',
            disableMouse: false,
            disableTouch: false,
            mousewheel: true,
            loop: false,
            keyBindings: true,
            clickSiblings: true,
            scaleImages: false,
            shiftLeft: false,
            bounce: true,
            breakpoints: ['phone', 'tablet', 'desktop']
        }, options || {});
        _this.arrowPrev = _this.view.find(_this.settings.prev);
        _this.arrowNext = _this.view.find(_this.settings.next);
        _this.numberEl = _this.view.find(_this.settings.number);
        _this.wrap = _this.view.find(_this.settings.wrap);
        _this.items = _this.view.find(_this.settings.item);
        _this.amount = _this.items.length;
        _this.pixelRatio = Site_1.pixelRatio;
        _this.disabled = false;
        if (_this.wrap.length < 1 || _this.amount < 1) {
            console.warn('There is no wrap or item element!');
            return _possibleConstructorReturn(_this);
        }
        _this.uid = Utils.generateUID();
        _this.swipe = new Swipe_1.Swipe(_this.wrap, {
            disableMouse: _this.settings.disableMouse,
            disableTouch: _this.settings.disableTouch
        });
        if (_this.amount > 2 && !!_this.settings.loop) {
            _this.infinite = true;
            _this.wrap.append(_this.items.slice(0, 3).clone(true));
            _this.items = _this.view.find(_this.settings.item);
        }
        if (_this.amount <= 2) {
            _this.arrowNext.remove();
            _this.arrowPrev.remove();
            _this.numberEl.remove();
        }
        _this.children = _this.items.find(_this.settings.child);
        _this.children = _this.children.length < 1 ? _this.items.children() : _this.children;
        if (!_this.disabled) {
            _this.bind();
            setTimeout(function () {
                _this.resize();
            }, 10);
            _this.initialized = true;
        }
        _this.view.data('Slider', _this);
        return _this;
    }

    _createClass(Slider, [{
        key: "destroy",
        value: function destroy() {
            this.unbind();
            gsap.killTweensOf(this.current);
            gsap.killTweensOf(this.transform);
            this.initialized = false;
            this.cache = null;
            this.arrowPrev = null;
            this.arrowNext = null;
            this.numberEl = null;
            this.items = null;
            this.children = null;
            this.images = null;
            this.aligns = null;
            this.wrap = null;
            this.swipe = null;
            this.context = null;
            this.uid = null;
            _get(Slider.prototype.__proto__ || Object.getPrototypeOf(Slider.prototype), "destroy", this).call(this);
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            if (this.wrap.length < 1 || this.amount < 1) {
                return;
            }
            this.updatePosition();
            gsap.from(this.transform, {
                duration: 0.8,
                skewY: -6,
                scaleY: 1.2,
                translateY: -100,
                delay: 0.2,
                ease: Site_1.easing,
                onUpdate: this.updatePosition
            });
        }
    }, {
        key: "setInScreen",
        value: function setInScreen() {
            Scrolling_1.Scrolling.scrollToElement(this.view.closest('section'), false, 0);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this2 = this;

            this.arrowPrev.off('.slider').on('click.slider', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this2.go(-1);
            });
            this.arrowNext.off('.slider').on('click.slider', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this2.go(+1);
            });
            this.swipe.on(Swipe_1.SwipeEvents.START, function (data) {
                return _this2.onSwipeStart(data);
            });
            this.swipe.on(Swipe_1.SwipeEvents.UPDATE, function (data) {
                return _this2.onSwipeUpdate(data);
            });
            this.swipe.on(Swipe_1.SwipeEvents.END, function (data) {
                return _this2.onSwipeEnd(data);
            });
            this.items.imagesLoaded().progress(function (instance, image) {
                return _this2.saveCache();
            }).done(function () {
                return _this2.updatePosition();
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.arrowPrev.off('.slider');
            this.arrowNext.off('.slider');
            if (this.swipe) {
                this.swipe.destroy();
            }
            Site_1.$doc.off('.slider-' + this.uid);
        }
    }, {
        key: "saveCache",
        value: function saveCache() {
            var _this3 = this;

            var temp = [];
            var offset = this.settings.showSiblings ? 50 : -20;
            this.children.each(function (index, child) {
                var $child = $(child);
                var wdt = $child.outerWidth();
                temp.push((wdt !== 0 ? (_this3.width - wdt) * 0.5 : 0) + offset);
            });
            this.cache = temp;
        }
    }, {
        key: "alignImagesVertically",
        value: function alignImagesVertically() {
            if (!!this.settings.valignImages && this.amount >= 2) {
                var maxHeight = Math.max.apply(null, this.children.toArray().map(function (child) {
                    return $(child).height();
                }));
                this.children.each(function (index, child) {
                    var $child = $(child);
                    var hgt = $child.height();
                    var mT = hgt > 0 ? (maxHeight - hgt) * 0.5 : '';
                    $child.css({ marginTop: mT });
                });
            }
        }
    }, {
        key: "go",
        value: function go(direction, autoplay) {
            this.targetX = this.current.x - direction * this.width;
            this.alignPosition(false, autoplay);
        }
    }, {
        key: "goTo",
        value: function goTo(el, fast) {
            if (!this.disabled) {
                var index = typeof el === 'number' ? el : el.index();
                this.targetX = -index * this.width;
                this.alignPosition(fast);
            }
        }
    }, {
        key: "alignPosition",
        value: function alignPosition(fast, slow) {
            var _this4 = this;

            this.animating = true;
            gsap.killTweensOf(this.current, { x: true });
            this.current.x += this.shiftX;
            this.targetX = this.targetX === null ? null : this.targetX + this.shiftX;
            this.shiftX = 0;
            var x = this.targetX === null ? this.current.x : this.targetX;
            x = Math.floor(x / this.width + 0.5) * this.width;
            x = !this.infinite ? Math.max(-this.amount * this.width, x) : x;
            x = !this.infinite ? Math.min(0, x) : x;
            if (this.totalWidth + x < this.view.width()) {
                x = -this.totalWidth + this.view.width() - this.width;
            } else if (this.targetX > 0) {
                x = 0;
            }
            gsap.to(this.current, {
                duration: !fast ? !slow ? 0.8 : 1.2 : 0,
                x: x,
                ease: Site_1.easing,
                onUpdate: function onUpdate() {
                    return _this4.updatePosition();
                },
                onComplete: function onComplete() {
                    _this4.animating = false;
                    _this4.targetX = null;
                }
            });
        }
    }, {
        key: "updateArrows",
        value: function updateArrows(index) {
            index = typeof index === 'undefined' ? this.getCurrentIndex() : index;
            this.arrowPrev.toggleClass('is-disabled', !this.infinite && index <= 0);
            if (!Breakpoint_1.breakpoint.desktop) {
                this.arrowNext.toggleClass('is-disabled', !this.infinite && index >= this.amount - 1);
            } else {
                this.arrowNext.toggleClass('is-disabled', !this.infinite && index >= this.amount - 2);
            }
        }
    }, {
        key: "getCurrentIndex",
        value: function getCurrentIndex() {
            var x = Math.floor(-(this.current.x + this.shiftX) / this.width + 0.5);
            x = !this.infinite ? Math.min(this.amount - 1, x) : x;
            var index = x % this.amount;
            return index;
        }
    }, {
        key: "onSwipeStart",
        value: function onSwipeStart(data) {
            if (!this.disabled) {
                gsap.killTweensOf(this.current);
                this.current.startX = this.current.x;
            }
        }
    }, {
        key: "onSwipeUpdate",
        value: function onSwipeUpdate(data) {
            if (!this.disabled && !!data.deltaX) {
                this.current.x = this.current.startX + data.deltaX;
                this.updatePosition();
            }
        }
    }, {
        key: "onSwipeEnd",
        value: function onSwipeEnd(data) {
            if (!this.disabled) {
                var dir = { 'left': -1, 'right': 1, 'none': 0, 'click': 0 }[data.direction];
                this.targetX = this.current.x + dir * this.width * 0.45;
                var link = this.items.eq(this.getCurrentIndex()).find('a')[0];
                if (data.direction === Swipe_1.SwipeDirections.CLICK && link) {} else {
                    this.alignPosition();
                }
            }
        }
    }]);

    return Slider;
}(Component_1.Component);

exports.Slider = Slider;
Slider.CANVAS_SKEW = 15;

},{"../Breakpoint":2,"../Scrolling":12,"../Site":13,"../Utils":15,"./Component":18,"./Swipe":38}],36:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Site_1 = require("../Site");

var SliderDoubleRow = function (_Component_1$Componen) {
    _inherits(SliderDoubleRow, _Component_1$Componen);

    function SliderDoubleRow(view) {
        _classCallCheck(this, SliderDoubleRow);

        var _this = _possibleConstructorReturn(this, (SliderDoubleRow.__proto__ || Object.getPrototypeOf(SliderDoubleRow)).call(this, view));

        _this.view = view;
        _this.jsonItems = new Array();
        _this.currentIndex = -1;
        _this.amount = -1;
        _this.isAnimating = false;
        _this.time = 0.8;
        _this.tempObject = { dashoffset: 0 };
        _this.autoplayTime = 5;
        _this.resize = function () {};
        _this.setJsonItems().then(function () {
            return _this.init();
        });
        _this.$name = _this.view.find('.slider-double-row__name');
        _this.$description = _this.view.find('.slider-double-row__description');
        _this.$img1 = _this.view.find('.slider-double-row__img1');
        _this.$img2 = _this.view.find('.slider-double-row__img2');
        _this.$link = _this.view.find('.slider-double-row__link');
        _this.$arrowPrev = _this.view.find('.js-slider-prev');
        _this.$arrowNext = _this.view.find('.js-slider-next');
        _this.$arrowArrows = _this.view.find('.slider-double-row__arrows');
        _this.$index = _this.view.find('.slider-double-row__index');
        _this.$curtain1 = _this.view.find('.slider-double-row__curtain1');
        _this.$curtain2 = _this.view.find('.slider-double-row__curtain2');
        _this.$content1 = _this.view.find('.slider-double-row__content1');
        _this.$more = _this.view.find('.button--more');
        setTimeout(function () {
            _this.autoplayLoop();
        }, 1000);
        _this.bind();
        return _this;
    }

    _createClass(SliderDoubleRow, [{
        key: "destroy",
        value: function destroy() {
            this.stopAutoplay();
            this.unbind();
            _get(SliderDoubleRow.prototype.__proto__ || Object.getPrototypeOf(SliderDoubleRow.prototype), "destroy", this).call(this);
        }
    }, {
        key: "stopAutoplay",
        value: function stopAutoplay() {
            gsap.killTweensOf(this.tempObject);
        }
    }, {
        key: "autoplayLoop",
        value: function autoplayLoop() {
            var indexNew = this.currentIndex + 1;
            this.goTo(indexNew, 'next', false);
            this.startAutoplay();
        }
    }, {
        key: "startAutoplay",
        value: function startAutoplay() {
            var _this2 = this;

            gsap.fromTo(this.tempObject, this.autoplayTime, { dashoffset: 220 }, { dashoffset: 0,
                onUpdate: function onUpdate() {}, onUpdateParams: [this.tempObject.dashoffset],
                onComplete: function onComplete() {
                    _this2.autoplayLoop();
                }
            });
        }
    }, {
        key: "init",
        value: function init() {
            var _this3 = this;

            this.items = new Array();
            $.each(this.jsonItems['items'], function (key1, value1) {
                _this3.items.push(value1);
            });
            this.amount = this.items.length;
            if (this.amount < 2) {
                this.$arrowArrows.remove();
            }
            this.goTo(0, 'next', false);
        }
    }, {
        key: "goTo",
        value: function goTo(index, direction, fast) {
            var _this4 = this;

            if (!this.isAnimating) {
                if (this.currentIndex != index) {
                    this.isAnimating = true;
                    if (this.amount - 1 < index) {
                        index = 0;
                    } else if (0 > index) {
                        index = this.amount - 1;
                    }
                    this.currentIndex = index;
                    gsap.to(this.$name, this.time, { opacity: '0', y: 30, ease: Site_1.easing, onComplete: function onComplete() {
                            _this4.$name.html(_this4.items[_this4.currentIndex]['name']);
                            gsap.to(_this4.$name, _this4.time, { opacity: '1', y: 0, ease: Site_1.easing });
                        }
                    });
                    var hOld = this.$content1.outerHeight(true);
                    gsap.to([this.$description, this.$link, this.$index], this.time, { opacity: '0', y: 30, ease: Site_1.easing, delay: 0.2, onComplete: function onComplete() {
                            _this4.$description.html(_this4.items[_this4.currentIndex]['description']);
                            _this4.$link.attr('href', _this4.items[_this4.currentIndex]['link']);
                            _this4.$link.attr('title', 'link ' + _this4.items[_this4.currentIndex]['name']);
                            _this4.$link.attr('aria-label', 'link ' + _this4.items[_this4.currentIndex]['name']);
                            _this4.$more.attr('href', _this4.items[_this4.currentIndex]['link']);
                            _this4.$more.attr('title', 'link ' + _this4.items[_this4.currentIndex]['name']);
                            _this4.$more.attr('aria-label', 'link ' + _this4.items[_this4.currentIndex]['name']);
                            _this4.$index.html(_this4.currentIndex + 1 + "<span>/" + _this4.amount + "</span>");
                            gsap.to([_this4.$description, _this4.$link, _this4.$index], _this4.time, { opacity: '1', y: 0, ease: Site_1.easing });
                            gsap.set(_this4.$content1, { display: 'block', height: '' });
                            var h = _this4.$content1.outerHeight(true);
                            if (h < 300) {
                                h = 300;
                            }
                            gsap.set(_this4.$content1, { height: hOld });
                            gsap.to(_this4.$content1, _this4.time, { height: h, ease: Site_1.easing });
                        }
                    });
                    gsap.set(this.$curtain2, { display: 'block', translateX: direction == 'next' ? '100%' : '-100%' });
                    gsap.to(this.$curtain2, this.time, {
                        translateX: '0%',
                        ease: Site_1.easing,
                        onComplete: function onComplete() {
                            _this4.$img2.attr('src', _this4.items[_this4.currentIndex]['img2']);
                            _this4.$img2.attr('alt', _this4.items[_this4.currentIndex]['alt2']);
                            gsap.to(_this4.$curtain2, _this4.time, {
                                translateX: direction == 'next' ? '-100%' : '100%',
                                ease: Site_1.easing
                            });
                        }
                    });
                    gsap.set(this.$curtain1, { display: 'block', translateX: direction == 'next' ? '100%' : '-100%' });
                    gsap.to(this.$curtain1, this.time, {
                        delay: this.time / 2,
                        translateX: '0%',
                        ease: Site_1.easing,
                        onComplete: function onComplete() {
                            _this4.$img1.attr('src', _this4.items[_this4.currentIndex]['img1']);
                            _this4.$img1.attr('alt', _this4.items[_this4.currentIndex]['alt1']);
                            gsap.to(_this4.$curtain1, _this4.time, {
                                translateX: direction == 'next' ? '-100%' : '100%',
                                ease: Site_1.easing,
                                onComplete: function onComplete() {
                                    _this4.isAnimating = false;
                                }
                            });
                        }
                    });
                }
            }
        }
    }, {
        key: "setJsonItems",
        value: function setJsonItems() {
            var _this5 = this;

            return new Promise(function (resolve, reject) {
                _this5.jsonItems = _this5.view.data('json');
                resolve();
            });
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this6 = this;

            this.$arrowPrev.off('.slider-double-row').on('click.slider-double-row', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this6.stopAutoplay();
                _this6.goTo(_this6.currentIndex - 1, 'prev', false);
            });
            this.$arrowNext.off('.slider-double-row').on('click.slider-double-row', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this6.stopAutoplay();
                _this6.goTo(_this6.currentIndex + 1, 'next', false);
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.$arrowPrev.off('.slider-double-row');
            this.$arrowNext.off('.slider-double-row');
        }
    }]);

    return SliderDoubleRow;
}(Component_1.Component);

exports.SliderDoubleRow = SliderDoubleRow;

},{"../Site":13,"./Component":18}],37:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Site_1 = require("../Site");
var Breakpoint_1 = require("../Breakpoint");

var SliderImage = function (_Component_1$Componen) {
    _inherits(SliderImage, _Component_1$Componen);

    function SliderImage(view) {
        _classCallCheck(this, SliderImage);

        var _this = _possibleConstructorReturn(this, (SliderImage.__proto__ || Object.getPrototypeOf(SliderImage)).call(this, view));

        _this.view = view;
        _this.currentNumber = -1;
        _this.currentLastNumber = -1;
        _this.time = 1;
        _this.animating = false;
        _this.resize = function () {
            setTimeout(function () {
                _this.$items.each(function (i, el) {
                    var item = $(el);
                    _this.setSize(item);
                });
            }, 1);
        };
        _this.$items = _this.view.find('.js-slider-item');
        _this.$number = _this.view.find('.js-number');
        _this.$arrowPrev = _this.view.find('.js-arrow-prev');
        _this.$arrowNext = _this.view.find('.js-arrow-next');
        _this.$arrowArrows = _this.view.find('.js-arrows');
        _this.$buttonFull = _this.view.find('.js-full');
        _this.amount = _this.$items.length;
        setTimeout(function () {
            _this.goTo(0, 'next', true);
        }, 100);
        if (_this.amount < 2) {
            _this.$arrowArrows.remove();
        }
        _this.bind();
        _this.resize();
        _this.view.data('SliderImage', _this);
        return _this;
    }

    _createClass(SliderImage, [{
        key: "destroy",
        value: function destroy() {
            this.unbind();
            this.$items = null;
            this.$number = null;
            this.$arrowPrev = null;
            this.$arrowNext = null;
            this.$arrowArrows = null;
            this.amount = null;
            _get(SliderImage.prototype.__proto__ || Object.getPrototypeOf(SliderImage.prototype), "destroy", this).call(this);
        }
    }, {
        key: "setSize",
        value: function setSize(item) {
            var $container = item;
            var $imageinfo = item.find('.slider-image__imageinfo');
            var $imageinfoScroll = item.find('.slider-image__imageinfo__scroll');
            gsap.set(item, { display: 'block' });
            gsap.set($imageinfo, { display: 'block', height: '' });
            var h = $imageinfo.outerHeight(true);
            $imageinfo.removeClass('scroll');
            if (!item.hasClass('is-current')) {
                gsap.set(item, { display: 'none' });
            }
            var maxH = $container.height() - (Breakpoint_1.breakpoint.desktop ? 140 : 80);
            if (h > maxH) {
                h = maxH;
                gsap.set($imageinfo, { height: maxH + 'px' });
                $imageinfoScroll.addClass('scroll');
            } else {
                $imageinfoScroll.removeClass('scroll');
            }
            item.data('h', h);
        }
    }, {
        key: "animateIn",
        value: function animateIn() {}
    }, {
        key: "bind",
        value: function bind() {
            var _this2 = this;

            this.$arrowPrev.off('.sliderimage').on('click.sliderimage', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this2.goTo(_this2.currentNumber - 1, 'prev', false);
            });
            this.$arrowNext.off('.sliderimage').on('click.sliderimage', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this2.goTo(_this2.currentNumber + 1, 'next', false);
            });
            this.$items.each(function (i, el) {
                var item = $(el);
                var $buttonImageinfo = item.find('.button--imageinfo');
                $buttonImageinfo.off('.slidermedia').on('click.slidermedia', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var item = $(e.currentTarget).closest('.js-slider-item');
                    _this2.toggle(item);
                });
            });
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.$arrowPrev.off('.sliderimage');
            this.$arrowNext.off('.sliderimage');
        }
    }, {
        key: "goTo",
        value: function goTo(number, direction, fast) {
            var _this3 = this;

            if (!this.animating) {
                if (this.currentNumber != number) {
                    this.view.find('.is-current').removeClass('is-current');
                    this.animating = true;
                    if (this.amount - 1 < number) {
                        number = 0;
                    } else if (0 > number) {
                        number = this.amount - 1;
                    }
                    this.currentLastNumber = this.currentNumber;
                    this.currentNumber = number;
                    var indexText = this.currentNumber + 1;
                    this.$number.html(indexText + '/' + this.amount);
                    var itemLast = this.$items.eq(this.currentLastNumber);
                    var item = this.$items.eq(this.currentNumber);
                    gsap.set(item, { display: 'block', translateX: '100%' });
                    item.addClass('is-current');
                    var url = item.data('url');
                    this.$buttonFull.attr('href', url);
                    gsap.to(itemLast, fast ? 0 : this.time, {
                        translateX: direction == 'next' ? '-100%' : '100%',
                        ease: Site_1.easing
                    });
                    gsap.fromTo(item, fast ? 0 : this.time, {
                        translateX: direction == 'next' ? '100%' : '-100%'
                    }, {
                        translateX: '0%',
                        ease: Site_1.easing,
                        onComplete: function onComplete() {
                            _this3.animating = false;
                        }
                    });
                }
            }
        }
    }, {
        key: "toggle",
        value: function toggle(item) {
            if (!item.hasClass('shown')) {
                this.show(item);
            } else {
                this.hide(item);
            }
        }
    }, {
        key: "show",
        value: function show(item, fast) {
            var _this4 = this;

            if (!this.animating) {
                this.animating = true;
                var $buttonImageinfo = item.find('.button--imageinfo');
                var $imageinfo = item.find('.slider-image__imageinfo');
                var h = parseFloat(item.data('h'));
                item.addClass('shown');
                $buttonImageinfo.find('.svg-info').hide();
                $buttonImageinfo.find('.svg-closer').show();
                gsap.to($imageinfo, {
                    duration: !fast ? this.time : 0,
                    y: '0',
                    ease: Site_1.easing,
                    onComplete: function onComplete() {
                        _this4.animating = false;
                    }
                });
                gsap.to($buttonImageinfo, {
                    duration: !fast ? this.time : 0,
                    y: -h,
                    ease: Site_1.easing
                });
            }
        }
    }, {
        key: "hide",
        value: function hide(item, fast, delay) {
            var _this5 = this;

            if (!this.animating) {
                this.animating = true;
                var $buttonImageinfo = item.find('.button--imageinfo');
                var $imageinfo = item.find('.slider-image__imageinfo');
                gsap.to($imageinfo, {
                    duration: !fast ? this.time : 0,
                    y: '100%',
                    ease: Site_1.easing,
                    delay: delay,
                    onComplete: function onComplete() {
                        item.removeClass('shown');
                        $buttonImageinfo.find('.svg-info').show();
                        $buttonImageinfo.find('.svg-closer').hide();
                        _this5.animating = false;
                    }
                });
                gsap.to($buttonImageinfo, {
                    duration: !fast ? this.time : 0,
                    y: 0,
                    ease: Site_1.easing
                });
            }
        }
    }]);

    return SliderImage;
}(Component_1.Component);

exports.SliderImage = SliderImage;

},{"../Breakpoint":2,"../Site":13,"./Component":18}],38:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Utils = require("../Utils");
var Site_1 = require("../Site");

var SwipeEvents = function SwipeEvents() {
    _classCallCheck(this, SwipeEvents);
};

exports.SwipeEvents = SwipeEvents;
SwipeEvents.START = 'start';
SwipeEvents.UPDATE = 'update';
SwipeEvents.END = 'end';

var SwipeAxes = function SwipeAxes() {
    _classCallCheck(this, SwipeAxes);
};

exports.SwipeAxes = SwipeAxes;
SwipeAxes.HORIZONTAL = 'h';
SwipeAxes.VERTICAL = 'v';

var SwipeDirections = function SwipeDirections() {
    _classCallCheck(this, SwipeDirections);
};

exports.SwipeDirections = SwipeDirections;
SwipeDirections.LEFT = 'left';
SwipeDirections.RIGHT = 'right';
SwipeDirections.UP = 'up';
SwipeDirections.DOWN = 'down';
SwipeDirections.NONE = 'none';
SwipeDirections.CLICK = 'click';

var Swipe = function (_Component_1$Componen) {
    _inherits(Swipe, _Component_1$Componen);

    function Swipe(view, options) {
        _classCallCheck(this, Swipe);

        var _this = _possibleConstructorReturn(this, (Swipe.__proto__ || Object.getPrototypeOf(Swipe)).call(this, view, options));

        _this.view = view;
        _this.options = options;
        _this.resize = function () {
            var scrollTop = window.scrollY ? window.scrollY : Site_1.$window.scrollTop();
            _this.offsetX = _this.view.offset().left;
            _this.offsetY = _this.view.offset().top - scrollTop;
        };
        _this.onMouseDown = function (e) {
            if (e.which && e.which === 3 || e.button && e.button === 2) {
                return;
            }
            e.preventDefault();
            _this.mouse.startX = (e.clientX || e.pageX) - _this.offsetX;
            _this.mouse.startY = (e.clientY || e.pageY) - _this.offsetY;
            _this.startSwipe();
        };
        _this.onMouseMove = function (e) {
            e.preventDefault();
            if (!!_this.swiping) {
                _this.mouse.x = (e.clientX || e.pageX) - _this.offsetX;
                _this.mouse.y = (e.clientY || e.pageY) - _this.offsetY;
                var diffX = Math.abs(_this.mouse.x - _this.mouse.startX);
                var diffY = Math.abs(_this.mouse.y - _this.mouse.startY);
                if (!_this.axe && (diffX > 12 || diffY > 12)) {
                    _this.axe = diffX > diffY ? SwipeAxes.HORIZONTAL : SwipeAxes.VERTICAL;
                }
                if (diffX > 12 || diffY > 12) {
                    _this.dragged = true;
                }
                if (_this.axe === SwipeAxes.HORIZONTAL && !!_this.settings.horizontal || _this.axe === SwipeAxes.VERTICAL && !!_this.settings.vertical) {
                    e.preventDefault();
                    _this.updateSwipe();
                    _this.view.find('a').css({ 'pointer-events': 'none' });
                }
            }
        };
        _this.onMouseUp = function (e) {
            if (!!_this.swiping) {
                e.preventDefault();
                e.stopPropagation();
                _this.endSwipe();
            }
            _this.view.find('a').css({ 'pointer-events': '' });
            _this.axe = null;
        };
        _this.onTouchStart = function (e) {
            _this.mouse.startX = e.originalEvent.touches[0].pageX;
            _this.mouse.startY = e.originalEvent.touches[0].pageY;
            _this.startSwipe();
        };
        _this.onTouchMove = function (e) {
            if (!!_this.swiping) {
                _this.mouse.x = e.originalEvent.touches[0].pageX;
                _this.mouse.y = e.originalEvent.touches[0].pageY;
                var diffX = Math.abs(_this.mouse.x - _this.mouse.startX);
                var diffY = Math.abs(_this.mouse.y - _this.mouse.startY);
                if (!_this.axe && (diffX > 12 || diffY > 12)) {
                    _this.axe = diffX > diffY ? SwipeAxes.HORIZONTAL : SwipeAxes.VERTICAL;
                }
                if (diffX > 12 || diffY > 12) {
                    _this.dragged = true;
                }
                if (_this.axe === SwipeAxes.HORIZONTAL && !!_this.settings.horizontal || _this.axe === SwipeAxes.VERTICAL && !!_this.settings.vertical) {
                    e.preventDefault();
                    _this.updateSwipe();
                } else if (_this.axe) {
                    _this.swiping = false;
                }
            }
        };
        _this.onTouchEnd = function (e) {
            if (!!_this.swiping) {
                _this.endSwipe();
            }
            if (!!_this.dragged) {
                _this.dragged = false;
                e.preventDefault();
            }
            _this.axe = null;
        };
        _this.settings = $.extend({
            horizontal: true,
            vertical: false,
            minimum: 80,
            disableMouse: false,
            disableTouch: false,
            handler: null
        }, options || {});
        _this.mouse = { x: 0, y: 0 };
        _this.deltaX = 0;
        _this.deltaY = 0;
        _this.x = 0;
        _this.y = 0;
        _this.startX = 0;
        _this.startY = 0;
        _this.offsetX = 0;
        _this.offsetY = 0;
        _this.dragged = false;
        _this.swiping = false;
        _this.disabled = false;
        _this.$handler = _this.settings.handler ? $(_this.settings.handler) : _this.view;
        _this.updateCursor();
        _this.uid = Utils.generateUID();
        _this.bind();
        return _this;
    }

    _createClass(Swipe, [{
        key: "destroy",
        value: function destroy() {
            _get(Swipe.prototype.__proto__ || Object.getPrototypeOf(Swipe.prototype), "destroy", this).call(this);
            this.unbind();
        }
    }, {
        key: "toggle",
        value: function toggle(enable) {
            this.disabled = !enable;
            this.updateCursor();
        }
    }, {
        key: "end",
        value: function end() {
            if (!!this.swiping) {
                this.endSwipe();
                this.axe = null;
            }
        }
    }, {
        key: "updateCursor",
        value: function updateCursor() {
            var isMouseDisabled = !Modernizr.touchevents && !!this.settings.disableMouse;
            this.$handler.toggleClass('is-grabbable', !this.disabled && !isMouseDisabled);
        }
    }, {
        key: "bind",
        value: function bind() {
            this.view.off('.swipe');
            if (!this.settings.disableMouse) {
                this.$handler.on('mousedown.swipe', this.onMouseDown);
                this.view.on('mousemove.swipe', this.onMouseMove).on('mouseup.swipe', this.onMouseUp).on('mouseleave.swipe', this.onMouseUp);
            }
            if (!this.settings.disableTouch) {
                this.$handler.on('touchstart.swipe', this.onTouchStart);
                this.view.on('touchmove.swipe', this.onTouchMove);
                Site_1.$doc.off('.swipe' + this.uid).on('touchend.swipe' + this.uid, this.onTouchEnd);
            }
        }
    }, {
        key: "unbind",
        value: function unbind() {
            this.view.off('.swipe');
            Site_1.$doc.off('.swipe' + this.uid);
        }
    }, {
        key: "startSwipe",
        value: function startSwipe() {
            if (!this.disabled) {
                this.swiping = true;
                this.dragged = false;
                this.startX = 0;
                this.startY = 0;
                this.axe = null;
                this.trigger(SwipeEvents.START, {
                    target: this.view[0],
                    x: this.mouse.startX - this.view.offset().left,
                    y: this.mouse.startY - this.view.offset().top,
                    instance: this
                });
                this.$handler.addClass('is-grabbed');
            }
        }
    }, {
        key: "updateSwipe",
        value: function updateSwipe() {
            var x = this.startX + this.mouse.x - this.mouse.startX,
                y = this.startY + this.mouse.y - this.mouse.startY;
            this.x = x;
            this.y = y;
            this.trigger(SwipeEvents.UPDATE, {
                target: this.view[0],
                deltaX: !!this.settings.horizontal ? x : 0,
                deltaY: !!this.settings.vertical ? y : 0,
                x: this.mouse.x,
                y: this.mouse.y,
                instance: this
            });
            this.$handler.addClass('is-dragged');
        }
    }, {
        key: "endSwipe",
        value: function endSwipe() {
            this.swiping = false;
            var direction = this.axe === SwipeAxes.HORIZONTAL ? this.x < this.startX ? SwipeDirections.LEFT : SwipeDirections.RIGHT : this.y < this.startY ? SwipeDirections.UP : SwipeDirections.DOWN;
            direction = this.axe === SwipeAxes.HORIZONTAL && Math.abs(this.mouse.x - this.mouse.startX) < this.settings.minimum ? SwipeDirections.NONE : direction;
            direction = this.axe === SwipeAxes.VERTICAL && Math.abs(this.mouse.y - this.mouse.startY) < this.settings.minimum ? SwipeDirections.NONE : direction;
            direction = this.axe === null ? SwipeDirections.NONE : direction;
            direction = this.axe === SwipeAxes.HORIZONTAL && !this.settings.horizontal || this.axe === SwipeAxes.VERTICAL && !this.settings.vertical ? SwipeDirections.NONE : direction;
            direction = direction === SwipeDirections.NONE && !this.dragged ? SwipeDirections.CLICK : direction;
            this.trigger(SwipeEvents.END, {
                target: this.view[0],
                direction: direction,
                instance: this
            });
            this.$handler.removeClass('is-grabbed is-dragged');
        }
    }]);

    return Swipe;
}(Component_1.Component);

exports.Swipe = Swipe;

},{"../Site":13,"../Utils":15,"./Component":18}],39:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Site_1 = require("../Site");
var Breakpoint_1 = require("../Breakpoint");

var TilesPriorities = function TilesPriorities() {
    _classCallCheck(this, TilesPriorities);
};

exports.TilesPriorities = TilesPriorities;
TilesPriorities.NONE = 'none';
TilesPriorities.LAST_COLUMN = 'right';
TilesPriorities.FIRST_COLUMN = 'left';

var Tiles = function (_Component_1$Componen) {
    _inherits(Tiles, _Component_1$Componen);

    function Tiles(view, options) {
        _classCallCheck(this, Tiles);

        var _this = _possibleConstructorReturn(this, (Tiles.__proto__ || Object.getPrototypeOf(Tiles)).call(this, view));

        _this.view = view;
        _this.resize = function () {
            _this.view.css('width', '');
            if (!!Breakpoint_1.breakpoint.phone) {
                _this.view.width(Math.floor(_this.view.closest('.grid').width() * 0.5) * 2);
            }
            _this.saveCache();
        };
        _this.settings = $.extend({
            item: '.js-tile',
            column: '.js-column-sizer',
            gutter: '.js-gutter-sizer',
            filler: '.js-filler',
            maxFillers: 3,
            minGapHeight: 200,
            maxHangingGapHeight: 300,
            hideHangingBottom: true,
            horizontalOrder: false
        }, options);
        _this.$column = typeof _this.settings.column === 'string' ? _this.view.find('' + _this.settings.column) : null;
        _this.$gutter = typeof _this.settings.gutter === 'string' ? _this.view.find('' + _this.settings.gutter) : null;
        console.assert(_this.$column.length > 0 && _this.$gutter.length > 0, 'There should be grid sizers! `.column-sizer` and `.gutter-sizer`', true);
        if (!!Site_1.debug) {
            _this.view.find(_this.settings.item).shuffle();
        }
        _this.setup();
        _this.view.data('Tiles', _this);
        return _this;
    }

    _createClass(Tiles, [{
        key: "destroy",
        value: function destroy() {
            this.$column = null;
            this.$gutter = null;
            this.view.data('Tiles', null);
            _get(Tiles.prototype.__proto__ || Object.getPrototypeOf(Tiles.prototype), "destroy", this).call(this);
        }
    }, {
        key: "onAppend",
        value: function onAppend($items, isEnd) {
            if (!!isEnd) {
                this.settings.hideHangingBottom = false;
            }
            this.setup($items);
        }
    }, {
        key: "setup",
        value: function setup($target) {
            var $currentTarget = $(typeof $target === 'undefined' ? this.view : $target);
            $currentTarget.imagesLoaded().always(function () {
                Site_1.$window.trigger('resize');
            });
            Site_1.$window.trigger('resize');
        }
    }, {
        key: "saveCache",
        value: function saveCache() {
            if (this.$column.length < 1 || this.$gutter.length < 1) {
                return;
            }
            var $items = this.view.find(this.settings.item);
            var elements = $items.toArray().map(function (el, i) {
                var $el = $(el);
                $el.css({ top: '', left: '' }).addClass('is-pending').removeClass('is-first-column is-last-column is-temporary-hidden');
                if (!$el.is(':visible')) {
                    return null;
                } else {
                    return {
                        $el: $el,
                        el: el,
                        width: Math.floor($el.outerWidth()),
                        height: $el.outerHeight(true),
                        priority: $el.data('priority') || 'none'
                    };
                }
            }).filter(function (item) {
                return item !== null;
            });
            var fillers = this.view.find(this.settings.filler).toArray().shuffle().map(function (el, i) {
                var $el = $(el);
                $el.removeAttr('style').addClass('is-pending');
                return {
                    $el: $el,
                    el: el,
                    width: $el.outerWidth(),
                    height: $el.outerHeight(true)
                };
            });
            var containerWidth = this.view.width();
            var columnWidth = typeof this.settings.column === 'number' ? parseInt('' + this.settings.column, 10) : !this.$column ? 0 : this.$column.width();
            var gutterWidth = typeof this.settings.gutter === 'number' ? parseInt('' + this.settings.gutter, 10) : !this.$gutter ? 0 : this.$gutter.width();
            var columnAmount = Math.floor(containerWidth / (columnWidth + gutterWidth));
            this.cache = {
                column: columnWidth,
                gutter: gutterWidth,
                columnWithGutter: columnWidth + gutterWidth,
                grid: columnAmount,
                width: containerWidth,
                elements: elements,
                fillers: fillers
            };
            this.layout();
        }
    }, {
        key: "layout",
        value: function layout() {
            var _this2 = this;

            if (!this.cache || !this.cache.elements || this.cache.elements.length < 1) {
                return;
            }
            var columns = [].slice.call(new Uint8Array(this.cache.grid));
            var gaps = [];
            var columnsLastElements = columns.concat();
            var isMobile = !!Breakpoint_1.breakpoint.phone;
            var lastItem = void 0;
            var lastColumn = -1;
            this.view.find('.gap').remove();
            $.each(this.cache.elements, function (ix, data) {
                var cols = Math.ceil((data.width + _this2.cache.gutter) / _this2.cache.columnWithGutter);
                var columnIndex = _this2.getColumnIndex(columns, cols, gaps, lastColumn, data.height, data.priority);
                var top = Math.max.apply(null, columns.concat().slice(columnIndex, columnIndex + cols));
                var left = Math.max(0, columnIndex * _this2.cache.columnWithGutter);
                var right = left + cols * _this2.cache.columnWithGutter;
                var bottom = top + data.height;
                lastColumn = columnIndex + cols - 1;
                data.$el.removeClass('is-pending').toggleClass('is-first-column', columnIndex === 0).toggleClass('is-last-column', columnIndex + cols === columns.length).css({
                    position: 'absolute',
                    top: top,
                    left: left
                });
                data.bottom = bottom;
                data.top = top;
                gaps = gaps.concat(columns.concat().slice(columnIndex, columnIndex + cols).reduce(function (newGaps, columnHeight, i, array) {
                    var gapHeight = top - columnHeight;
                    return gapHeight > _this2.settings.minGapHeight ? newGaps.concat({
                        index: columnIndex + i,
                        top: columnHeight,
                        height: gapHeight,
                        bottom: columnHeight + gapHeight
                    }) : newGaps;
                }, []));
                columns = columns.map(function (columnHeight, index) {
                    return columnIndex <= index && index < columnIndex + cols ? top + data.height : columnHeight;
                });
                columnsLastElements = columnsLastElements.map(function (lastElementData, index) {
                    return columnIndex <= index && index < columnIndex + cols ? data : lastElementData;
                });
                lastItem = !lastItem || right >= lastItem.right && bottom > lastItem.bottom ? { right: right, bottom: bottom, $el: data.$el } : lastItem;
            });
            if (lastItem && lastItem.$el) {
                lastItem.$el.addClass('is-last').siblings().removeClass('is-last');
            }
            var totalHeight = Math.max.apply(null, columns);
            this.view.css({
                height: totalHeight,
                position: 'relative'
            });
            gaps = gaps.concat(columns.concat().map(function (c, i) {
                var bottomGapHeight = totalHeight - c;
                return bottomGapHeight > _this2.settings.minGapHeight ? {
                    index: i,
                    top: c,
                    height: bottomGapHeight,
                    bottom: totalHeight
                } : null;
            })).filter(function (gap) {
                return gap !== null;
            });
            gaps = gaps.concat().filter(function (gap, index, gaps) {
                var gapCols = gap ? 1 : 0;
                while (gap && gaps[gapCols + index] && gaps[gapCols + index].top === gaps[index].top) {
                    gaps[gapCols + index] = null;
                    gapCols++;
                }
                if (gap) {
                    gap.width = gapCols * _this2.cache.columnWithGutter;
                }
                return gap !== null;
            });
            gaps = gaps.concat().sort(function (a, b) {
                return a.height < b.height ? 1 : a.height > b.height ? -1 : 0;
            }).slice(0, this.settings.maxFillers);
            if (gaps && gaps.length > 0 && gaps[gaps.length - 1].top !== 0) {
                var filledGaps = [];

                var _loop = function _loop(i) {
                    var gapWidth = gaps[i].width;
                    var gapHeight = gaps[i].height;
                    var chosenFiller = _this2.cache.fillers.reduce(function (chosen, filler) {
                        return !filler.used && gaps[i] && filler.width <= gapWidth && filler.height < gapHeight && (!chosen || filler.height > chosen.height) ? filler : chosen;
                    }, null);
                    if (chosenFiller) {
                        chosenFiller.used = true;
                        chosenFiller.$el.css({
                            top: gaps[i].top,
                            left: gaps[i].index * _this2.cache.columnWithGutter
                        });
                        filledGaps.push({
                            filler: chosenFiller,
                            top: gaps[i].top,
                            left: gaps[i].index * _this2.cache.columnWithGutter,
                            right: gaps[i].index * _this2.cache.columnWithGutter + gapWidth,
                            bottom: gaps[i].top + gaps[i].height,
                            height: gapHeight
                        });
                    }
                    if (gaps[i] && !!Site_1.debug) {
                        var $g = $('<div class="gap">');
                        $g.css({
                            opacity: 0.1,
                            background: 'red',
                            position: 'absolute',
                            left: gaps[i].index * _this2.cache.columnWithGutter,
                            height: gaps[i].height,
                            width: gaps[i].width,
                            top: gaps[i].top
                        });
                        _this2.view.append($g);
                    }
                };

                for (var i = 0; i < gaps.length; i++) {
                    _loop(i);
                }

                var _loop2 = function _loop2(i) {
                    var currentGap = filledGaps[i];
                    if (currentGap) {
                        filledGaps.concat().filter(function (g, index) {
                            return index === i || currentGap.top >= g.top && currentGap.top < g.bottom || currentGap.bottom <= g.bottom && currentGap.bottom > g.top;
                        }).reduce(function (biggest, current) {
                            return !biggest || current.height > biggest.height ? current : biggest;
                        }, null).filler.$el.removeClass('is-pending').css({ opacity: 1 });
                    }
                };

                for (var i = 0; i < filledGaps.length; i++) {
                    _loop2(i);
                }
            }
        }
    }, {
        key: "getColumnIndex",
        value: function getColumnIndex(columns, cols, gaps, lastColumn, height, priority) {
            if (this.settings.horizontalOrder) {
                return lastColumn + cols > columns.length ? 0 : lastColumn + 1;
            }
            switch (priority) {
                case TilesPriorities.FIRST_COLUMN:
                    return 0;
                case TilesPriorities.LAST_COLUMN:
                    return columns.length - cols;
                default:
                    return columns.concat().slice(0, columns.length - cols + 1).reduce(function (smallest, current, index) {
                        return smallest.height <= Math.max.apply(null, columns.concat().slice(index, index + cols)) ? smallest : { 'height': current, 'index': index };
                    }, { height: Infinity, index: null }).index;
            }
        }
    }]);

    return Tiles;
}(Component_1.Component);

exports.Tiles = Tiles;

},{"../Breakpoint":2,"../Site":13,"./Component":18}],40:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Player_1 = require("./Player");
var Browser_1 = require("../Browser");
var Templates_1 = require("../Templates");
var MediaState;
(function (MediaState) {
    MediaState[MediaState["HAVE_NOTHING"] = 0] = "HAVE_NOTHING";
    MediaState[MediaState["HAVE_METADATA"] = 1] = "HAVE_METADATA";
    MediaState[MediaState["HAVE_CURRENT_DATA"] = 2] = "HAVE_CURRENT_DATA";
    MediaState[MediaState["HAVE_FUTURE_DATA"] = 3] = "HAVE_FUTURE_DATA";
    MediaState[MediaState["HAVE_ENOUGH_DATA"] = 4] = "HAVE_ENOUGH_DATA";
})(MediaState = exports.MediaState || (exports.MediaState = {}));

var Video = function (_Player_1$Player) {
    _inherits(Video, _Player_1$Player);

    function Video(view, options) {
        _classCallCheck(this, Video);

        var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, view, options));

        _this.view = view;
        _this.isShown = false;
        _this.onCCTrackClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var index = parseInt(e.currentTarget.dataset.index || -1, 10);
            _this.loadCC(index);
        };
        _this.onCueEnter = function (e) {
            var cue = e.currentTarget;
            _this.controls.captions.show().html(cue.text);
        };
        _this.onCueExit = function () {
            _this.controls.captions.hide();
        };
        return _this;
    }

    _createClass(Video, [{
        key: "preload",
        value: function preload() {
            var _this2 = this;

            var state = !Browser_1.browser.safari ? MediaState.HAVE_ENOUGH_DATA : MediaState.HAVE_METADATA;
            return new Promise(function (resolve, reject) {
                if (!!Browser_1.browser.mobile || !_this2.settings.autoplay) {
                    resolve(true);
                } else if (_this2.media.readyState >= state) {
                    resolve(true);
                } else {
                    _this2.mediaEl.on('loadeddata', function () {
                        if (_this2.media.readyState >= state) {
                            resolve(true);
                        }
                    });
                }
            });
        }
    }, {
        key: "load",
        value: function load(data) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var src = !!Browser_1.browser.mobile && data.src_mobile && data.src_mobile !== '' ? data.src_mobile : data.src;
                src = _this3.decodeURL(src);
                _this3.media.pause();
                _this3.media.src = src;
                _this3.view.removeClass('is-ended is-started is-played is-playing');
                _this3.playlist.hide();
                _this3.media.load();
                _this3.resetTimeline();
                if (_this3.settings.autoplay && _this3.isShown) {
                    _this3.play();
                }
                _this3.settings.ratio = data.ratio;
                _this3.settings.ratio_mobile = data.ratio_mobile;
                _this3.resize();
                _this3.settings.poster = data.poster;
                _this3.settings.poster_mobile = data.poster_mobile;
                _this3.loadPoster();
                resolve(true);
            });
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            this.isShown = true;
            if (!!this.settings.autoplay) {
                this.play();
            }
            _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), "animateIn", this).call(this);
        }
    }, {
        key: "animateOut",
        value: function animateOut() {
            var _this4 = this;

            return new Promise(function (resolve, reject) {
                _this4.pause();
                resolve();
            });
        }
    }, {
        key: "play",
        value: function play() {
            var _this5 = this;

            var playPromise = this.media.play();
            setTimeout(function () {
                _this5.view.addClass('should-play');
            }, 1000);
            if (playPromise !== undefined) {
                playPromise.then(function () {
                    _this5.view.removeClass('autoplay-failed');
                }).catch(function (error) {
                    _this5.view.addClass('autoplay-failed');
                });
            }
        }
    }, {
        key: "pause",
        value: function pause() {
            this.media.pause();
        }
    }, {
        key: "toggle",
        value: function toggle() {
            if (!this.media.paused) {
                this.media.pause();
            } else {
                Player_1.Player.pauseAll();
                this.media.play();
                this.playlist.hide();
            }
        }
    }, {
        key: "unload",
        value: function unload() {
            if (this.media) {
                this.media.pause();
                this.media.src = '';
                this.media.load();
            }
        }
    }, {
        key: "seek",
        value: function seek(value) {
            this.media.currentTime = this.media.duration * value;
        }
    }, {
        key: "setVolume",
        value: function setVolume(value) {
            this.media.volume = value;
            this.updateVolume(this.media.volume);
        }
    }, {
        key: "toggleMute",
        value: function toggleMute() {
            this.media.volume = this.media.volume > 0 ? 0 : 1;
            this.updateVolume(this.media.volume);
        }
    }, {
        key: "createPlayer",
        value: function createPlayer() {}
    }, {
        key: "isPaused",
        value: function isPaused() {
            return this.media.paused;
        }
    }, {
        key: "setup",
        value: function setup() {
            this.mediaEl = this.view.find('audio, video');
            if (!this.mediaEl[0]) {
                console.error('Video/Audio component must contain html `<audio>` or `<video>` element');
                return;
            }
            this.media = this.mediaEl[0];
            this.isAudio = this.media.tagName === 'AUDIO';
            this.settings.ratio = parseFloat(this.settings.ratio + '');
            this.settings.ratio_mobile = parseFloat(this.settings.ratio_mobile + '');
            if (this.mediaEl.data('src-mobile')) {
                this.settings.src_mobile = this.mediaEl.data('src-mobile');
            }
            if (this.mediaEl.data('src')) {
                this.settings.src = this.mediaEl.data('src');
            }
            if (!this.settings.src_mobile || this.settings.src_mobile === '') {
                delete this.settings.ratio_mobile;
                delete this.settings.src_mobile;
            }
            if (!!Browser_1.browser.mobile && this.settings.src_mobile && this.settings.src_mobile !== this.media.src) {
                this.media.src = this.decodeURL(this.settings.src_mobile);
                this.media.load();
            } else if (!Browser_1.browser.mobile && this.settings.src && this.settings.src !== this.media.src) {
                this.media.src = this.decodeURL(this.settings.src);
                this.media.load();
            }
            if (this.settings.volume) {
                this.media.volume = this.settings.volume;
            }
            if (this.media.autoplay || this.settings.autoplay) {
                this.settings.autoplay = true;
                this.media.autoplay = false;
            }
            if (this.media.loop) {
                this.settings.loop = true;
            }
            if (this.settings.loop) {
                this.media.loop = true;
            }
            var media = this.media;
            if (media.poster && !this.settings.poster) {
                this.settings.poster = media.poster;
                if (this.media.controls) {
                    media.poster = '';
                }
            }
            if (!!this.media.controls || this.settings.controls) {
                this.buildUI();
                this.media.controls = false;
                $(this.media).removeAttr('controls');
            }
            this.updateVolume(this.media.volume);
            this.bind();
            this.resize();
            if (!!this.settings.autoplay) {
                this.pause();
            }
        }
    }, {
        key: "bind",
        value: function bind() {
            this.mediaEl.off('.player').on('click.player', this.onToggleClick);
            _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), "bind", this).call(this);
        }
    }, {
        key: "bindPlayer",
        value: function bindPlayer() {
            var _this6 = this;

            if (this.media.readyState >= 2) {
                this.onLoaded();
            }
            this.mediaEl.on('loadedmetadata loadeddata', function () {
                return _this6.onLoaded();
            }).on('durationchange updateMediaState', function () {
                return _this6.onDurationChange();
            }).on('progress updateMediaState', function () {
                return _this6.onProgress();
            }).on('timeupdate', function () {
                return _this6.onTimeupdate();
            }).on('play', function () {
                return _this6.onPlay();
            }).on('canplay', function () {
                return _this6.onCanplay();
            }).on('playing', function () {
                return _this6.onPlaying();
            }).on('pause', function () {
                return _this6.onPause();
            }).on('waiting', function () {
                return _this6.onWaiting();
            }).on('ended', function () {
                return _this6.onEnd();
            }).on('error', function (e) {
                return _this6.onError(e);
            });
            if (screenfull.isEnabled) {
                document.addEventListener(screenfull.raw.fullscreenchange, function () {
                    _this6.view.toggleClass('is-fullscreen', screenfull.isFullscreen);
                });
            }
        }
    }, {
        key: "unbindPlayer",
        value: function unbindPlayer() {
            this.mediaEl.off();
        }
    }, {
        key: "onLoaded",
        value: function onLoaded() {
            this.loadCaptions();
        }
    }, {
        key: "onDurationChange",
        value: function onDurationChange() {
            var duration = this.media.duration;
            if (!duration) {
                return;
            }
            this.updateTimeline(null, null, duration);
        }
    }, {
        key: "onProgress",
        value: function onProgress() {
            this.updateLoadProgress();
        }
    }, {
        key: "onTimeupdate",
        value: function onTimeupdate() {
            var current = this.media.currentTime;
            if (!current || this.scrubbing) {
                return;
            }
            this.updateTimeline(this.media.duration, null, current);
        }
    }, {
        key: "loadCaptions",
        value: function loadCaptions() {
            var _this7 = this;

            if (this.media.textTracks.length > 0) {
                this.view.addClass('has-cc');
                this.media.textTracks[0].mode = 'showing';
                var ccTracksData = [];
                for (var i = 0; i < this.media.textTracks.length; i++) {
                    var track = this.media.textTracks[i];
                    track.mode = 'hidden';
                    ccTracksData.push({
                        lang: track.language,
                        label: track.label,
                        kind: track.kind
                    });
                }
                var ccTemplate = Templates_1.Templates.get(Templates_1.TemplateNames.PLAYERCC);
                this.controls.cc.find('ul').html(ccTemplate.render({ tracks: ccTracksData }));
                setTimeout(function () {
                    _this7.controls.cc.find('li').on('click.cc', _this7.onCCTrackClick);
                }, 0);
            } else {
                this.view.removeClass('has-cc');
            }
        }
    }, {
        key: "updateLoadProgress",
        value: function updateLoadProgress() {
            var buffered = this.media.buffered;
            var bufferedTime = buffered && buffered.length ? buffered.end(0) : 0;
            this.updateTimeline(this.media.duration, bufferedTime, null);
        }
    }, {
        key: "decodeURL",
        value: function decodeURL(src) {
            var decode = function decode(s) {
                try {
                    var d = window.atob(s);
                    return (/^wq|x@$/g.test(d) ? d.replace(/^wq|x@$/g, '') : s
                    );
                } catch (e) {
                    return s;
                }
            };
            return (/\.mp4$/.test(src) ? src : decode(src)
            );
        }
    }, {
        key: "loadCC",
        value: function loadCC(index) {
            for (var i = 0; i < this.media.textTracks.length; i++) {
                this.media.textTracks[i].mode = i === index ? 'hidden' : 'disabled';
            }
            this.controls.cc.find(index >= 0 ? 'li[data-index=' + index + ']' : 'li:first-child').addClass('is-active').siblings().removeClass('is-active');
            var cues = this.media.textTracks[index].cues;
            for (var _i = 0; _i < cues.length; ++_i) {
                var cue = cues[_i];
                cue.onenter = this.onCueEnter;
                cue.onexit = this.onCueExit;
            }
        }
    }]);

    return Video;
}(Player_1.Player);

exports.Video = Video;

},{"../Browser":3,"../Templates":14,"./Player":31}],41:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Player_1 = require("./Player");
var Browser_1 = require("../Browser");
var Utils = require("../Utils");

var Youtube = function (_Player_1$Player) {
    _inherits(Youtube, _Player_1$Player);

    function Youtube(view, options) {
        _classCallCheck(this, Youtube);

        var _this = _possibleConstructorReturn(this, (Youtube.__proto__ || Object.getPrototypeOf(Youtube)).call(this, view, options));

        _this.view = view;
        _this.isNative = false;
        _this.currentState = -1;
        _this.onPlayerReady = function () {
            _this.bind();
            _this.resize();
        };
        _this.onPlayerStateChange = function (event) {
            var state = _this.player.getPlayerState();
            switch (state) {
                case -1:
                    break;
                case 0:
                    _this.onEnd();
                    break;
                case 1:
                    _this.onCanplay();
                    _this.onPlay();
                    _this.onPlaying();
                    break;
                case 2:
                    _this.onPause();
                    break;
                case 3:
                    _this.onWaiting();
                    break;
                case 5:
                    break;
                default:
                    break;
            }
            _this.currentState = state;
        };
        Youtube.allYoutubeInstances.push(_this);
        return _this;
    }

    _createClass(Youtube, [{
        key: "play",
        value: function play() {
            this.player.playVideo();
        }
    }, {
        key: "pause",
        value: function pause() {
            window.clearTimeout(this.interval);
            if (this.player && typeof this.player.pauseVideo === 'function') {
                if (this.currentState === 1 || this.currentState === 3) {
                    this.player.pauseVideo();
                }
            }
        }
    }, {
        key: "toggle",
        value: function toggle(e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            switch (this.currentState) {
                case 0:
                case -1:
                case 2:
                case 5:
                    this.play();
                    break;
                case 1:
                case 3:
                    this.pause();
                    break;
                default:
                    this.play();
                    break;
            }
        }
    }, {
        key: "seek",
        value: function seek(_seek) {
            var goTo = parseInt('' + this.player.getDuration() * _seek, 10);
            this.player.seekTo(goTo, true);
            this.play();
        }
    }, {
        key: "setVolume",
        value: function setVolume(value) {
            this.player.setVolume(value * 100);
            this.updateVolume(value);
        }
    }, {
        key: "toggleMute",
        value: function toggleMute() {
            var vol = this.player.isMuted() || this.player.getVolume() === 0 ? 100 : 0;
            this.player.setVolume(vol);
            this.updateVolume(vol);
        }
    }, {
        key: "createPlayer",
        value: function createPlayer() {
            var _this2 = this;

            if (typeof this.settings.id !== 'undefined') {
                this.timeoutCreateYoutubePlayer = setTimeout(function () {
                    var playerVars = {
                        autohide: 1,
                        autoplay: _this2.settings.autoplay ? 1 : 0,
                        cc_load_policy: 0,
                        controls: 0,
                        disablekb: 1,
                        enablejsapi: 1,
                        fs: 0,
                        iv_load_policy: 3,
                        loop: _this2.settings.loop ? 1 : 0,
                        modestbranding: 1,
                        origin: window.location.origin,
                        playsinline: 1,
                        rel: 0,
                        showinfo: 0
                    };
                    if (!!Browser_1.browser.mobile) {
                        playerVars.autoplay = 0;
                        _this2.isNative = true;
                    }
                    _this2.player = new YT.Player(_this2.id, {
                        videoId: _this2.settings.id,
                        width: _this2.settings.width,
                        height: _this2.settings.height,
                        playerVars: playerVars,
                        events: {
                            'onReady': function onReady() {
                                return _this2.onPlayerReady();
                            },
                            'onStateChange': function onStateChange(event) {
                                return _this2.onPlayerStateChange(event);
                            }
                        }
                    });
                }, 300);
            } else {
                console.warn('You should provide Youtube ID!');
            }
        }
    }, {
        key: "preload",
        value: function preload() {
            return Promise.resolve();
        }
    }, {
        key: "load",
        value: function load(data) {
            return this.player.loadVideoById({
                videoId: data.id
            });
        }
    }, {
        key: "destroy",
        value: function destroy() {
            Youtube.allYoutubeInstances.splice(Youtube.allYoutubeInstances.indexOf(this), 1);
            _get(Youtube.prototype.__proto__ || Object.getPrototypeOf(Youtube.prototype), "destroy", this).call(this);
        }
    }, {
        key: "unload",
        value: function unload() {
            if (this.player) {
                if (typeof this.player.stopVideo === 'function') {
                    this.player.stopVideo();
                }
                if (typeof this.player.clearVideo === 'function') {
                    this.player.clearVideo();
                }
                if (typeof this.player.destroy === 'function') {
                    this.player.destroy();
                }
            }
        }
    }, {
        key: "isPaused",
        value: function isPaused() {
            return this.player && typeof this.player.getPlayerState === 'function' && this.player.getPlayerState() !== 1 && this.player.getPlayerState() !== 3;
        }
    }, {
        key: "setup",
        value: function setup() {
            var _this3 = this;

            if (!this.view.find('.youtube')[0]) {
                this.view.append('<div class="youtube">');
            }
            this.videoEl = this.view.find('.youtube');
            this.id = 'youtube-' + this.uid;
            this.videoEl.attr('id', this.id);
            if (!!Browser_1.browser.mobile) {
                if (this.videoEl[0].nodeName === 'iframe') {
                    var iframeSource = this.videoEl.attr('src');
                    iframeSource = iframeSource.split('?')[0] + '?showinfo=0&controls=0&rel=0';
                    this.videoEl.attr('src', iframeSource);
                }
                this.view.addClass('is-native');
                this.settings.autoplay = false;
                this.isNative = true;
            }
            this.settings.poster = this.settings.poster || '//img.youtube.com/vi/' + this.settings.id + '/maxresdefault.jpg';
            if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
                window.onYouTubePlayerAPIReady = function () {
                    return _this3.onYouTubeIframeAPIReady();
                };
                $.getScript('//www.youtube.com/iframe_api');
            } else {
                this.createPlayer();
            }
            this.buildUI();
            this.resize();
        }
    }, {
        key: "bindPlayer",
        value: function bindPlayer() {
            var _this4 = this;

            if (screenfull.isEnabled) {
                document.addEventListener(screenfull.raw.fullscreenchange, function () {
                    _this4.view.toggleClass('is-fullscreen', screenfull.isFullscreen);
                });
            }
        }
    }, {
        key: "unbindPlayer",
        value: function unbindPlayer() {}
    }, {
        key: "onPlay",
        value: function onPlay() {
            var _this5 = this;

            _get(Youtube.prototype.__proto__ || Object.getPrototypeOf(Youtube.prototype), "onPlay", this).call(this);
            window.clearTimeout(this.interval);
            this.interval = setInterval(function () {
                _this5.onDurationChange();
                _this5.onProgress();
                _this5.onTimeupdate();
            }, 100);
        }
    }, {
        key: "onDurationChange",
        value: function onDurationChange() {
            var duration = this.player.getDuration();
            if (!duration) {
                return;
            }
            this.controls.duration.text(Utils.parseToTime(duration));
        }
    }, {
        key: "onProgress",
        value: function onProgress() {
            var buffered = this.player.getVideoLoadedFraction();
            this.controls.loaded.width(buffered * 100 + '%');
        }
    }, {
        key: "onTimeupdate",
        value: function onTimeupdate() {
            var current = this.player.getCurrentTime();
            if (!current) {
                return;
            }
            this.controls.time.text(Utils.parseToTime(current));
            this.controls.progress.width(current / this.player.getDuration() * 100 + '%');
            this.view.toggleClass('is-started', current > this.settings.ready_time);
        }
    }, {
        key: "onEnd",
        value: function onEnd() {
            _get(Youtube.prototype.__proto__ || Object.getPrototypeOf(Youtube.prototype), "onEnd", this).call(this);
            window.clearTimeout(this.interval);
        }
    }, {
        key: "onYouTubeIframeAPIReady",
        value: function onYouTubeIframeAPIReady() {
            Youtube.allYoutubeInstances.forEach(function (item) {
                return item.createPlayer();
            });
        }
    }]);

    return Youtube;
}(Player_1.Player);

exports.Youtube = Youtube;
Youtube.allYoutubeInstances = [];

},{"../Browser":3,"../Utils":15,"./Player":31}],42:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var Component_1 = require("./Component");
var Site_1 = require("../Site");
var Utils = require("../Utils");

var Zoom = function (_Component_1$Componen) {
    _inherits(Zoom, _Component_1$Componen);

    function Zoom(view, options) {
        _classCallCheck(this, Zoom);

        var _this = _possibleConstructorReturn(this, (Zoom.__proto__ || Object.getPrototypeOf(Zoom)).call(this, view, options));

        _this.view = view;
        _this.options = options;
        _this.resize = function () {
            _this.resizeImage();
        };
        _this.onImageLoaded = function () {
            _this.resizeImage();
        };
        _this.resizeImage = function () {
            _this.image.css('height', '');
            var hgt = _this.image.height();
            _this.minScale = hgt !== 0 ? window.innerHeight / hgt : 0;
            if (_this.scale < _this.minScale) {
                _this.scale = _this.minScale;
            }
            _this.image.css('height', Math.max(hgt, window.innerHeight));
            gsap.set(_this.image, { scale: _this.scale, transformOrigin: '0 0' });
            _this.image.parent().css({ 'height': _this.image.height() * _this.scale, 'width': _this.image.width() * _this.scale });
            _this.iscroll.refresh();
        };
        if (!_this.view.length) {
            return _possibleConstructorReturn(_this);
        }
        _this.scale = 0;
        _this.minScale = 0;
        _this.dragonSettings = {
            animationTime: 1.2,
            debugMode: false,
            defaultZoomLevel: 1,
            minZoomImageRatio: 1,
            showNavigationControl: false,
            visibilityRatio: 1
        };
        _this.build();
        _this.bind();
        return _this;
    }

    _createClass(Zoom, [{
        key: "load",
        value: function load(sources) {
            if (!this.view.length || !sources || sources.length < 1) {
                return;
            }
            var html = '';
            for (var i = 0; i < sources.length; i++) {
                var s = sources[i];
                html += '<img src="' + s.src + '" width="' + s.width * s.scale + '" height="' + s.height * s.scale + '" alt="" />';
            }
            this.image.html(html).addClass('grabbable');
            this.view.show();
            this.imageWrap.show();
            this.dragonWrap.hide();
            gsap.fromTo(this.view.find('.js-zoom-in, .js-zoom-out'), {
                x: 64
            }, {
                duration: 0.4,
                x: 0,
                delay: 0.1,
                ease: Site_1.easing
            });
            Site_1.$body.addClass('is-zoomed');
            this.image.imagesLoaded().always(this.onImageLoaded);
            this.shown = true;
        }
    }, {
        key: "loadDeepzoom",
        value: function loadDeepzoom(src) {
            Site_1.$body.addClass('is-zoomed');
            this.view.show();
            this.imageWrap.hide();
            this.dragonWrap.show();
            this.dragon.open(src);
            this.shown = true;
        }
    }, {
        key: "hide",
        value: function hide() {
            if (!this.shown) {
                return false;
            } else {
                this.view.hide();
                this.imageWrap.hide();
                this.dragonWrap.hide();
                Site_1.$body.removeClass('is-zoomed');
                this.trigger('close');
                this.shown = false;
                this.scale = 0;
                return true;
            }
        }
    }, {
        key: "isShown",
        value: function isShown() {
            return !!this.shown;
        }
    }, {
        key: "build",
        value: function build() {
            this.view.append('<div class="zoom__imagewrap"><div><div class="zoom__image"><div></div></div></div></div><div class="zoom__deep"></div><div class="zoom__buttons"><button class="zoom__button--in button js-zoom-in"><i class="icon-plus"></i></button><button class="zoom__button--out button js-zoom-out"><i class="icon-minus"></i></button></div>');
            this.imageWrap = this.view.find('.zoom__imagewrap');
            this.image = this.view.find('.zoom__image');
            this.dragonWrap = this.view.find('.zoom__deep');
            this.dragonSettings.element = this.dragonWrap[0];
            this.iscroll = new IScroll(this.imageWrap[0], {
                freeScroll: true,
                scrollbars: false,
                scrollX: true,
                scrollY: true,
                mouseWheel: true
            });
            this.dragon = new OpenSeadragon.Viewer(this.dragonSettings);
        }
    }, {
        key: "bind",
        value: function bind() {
            var _this2 = this;

            this.iscroll.on('scrollCancel', function (e) {
                _this2.hide();
            });
            this.dragon.addViewerInputHook({
                hooks: [{
                    tracker: 'viewer',
                    handler: 'clickHandler',
                    hookHandler: function hookHandler(event) {
                        if (event.quick) {
                            event.preventDefaultAction = true;
                            _this2.hide();
                        }
                    }
                }]
            });
            Site_1.$doc.off('.zoom').on('keyup.zoom', function (e) {
                switch (e.keyCode || e.which) {
                    case Utils.keys.plus:
                        _this2.changeScale(+1);
                        break;
                    case Utils.keys.minus:
                        _this2.changeScale(-1);
                        break;
                    default:
                        break;
                }
            });
            this.view.find('.js-zoom-in').on('click.zoom', function () {
                _this2.changeScale(1);
            });
            this.view.find('.js-zoom-out').on('click.zoom', function () {
                _this2.changeScale(-1);
            });
        }
    }, {
        key: "changeScale",
        value: function changeScale(step) {
            gsap.to(this, {
                duration: 0.3,
                scale: Math.max(this.minScale, Math.min(1, this.scale + step * 0.1)),
                onUpdate: this.resizeImage,
                ease: Site_1.easing
            });
            return this.scale;
        }
    }]);

    return Zoom;
}(Component_1.Component);

exports.Zoom = Zoom;

},{"../Site":13,"../Utils":15,"./Component":18}],43:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Handler_1 = require("../Handler");
var Component_1 = require("../components/Component");
var Classes_1 = require("../Classes");

var PageEvents = function PageEvents() {
    _classCallCheck(this, PageEvents);
};

exports.PageEvents = PageEvents;
PageEvents.PROGRESS = 'progress';
PageEvents.COMPLETE = 'complete';
PageEvents.CHANGE = 'append';

var Page = function (_Handler_1$Handler) {
    _inherits(Page, _Handler_1$Handler);

    function Page(view, options) {
        _classCallCheck(this, Page);

        var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this));

        _this.view = view;
        _this.components = [];
        _this.onComponentChange = function (el) {
            _this.buildComponents(el.filter('[data-component]').add(el.find('[data-component]')));
            _this.trigger(PageEvents.CHANGE, el);
        };
        _this.view.css({ opacity: 0 });
        _this.components = [];
        _this.buildComponents(_this.view.parent().find('[data-component]'));
        return _this;
    }

    _createClass(Page, [{
        key: "preload",
        value: function preload() {
            var _this2 = this;

            var il = imagesLoaded(this.view.find('.preload').toArray(), { background: true });
            var images = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var component = _step.value;

                    images = images.concat(component.preloadImages());
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = images[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var url = _step2.value;

                    il.addBackground(url, null);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return new Promise(function (resolve, reject) {
                _this2.loader = il.jqDeferred;
                _this2.loader.progress(function (instance, image) {
                    var progress = instance.progressedCount / instance.images.length;
                    _this2.trigger(PageEvents.PROGRESS, progress);
                }).always(function () {
                    _this2.trigger(PageEvents.COMPLETE);
                    resolve();
                });
            });
        }
    }, {
        key: "onState",
        value: function onState() {
            var changed = !!false;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this.components[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var component = _step3.value;

                    var componentChanged = component.onState();
                    if (!changed && !!componentChanged) {
                        changed = true;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return changed;
        }
    }, {
        key: "animateIn",
        value: function animateIn(delay) {
            for (var i = 0; i < this.components.length; ++i) {
                this.components[i].animateIn(i, delay);
            }
            gsap.to(this.view, {
                opacity: 1
            });
        }
    }, {
        key: "animateOut",
        value: function animateOut() {
            var _this3 = this;

            var pageAnimationPromise = new Promise(function (resolve, reject) {
                gsap.to(_this3.view, {
                    onComplete: function onComplete() {
                        resolve();
                    }
                });
            });
            var componentAnimations = this.components.map(function (obj) {
                return obj.animateOut();
            });
            return new Promise(function (resolve, reject) {
                var allPromises = componentAnimations.concat(pageAnimationPromise);
                Promise.all(allPromises).then(function (results) {
                    resolve();
                });
            });
        }
    }, {
        key: "turnOff",
        value: function turnOff() {
            this.callAll('turnOff');
        }
    }, {
        key: "turnOn",
        value: function turnOn() {
            this.callAll('turnOn');
        }
    }, {
        key: "resize",
        value: function resize(wdt, hgt, breakpoint, bpChanged) {
            this.callAll('resize', wdt, hgt, breakpoint, bpChanged);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this.callAll('destroy');
            this.components = [];
            gsap.killTweensOf(this.view);
            this.view = null;
            _get(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), "destroy", this).call(this);
        }
    }, {
        key: "buildComponents",
        value: function buildComponents($components) {
            for (var i = $components.length - 1; i >= 0; i--) {
                var $component = $components.eq(i);
                var componentName = $component.data('component');
                if (componentName !== undefined && Classes_1.components[componentName]) {
                    var options = $component.data('options'),
                        component = new Classes_1.components[componentName]($component, options);
                    this.components.push(component);
                    component.on(Component_1.ComponentEvents.CHANGE, this.onComponentChange);
                } else {
                    window.console.warn('There is no `%s` component!', componentName);
                }
            }
        }
    }, {
        key: "callAll",
        value: function callAll(fn) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = this.components[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var component = _step4.value;

                    if (typeof component[fn] === 'function') {
                        component[fn].apply(component, [].slice.call(arguments, 1));
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    }]);

    return Page;
}(Handler_1.Handler);

exports.Page = Page;

},{"../Classes":4,"../Handler":6,"../components/Component":18}],44:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var IScroll_1 = require("./IScroll");
var Scrolling_1 = require("../Scrolling");
var Button_1 = require("./Button");
var Images_1 = require("./Images");
var Form_1 = require("./Form");
var Fb_1 = require("./Fb");
var Email_1 = require("./Email");
var Copy_1 = require("./Copy");
var Datepicker_1 = require("./Datepicker");
var Analytics_1 = require("./Analytics");
var Wcag_1 = require("./Wcag");
var Cookies_1 = require("./Cookies");
var Popup_1 = require("./Popup");
var PopupNewsletter_1 = require("./PopupNewsletter");
var Formhint_1 = require("./Formhint");
var Lang_1 = require("./Lang");
var PushStates_1 = require("./../PushStates");

var Widgets = function () {
    function Widgets() {
        _classCallCheck(this, Widgets);
    }

    _createClass(Widgets, null, [{
        key: "bind",
        value: function bind(target) {
            Images_1.Images.bind(target);
            Analytics_1.Analytics.bind(target);
            Button_1.Button.bind(target);
            Form_1.Form.bind(target);
            Fb_1.Fb.bind(target);
            IScroll_1.Iscroll.bind(target);
            Email_1.Email.bind(target);
            Copy_1.Copy.bind(target);
            Datepicker_1.Datepicker.bind(target);
            Wcag_1.Wcag.bind(target);
            Cookies_1.Cookies.bind(target);
            Popup_1.Popup.bind(target);
            PopupNewsletter_1.PopupNewsletter.bind(target);
            Formhint_1.Formhint.bind(target);
            Lang_1.Lang.bind(target);
            Button_1.Button.bind(target);
            var $target = $(typeof target !== 'undefined' ? target : 'body');
            $target.find('[data-share]').off().on('click.share', this.onShareClick);
            $target.find('[data-print]').off().on('click.print', this.onPrintClick);
            var $pagingAnchor = $target.find('.js-paging-anchor');
            if ($pagingAnchor.length > 0 && (window.location.search.indexOf("page") > -1 || window.location.search.indexOf("search") > -1)) {
                setTimeout(function () {
                    Scrolling_1.Scrolling.scrollToElement($pagingAnchor, true, -60);
                }, 1);
            } else {
                setTimeout(function () {
                    Scrolling_1.Scrolling.scrollTop(true);
                }, 1);
            }
            $target.off('.headline--mask').on('mousemove.headline--mask', function (e) {
                if (!$('body').hasClass('wcag-contrast-high')) {
                    var img = $('.headline--mask img');
                    var xShift = $(window).width() / 2 - e.clientX;
                    var yShift = $(window).height() / 2 - e.clientY;
                    gsap.to(img, 1, { x: xShift * 0.025, y: yShift * 0.025, ease: 'sineInOut' });
                }
            });
            $target.find('.js-additional-link').each(function (i, el) {
                if ($(el).attr('data-href')) {
                    $(el).off().on('click', function () {
                        var location = $(el).attr('data-href');
                        var pathname = location.replace(window.location.protocol + window.location.host, '');
                        var isDifferent = pathname !== window.location.pathname;
                        var hasBlank = $(el).attr('target') === '_blank';
                        if (isDifferent) {
                            if (hasBlank) {
                                window.open(location, '_blank');
                            } else {
                                window.location.href = location;
                            }
                        } else {
                            PushStates_1.PushStates.goTo(location);
                        }
                    });
                }
            });
            $target.find('table').each(function (i, el) {
                var tdThead = $(el).find('thead tr td');
                if (tdThead.length > 0) {
                    var tab = [];
                    tdThead.each(function (i2, el2) {
                        tab[i2] = $(el2).html();
                    });
                    var tdTbody = $(el).find('tbody tr');
                    tdTbody.each(function (i2, el2) {
                        $(el2).find('td').each(function (i3, el3) {
                            $(el3).attr('data-label', tab[i3]);
                        });
                    });
                } else {
                    $(el).addClass('no-thead');
                }
            });
        }
    }, {
        key: "resize",
        value: function resize() {
            $('.headline-text').each(function (i, el) {
                var headlineLine = $(el).find('.headline');
                var headlineContainerLeft = $(el).find('.headline__container__left');
                var text = headlineLine.find('.headline__text').text();
                $(el).removeClass('headlineRotate');
                if (headlineContainerLeft.length > 0) {
                    if (headlineContainerLeft.width() < headlineLine.width()) {
                        $(el).addClass('headlineRotate');
                    } else {
                        $(el).removeClass('headlineRotate');
                    }
                }
            });
        }
    }]);

    return Widgets;
}();

exports.Widgets = Widgets;
Widgets.onShareClick = function (e) {
    e.preventDefault();
    var winWidth = parseInt($(e.currentTarget).attr('data-winwidth'), 10) || 520,
        winHeight = parseInt($(e.currentTarget).attr('data-winheight'), 10) || 350,
        winTop = screen.height / 2 - winHeight / 2,
        winLeft = screen.width / 2 - winWidth / 2;
    var href = e.currentTarget.href,
        data = $(e.currentTarget).data('share');
    if (data === 'facebook' || data === 'google') {
        href += encodeURIComponent(window.location.href);
    }
    window.open(href, 'sharer' + data, 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    return false;
};
Widgets.onPrintClick = function (e) {
    e.preventDefault();
    window.print();
    return false;
};
Widgets.onScrollDownClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    Scrolling_1.Scrolling.scroll({
        y: window.innerHeight
    });
};
Widgets.onScrollTopClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    Scrolling_1.Scrolling.scroll({
        y: 0
    });
};

},{"../Scrolling":12,"./../PushStates":11,"./Analytics":45,"./Button":46,"./Cookies":47,"./Copy":48,"./Datepicker":49,"./Email":50,"./Fb":51,"./Form":52,"./Formhint":53,"./IScroll":54,"./Images":55,"./Lang":56,"./Popup":57,"./PopupNewsletter":58,"./Wcag":60}],45:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Site_1 = require("../Site");

var Analytics = function () {
    function Analytics() {
        _classCallCheck(this, Analytics);
    }

    _createClass(Analytics, null, [{
        key: "bind",
        value: function bind(target) {
            var _this = this;

            var $target = typeof target !== 'undefined' ? $(target) : Site_1.$body;
            $('[data-ga]', $target).off('.ga').on('click.ga', function (e) {
                var data = $(e.currentTarget).data('ga');
                _this.sendEvent(data[0] || '', data[1] || '', data[2] || '', data[3] || -1);
            });
        }
    }, {
        key: "sendEvent",
        value: function sendEvent(category, action, label, value) {
            if (typeof gtag !== 'undefined') {
                gtag('event', action, {
                    event_category: category,
                    event_label: label,
                    value: value
                });
            } else if (typeof ga !== 'undefined') {
                ga('send', 'event', category, action, label, value);
            }
        }
    }, {
        key: "sendPageview",
        value: function sendPageview(pathname, title) {
            if (typeof gtag !== 'undefined') {
                gtag('config', Analytics.TRACKING_ID, {
                    page_path: pathname || '',
                    page_title: title
                });
            } else if (typeof ga !== 'undefined') {
                ga('send', 'pageview', pathname || window.location.pathname, {
                    title: title,
                    pathname: pathname || ''
                });
            }
        }
    }]);

    return Analytics;
}();

exports.Analytics = Analytics;

},{"../Site":13}],46:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Breakpoint_1 = require("../Breakpoint");

var Button = function () {
    function Button() {
        _classCallCheck(this, Button);
    }

    _createClass(Button, null, [{
        key: "bind",
        value: function bind(target) {
            if (!Breakpoint_1.breakpoint.desktop) {
                return;
            }
            var $target = $(typeof target !== 'undefined' ? target : 'body');
            $target.find('.button--circle').off('.button--circle').on('mouseenter.button--circle', this.mouseenterButtonCircle).on('mouseleave.button--circle', this.mouseleaveButtonCircle);
            $target.find('.button--circlesmall').off('.button--circlesmall').on('mouseenter.button--circlesmall', this.mouseenterButtonCircleSmall).on('mouseleave.button--circlesmall', this.mouseleaveButtonCircleSmall);
            $target.find('.button--icon').off('.button--icon').on('mouseenter.button--icon', this.mouseenterButtonIcon).on('mouseleave.button--icon', this.mouseleaveButtonIcon);
            $target.find('.footer__item a').off('.footer').on('mouseenter.footer', this.mouseenterFooterItem).on('mouseleave.footer', this.mouseleaveFooterItem);
        }
    }]);

    return Button;
}();

exports.Button = Button;
Button.mouseenterFooterItem = function (e) {
    var el = $(e.currentTarget);
    var text1 = el.find('.footer__item__container span').eq(0);
    var text2 = el.find('.footer__item__container span').eq(1);
    gsap.killTweensOf([text1, text2]);
    var h = el.find('.footer__item__container').height() * 1.2;
    var deg = 0;
    gsap.fromTo(text1, 0.35, { y: 0, rotation: 0, opacity: 1 }, { y: -h, rotation: deg, opacity: 0, ease: 'sine.out' });
    gsap.fromTo(text2, 0.35, { y: h, rotation: deg, opacity: 0 }, { y: 0, rotation: 0, opacity: 1, ease: 'sine.out' });
};
Button.mouseleaveFooterItem = function (e) {
    var el = $(e.currentTarget);
    var text1 = el.find('.footer__item__container span').eq(0);
    var text2 = el.find('.footer__item__container span').eq(1);
    gsap.killTweensOf([text1, text2]);
    var h = el.find('.footer__item__container').height() * 1.2;
    var deg = 0;
    gsap.set(text1, { y: 0, rotation: 0 });
    gsap.fromTo(text1, 0.25, { opacity: 0 }, { opacity: 1, ease: 'sine.out' });
    gsap.fromTo(text2, 0.25, { opacity: 1 }, { opacity: 0, ease: 'sine.out' });
};
Button.mouseenterButtonCircle = function (e) {
    var svg = $(e.currentTarget).find('svg');
    var line = svg.find('line');
    var dot = svg.find('circle').eq(1);
    gsap.killTweensOf([line, dot]);
    gsap.to(line, 0.25, { x: 35, ease: 'sine.out' });
    gsap.to(dot, 0.4, { r: 10, ease: 'back.out(5)' });
    var text1 = $(e.currentTarget).find('.button__text span').eq(0);
    var text2 = $(e.currentTarget).find('.button__text span').eq(1);
    var h = $(e.currentTarget).find('.button__text').height() * 1.2;
    var deg = 0;
    gsap.fromTo(text1, 0.35, { y: 0, rotation: 0, opacity: 1 }, { y: -h, rotation: deg, opacity: 0, ease: 'sine.out' });
    gsap.fromTo(text2, 0.35, { y: h, rotation: deg, opacity: 0 }, { y: 0, rotation: 0, opacity: 1, ease: 'sine.out' });
};
Button.mouseleaveButtonCircle = function (e) {
    var svg = $(e.currentTarget).find('svg');
    var line = svg.find('line');
    var dot = svg.find('circle').eq(1);
    gsap.killTweensOf([line, dot]);
    gsap.to(line, 0.25, { x: 0, ease: 'sine.out' });
    gsap.to(dot, 0.4, { r: 0, ease: 'sine.out' });
    var text1 = $(e.currentTarget).find('.button__text span').eq(0);
    var text2 = $(e.currentTarget).find('.button__text span').eq(1);
    var h = $(e.currentTarget).find('.button__text').height() * 1.2;
    var deg = 0;
    gsap.fromTo(text1, 0.35, { y: -h, rotation: deg, opacity: 0 }, { y: 0, rotation: 0, opacity: 1, ease: 'sine.out' });
    gsap.fromTo(text2, 0.35, { y: 0, rotation: 0, opacity: 1 }, { y: h, rotation: deg, opacity: 0, ease: 'sine.out' });
};
Button.mouseenterButtonCircleSmall = function (e) {
    var svg = $(e.currentTarget).find('svg');
    var line = svg.find('line');
    var dot = svg.find('circle').eq(1);
    gsap.killTweensOf([line, dot]);
    gsap.to(line, 0.25, { x: 16, ease: 'sine.out' });
    gsap.to(dot, 0.4, { r: 6, ease: 'back.out(5)' });
    var text1 = $(e.currentTarget).find('.button__text span').eq(0);
    var text2 = $(e.currentTarget).find('.button__text span').eq(1);
    var h = $(e.currentTarget).find('.button__text').height() * 1.2;
    var deg = 0;
    gsap.fromTo(text1, 0.35, { y: 0, rotation: 0, opacity: 1 }, { y: -h, rotation: deg, opacity: 0, ease: 'sine.out' });
    gsap.fromTo(text2, 0.35, { y: h, rotation: deg, opacity: 0 }, { y: 0, rotation: 0, opacity: 1, ease: 'sine.out' });
};
Button.mouseleaveButtonCircleSmall = function (e) {
    var svg = $(e.currentTarget).find('svg');
    var line = svg.find('line');
    var dot = svg.find('circle').eq(1);
    gsap.killTweensOf([line, dot]);
    gsap.to(line, 0.25, { x: 0, ease: 'sine.out' });
    gsap.to(dot, 0.4, { r: 0, ease: 'sine.out' });
    var text1 = $(e.currentTarget).find('.button__text span').eq(0);
    var text2 = $(e.currentTarget).find('.button__text span').eq(1);
    var h = $(e.currentTarget).find('.button__text').height() * 1.2;
    var deg = 0;
    gsap.fromTo(text1, 0.35, { y: -h, rotation: deg, opacity: 0 }, { y: 0, rotation: 0, opacity: 1, ease: 'sine.out' });
    gsap.fromTo(text2, 0.35, { y: 0, rotation: 0, opacity: 1 }, { y: h, rotation: deg, opacity: 0, ease: 'sine.out' });
};
Button.mouseenterButtonIcon = function (e) {
    var svg = $(e.currentTarget).find('.svg-circle');
    var circle = svg.find('circle').eq(1);
    gsap.killTweensOf(svg);
    gsap.to(circle, 0.4, { strokeDashoffset: "80", ease: 'sine.out' });
};
Button.mouseleaveButtonIcon = function (e) {
    var svg = $(e.currentTarget).find('.svg-circle');
    var circle = svg.find('circle').eq(1);
    gsap.killTweensOf(svg);
    gsap.to(circle, 0.4, { strokeDashoffset: "251", ease: 'sine.out' });
};

},{"../Breakpoint":2}],47:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Cookies = function () {
    function Cookies() {
        _classCallCheck(this, Cookies);
    }

    _createClass(Cookies, null, [{
        key: "bind",
        value: function bind(target) {
            var _this = this;

            var $target = $(typeof target !== 'undefined' ? target : 'body');
            setTimeout(function () {
                if ($('.cookies').length > 0) {
                    var cookies_personalization = Cookies.getCookie('cookies_personalization');
                    if (cookies_personalization === 'granted') {
                        $('#cookies_personalization').prop("checked", true);
                    }
                    var cookies_analytics = Cookies.getCookie('cookies_analytics');
                    if (cookies_analytics === 'granted') {
                        $('#cookies_analytics').prop("checked", true);
                    }
                    var cookies_marketing = Cookies.getCookie('cookies_marketing');
                    if (cookies_marketing === 'granted') {
                        $('#cookies_marketing').prop("checked", true);
                    }
                    var cookies_functionality = Cookies.getCookie('cookies_functionality');
                    if (cookies_functionality === 'granted') {
                        $('#cookies_functionality').prop("checked", true);
                    }
                    _this.check();
                    var cookies = Cookies.getCookie('cookies_main');
                    if (cookies === '') {
                        _this.show($('.cookies'));
                    }
                }
            }, 100);
            $target.find('.cookies__settings').off().on('click', function (e) {
                return _this.showPanel();
            });
            $target.find('.cookies__accept-all').off().on('click', function (e) {
                _this.onAll();
                _this.check();
                _this.hide();
            });
            $target.find('.cookies__settings-accept').off().on('click', function (e) {
                _this.check();
                _this.hidePanel();
                _this.hide();
            });
            $target.find('.cookies__settings-close').off().on('click', function (e) {
                return _this.hidePanel();
            });
            $target.find('.cookies__show').off().on('click', function (e) {
                return _this.show($('.cookies'));
            });
        }
    }, {
        key: "setCookie",
        value: function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            var expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        }
    }, {
        key: "getCookie",
        value: function getCookie(cname) {
            var name = cname + '=';
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
    }, {
        key: "show",
        value: function show(cookiesBox) {
            cookiesBox.addClass('showed');
            gsap.set(cookiesBox, { 'display': 'block', y: '100%' });
            gsap.to(cookiesBox, 0.5, { y: '0%', ease: 'sine.easeOut', onComplete: function onComplete() {} });
            var cookiesCurtain = $('.cookies__curtain');
            gsap.to(cookiesCurtain, 0.5, { opacity: 0.5, ease: 'sine.easeOut', onComplete: function onComplete() {
                    cookiesCurtain.css({ 'display': 'block' });
                } });
        }
    }, {
        key: "hide",
        value: function hide() {
            var cookiesBox = $('.cookies');
            gsap.to(cookiesBox, 0.5, {
                y: '100%',
                ease: 'sine.easeOut',
                onComplete: function onComplete() {
                    cookiesBox.css({ 'display': 'none' });
                    cookiesBox.removeClass('showed');
                }
            });
            var cookiesCurtain = $('.cookies__curtain');
            gsap.to(cookiesCurtain, 0.5, { opacity: 0, ease: 'sine.easeOut', onComplete: function onComplete() {
                    cookiesCurtain.css({ 'display': 'none' });
                } });
            Cookies.setCookie('cookies_main', 'close', 365);
        }
    }, {
        key: "showPanel",
        value: function showPanel() {
            var _this2 = this;

            if (!this.isAnimating) {
                this.isAnimating = true;
                var panel = $('.cookies__settings-panel');
                var h = panel.outerHeight(true);
                gsap.set(panel, { display: 'block', y: h });
                gsap.to(panel, this.time, {
                    y: 0,
                    onComplete: function onComplete() {
                        _this2.isAnimating = false;
                    }
                });
            }
        }
    }, {
        key: "hidePanel",
        value: function hidePanel() {
            if (!Cookies.isAnimating) {
                Cookies.isAnimating = true;
                var panel = $('.cookies__settings-panel');
                var h = panel.outerHeight(true);
                gsap.to(panel, Cookies.time, {
                    y: h,
                    onComplete: function onComplete() {
                        gsap.set(panel, { display: 'none' });
                        panel.removeClass('is-open');
                        Cookies.isAnimating = false;
                    }
                });
            }
        }
    }, {
        key: "check",
        value: function check() {
            var checkPersonalization = 'denied';
            var checkAnalytics = 'denied';
            var checkMarketing = 'denied';
            var checkFunctionality = 'denied';
            if ($('#cookies_personalization').is(':checked')) {
                checkPersonalization = 'granted';
            } else {}
            if ($('#cookies_analytics').is(':checked')) {
                checkAnalytics = 'granted';
            } else {}
            if ($('#cookies_marketing').is(':checked')) {
                checkMarketing = 'granted';
            } else {}
            if ($('#cookies_functionality').is(':checked')) {
                checkFunctionality = 'granted';
            } else {}
            if (typeof gtag !== 'undefined') {
                gtag('consent', 'update', {
                    'security_storage': 'granted',
                    'analytics_storage': checkAnalytics,
                    'ad_storage': checkMarketing,
                    'ad_user_data': checkMarketing,
                    'ad_personalization': checkMarketing,
                    'personalization_storage': checkPersonalization,
                    'functionality_storage': checkFunctionality
                });
            } else {}
            Cookies.setCookie('cookies_personalization', checkPersonalization, 365);
            Cookies.setCookie('cookies_analytics', checkAnalytics, 365);
            Cookies.setCookie('cookies_marketing', checkMarketing, 365);
            Cookies.setCookie('cookies_functionality', checkFunctionality, 365);
        }
    }, {
        key: "onAll",
        value: function onAll() {
            $('#cookies_personalization').prop("checked", true);
            $('#cookies_analytics').prop("checked", true);
            $('#cookies_marketing').prop("checked", true);
            $('#cookies_functionality').prop("checked", true);
        }
    }]);

    return Cookies;
}();

exports.Cookies = Cookies;
Cookies.isAnimating = false;
Cookies.time = 0.8;
Cookies.timeIcon = 0.25;

},{}],48:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Copy = function () {
    function Copy() {
        _classCallCheck(this, Copy);
    }

    _createClass(Copy, null, [{
        key: "bind",
        value: function bind(target) {
            var $target = $(typeof target !== 'undefined' ? target : 'body');
            $target.find('[data-copy]').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $el = $(e.currentTarget);
                var data = $el.data('copy');
                var text = data || window.location.origin + window.location.pathname;
                Clipboard.copy(text);
                window.console.info('"%s" copied', text);
                $el.addClass('is-copied');
                setTimeout(function () {
                    $el.removeClass('is-copied');
                }, 1000);
            });
        }
    }]);

    return Copy;
}();

exports.Copy = Copy;

},{}],49:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Datepicker = function () {
    function Datepicker() {
        _classCallCheck(this, Datepicker);
    }

    _createClass(Datepicker, null, [{
        key: "bind",
        value: function bind(target) {
            var $target = $(typeof target !== 'undefined' ? target : 'body');
            $target.find('input[type=date]').each(function (i, el) {
                var $el = $(el);
                var value = $el.is('[value]') ? $el.val() : null;
                var min = $el.data('min');
                var max = $el.data('max');
                $el.attr('type', 'text').datepicker({
                    dateFormat: Datepicker.dateFormat,
                    defaultDate: value ? new Date(value) : new Date(),
                    minDate: min ? new Date(min) : null,
                    maxDate: max ? new Date(max) : null,
                    monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
                    monthNamesShort: ['Sty', 'Lu', 'Mar', 'Kw', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Pa', 'Lis', 'Gru'],
                    onSelect: Datepicker.onSelect,
                    firstDay: 1
                });
            });
        }
    }]);

    return Datepicker;
}();

exports.Datepicker = Datepicker;
Datepicker.dateFormat = 'dd-mm-yy';
Datepicker.onSelect = function (selectedDate, instance) {
    var $input = $(instance.input);
    var formattedDate = selectedDate.split('-').reverse().join('-');
    var date = new Date(formattedDate);
    var restrictMin = $input.data('restrict-min');
    var restrictMax = $input.data('restrict-max');
    $('#' + restrictMin).datepicker('option', 'minDate', date);
    $('#' + restrictMax).datepicker('option', 'maxDate', date);
    $input.val(formattedDate).trigger('change');
};

},{}],50:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Email = function () {
    function Email() {
        _classCallCheck(this, Email);
    }

    _createClass(Email, null, [{
        key: "bind",
        value: function bind(target) {
            var $target = $(typeof target !== 'undefined' ? target : 'body');
            $target.find('[data-poczta]').each(function (i, el) {
                var mail = atob($(el).data('poczta'));
                el.href = 'mailto:' + mail;
                if (el.innerHTML === '') {
                    el.text = mail;
                }
                $(el).removeAttr('data-poczta hidden');
            });
        }
    }]);

    return Email;
}();

exports.Email = Email;

},{}],51:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Fb = function () {
    function Fb() {
        _classCallCheck(this, Fb);
    }

    _createClass(Fb, null, [{
        key: "bind",
        value: function bind(target) {
            var $target = $(typeof target !== 'undefined' ? target : 'body');
            $target.find('[data-facebook]').off().on('click.fb', Fb.onFacebookLoginClick);
            if (typeof FB !== 'undefined') {
                try {
                    FB.XFBML.parse();
                } catch (ex) {
                    console.warn('FB parse failed');
                }
            }
        }
    }]);

    return Fb;
}();

exports.Fb = Fb;
Fb.onFacebookLoginClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    var fburl = $(e.currentTarget).data('facebook');
    if (typeof FB !== 'undefined') {
        FB.login(function (response) {
            if (response.authResponse) {
                FB.api('/me', function () {
                    window.location.assign(fburl + '&token=' + response.authResponse.accessToken);
                });
            }
        }, {
            scope: 'email'
        });
    } else {
        console.warn('There is no Facebook SDK loaded yet…');
        $(e.currentTarget).addClass('is-waiting');
    }
    return false;
};

},{}],52:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Utils = require("../Utils");
var PushStates_1 = require("../PushStates");
var Templates_1 = require("../Templates");
var Site_1 = require("../Site");
var Scrolling_1 = require("../Scrolling");

var Form = function () {
    function Form() {
        _classCallCheck(this, Form);
    }

    _createClass(Form, null, [{
        key: "reset",
        value: function reset(form) {
            var elements = form.elements;
            form.reset();
            for (var i = 0; i < elements.length; i++) {
                switch (elements[i].type.toLowerCase()) {
                    case 'text':
                    case 'password':
                    case 'textarea':
                    case 'hidden':
                        elements[i].value = '';
                        break;
                    case 'radio':
                    case 'checkbox':
                        elements[i].checked = false;
                        break;
                    case 'select-one':
                    case 'select-multi':
                        elements[i].selectedIndex = 0;
                        break;
                    default:
                        break;
                }
                $(elements[i]).trigger('change');
            }
        }
    }, {
        key: "bind",
        value: function bind(target) {
            Form.setup();
            var $target = $(typeof target !== 'undefined' ? target : 'body');
            $('form', $target).not('[novalidate]').each(function (i, o) {
                $(o).parsley(Form.formConfig).on('field:validated', function (fieldInstance) {
                    var $el = fieldInstance.$element;
                    var isCheckbox = $el.is('[type=radio], [type=checkbox]');
                    var isSelfHidden = $el.css('display') === 'none';
                    var isInsideHidden = $el.closest('[aria-hidden="true"]')[0];
                    var isHidden = isSelfHidden || isInsideHidden;
                    if (!isCheckbox && isHidden) {
                        fieldInstance._ui.$errorsWrapper.css('display', 'none');
                        fieldInstance.validationResult = true;
                        return true;
                    } else {
                        fieldInstance._ui.$errorsWrapper.css('display', '');
                    }
                }).on('form:validate', function (formInstance) {}).on('form:success', function (formInstance) {}).on('form:error', function (formInstance) {
                    var form = formInstance.$element;
                    if (!form.is('#popup-subscribe-form')) {
                        var $firstError = formInstance.$element.find('.parsley-error').parent();
                        Scrolling_1.Scrolling.scrollToElement($firstError, false, -40);
                    }
                }).on('form:submit', function (formInstance) {
                    var form = formInstance.$element;
                    var pathname = form.attr('action') || window.location.pathname;
                    var params = Utils.serialize(form);
                    var isPost = form.is('[method="post"]');
                    var isApi = form.is('[data-api]');
                    if (isApi) {
                        Form.submitAPI(form);
                        return false;
                    }
                    if (!isPost) {
                        PushStates_1.PushStates.goTo(pathname + '?' + params);
                    } else {
                        Form.submitAjax(form);
                    }
                    return false;
                });
            });
            $('[data-clear-form]').off('.clear-form').on('click.clear-form', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $form = $($(e.currentTarget).data('clear-form'));
                Form.reset($form[0]);
                $form.trigger('submit');
                return false;
            });
            Site_1.$body.on('click.filtered', '.js-filtered', function (e) {
                e.preventDefault();
                e.stopPropagation();
                gsap.to(e.currentTarget, {
                    duration: 0.3,
                    pointerEvents: 'none',
                    overflow: 'hidden',
                    margin: 0,
                    width: 0,
                    opacity: 0,
                    onComplete: function onComplete() {
                        $('#' + $(e.currentTarget).attr('for')).prop('checked', false).trigger('change');
                    }
                });
            });
        }
    }, {
        key: "submitAPI",
        value: function submitAPI($form) {
            var _this = this;

            var dataForm = $form.data('form');
            var containerForm = $(dataForm.containerForm);
            var containerSuccess = $(dataForm.containerSuccess);
            var containerFailure = $(dataForm.containerFailure);
            var data = { 'action': $form.attr('action'), params: $form.serializeObject() };
            $form.addClass('is-doing-request');
            $.ajax({
                url: '/application/api/server.php',
                global: false,
                type: 'POST',
                dataType: 'json',
                data: data,
                async: true,
                success: function success(response) {
                    $('.consola').html(response.result + ' ' + response.id);
                    if (!response.noHideForm) {
                        if (containerForm[0]) {
                            _this.hideContainer(containerForm);
                        }
                    }
                    if (response.result === "success") {
                        if (containerSuccess[0]) {
                            if (response.message) {
                                containerSuccess.html(response.message);
                            }
                            _this.showContainer(containerSuccess);
                            Scrolling_1.Scrolling.scrollToElement(containerSuccess, false, -200);
                        }
                    } else {
                        if (containerFailure[0]) {
                            if (response.message) {
                                containerFailure.html(response.message);
                            }
                            _this.showContainer(containerFailure);
                            Scrolling_1.Scrolling.scrollToElement(containerFailure, false, -200);
                        }
                    }
                },
                error: function error(e) {
                    console.error(e);
                    $form.removeClass('is-doing-request');
                },
                complete: function complete() {
                    $form.addClass('is-doing-request');
                }
            });
        }
    }, {
        key: "hideContainer",
        value: function hideContainer(el) {
            gsap.to(el, 0.2, {
                opacity: 0,
                ease: 'sine.out',
                onComplete: function onComplete() {
                    gsap.set(el, { 'display': 'none' });
                }
            });
        }
    }, {
        key: "showContainer",
        value: function showContainer(el) {
            gsap.set(el, { 'display': 'block' });
            gsap.to(el, 0.2, { opacity: 1, ease: 'sine.out', delay: 0.2, onComplete: function onComplete() {} });
        }
    }, {
        key: "submitAjax",
        value: function submitAjax($form) {
            var url = $form.attr('action') || window.location.pathname;
            var data = $form.serializeObject();
            var options = $.extend(Form.defaultOptions, $form.data('options') || {});
            $form.addClass('is-doing-request');
            $.ajax({
                context: $form[0],
                url: url,
                global: false,
                type: 'POST',
                dataType: options.type,
                data: data,
                async: true,
                success: function success(response) {
                    return Form.onSuccess(response, $form);
                },
                error: function error(_error) {
                    return Form.onError(_error, $form);
                }
            });
        }
    }, {
        key: "onSuccess",
        value: function onSuccess(response, $form) {
            var options = $.extend(Form.defaultOptions, $form.data('options') || {});
            var $success = options.success ? $(options.success) : null;
            var $fail = options.fail ? $(options.fail) : null;
            $form.removeClass('is-doing-request');
            if ($success && $success[0]) {
                if (response.message) {
                    $success.find('.message').text(response.message);
                }
                $success.toggle(!!response.result);
                if (response.result) {
                    Scrolling_1.Scrolling.scrollToElement($success, false, -34);
                }
            }
            if ($fail && $fail[0]) {
                if (response.message) {
                    $fail.find('.message').text(response.message);
                }
                $fail.toggle(!response.result);
                if (!response.result) {
                    Scrolling_1.Scrolling.scrollToElement($fail, false, -34);
                }
            }
            if (options.response) {
                switch (options.type) {
                    case 'html':
                        Form.renderHtml(response, options.response);
                        break;
                    case 'json':
                        Form.renderJSON(response, options.response, options.template);
                        break;
                    default:
                        break;
                }
            }
            if (options.hide && !!response.result) {
                (options.hide === true ? $form : $(options.hide)).hide();
            }
            if (options.reset && !!response.result) {
                $form[0].reset();
            }
            if ((options.redirectURL || response.redirectURL) && !!response.result) {
                setTimeout(function () {
                    window.location.replace(options.redirectURL || response.redirectURL);
                }, options.redirectDelay || 1000);
            }
        }
    }, {
        key: "renderHtml",
        value: function renderHtml(response, selector) {
            var loadedContent = $(response).find(selector);
            if (!loadedContent[0]) {
                loadedContent = $(response).filter(selector);
            }
            if (!loadedContent[0]) {
                console.warn('no response element found!');
                return;
            }
            $(selector).replaceWith(loadedContent);
        }
    }, {
        key: "renderJSON",
        value: function renderJSON(response, selector, templateName) {
            var template = Templates_1.Templates.get(response.template || templateName || 'form-response');
            var html = template.render(response);
            $(selector).html(html);
        }
    }, {
        key: "setup",
        value: function setup() {
            var siteLang = $('html').attr('lang');
            window.Parsley.setLocale(siteLang);
            window.Parsley.addValidator('palindrome', {
                validateString: function validateString(value) {
                    return value.split('').reverse().join('') === value;
                },
                messages: {
                    en: 'This string is not the reverse of itself',
                    pl: "To nie jest palidrom",
                    ua: "Це не палідром"
                }
            });
            window.Parsley.addValidator('dateformat', {
                validate: function validate(value, id) {
                    var isValid = moment(value, "YYYY-MM-DD", true).isValid();
                    return isValid;
                },
                messages: {
                    en: 'Please provide date in format YYYY-MM-DD',
                    pl: 'Proszę podać poprawną datę w formacie RRRR-MM-DD',
                    ua: 'Будь ласка, введіть правильну дату у форматі RRRR-MM-DD'
                }
            });
            window.Parsley.addValidator('dateformataddoffer', {
                validate: function validate(value, id) {
                    var isValid = moment(value, "YYYY-MM-DD", true).isValid();
                    if (isValid) {
                        var valueDate = new Date(value);
                        var today = new Date();
                        var today30 = new Date();
                        today30.setDate(today30.getDate() + 30);
                        if (valueDate < today || valueDate > today30) {
                            isValid = false;
                        }
                    }
                    return isValid;
                },
                messages: {
                    en: 'Please provide date in format YYYY-MM-DD to 30 days',
                    pl: 'Proszę podać poprawną datę w formacie RRRR-MM-DD do 30 dni',
                    ua: 'Будь ласка, вкажіть правильну дату у форматі ГГГГ-ММ-ДД до 30 днів'
                }
            });
            window.Parsley.addValidator('nip', {
                validateString: function validateString(value) {
                    return Form.nip(value);
                },
                messages: {
                    en: 'NIP not correct',
                    pl: 'NIP jest niepoprawny',
                    ua: 'NIP є неправильним'
                }
            });
            window.Parsley.addValidator('pesel', {
                validateString: function validateString(value) {
                    return Form.pesel(value);
                },
                messages: {
                    en: 'PESEL not correct',
                    pl: 'PESEL jest niepoprawny',
                    ua: 'PESEL є неправильним'
                }
            });
            window.Parsley.addValidator('checkpassword', {
                validateString: function validateString(value) {
                    var data = { 'action': 'checkPassword', 'password': value };
                    return Form.checkPassword(data);
                },
                messages: {
                    en: 'Password not correct',
                    pl: 'Hasło jest niepoprawne',
                    ua: 'Неправильний пароль'
                }
            });
        }
    }, {
        key: "nip",
        value: function nip(_nip) {
            if (typeof _nip !== 'string') return false;
            _nip = _nip.replace(/[\ \-]/gi, '');
            var weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
            var sum = 0;
            var controlNumber = parseInt(_nip.substring(9, 10));
            var weightCount = weight.length;
            for (var i = 0; i < weightCount; i++) {
                sum += parseInt(_nip.substr(i, 1)) * weight[i];
            }
            return sum % 11 === controlNumber;
        }
    }, {
        key: "pesel",
        value: function pesel(_pesel) {
            if (_pesel.length == 11) {
                var w = Array(1, 3, 7, 9);
                var wk = 0;
                for (var i = 0; i <= 9; i++) {
                    wk = (wk + _pesel[i] * w[i % 4]) % 10;
                }
                var k = (10 - wk) % 10;
                if (_pesel[10] == k) {
                    if (_pesel === '00000000000' || _pesel === '22222222222' || _pesel === '44444444444' || _pesel === '66666666666' || _pesel === '88888888888') {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    }, {
        key: "checkPassword",
        value: function checkPassword(dataAtr) {
            var resultCheck = false;
            $('body').addClass('is-ajaxing');
            $.ajax({
                url: '/application/api/server.php',
                global: false,
                type: 'POST',
                dataType: 'json',
                async: false,
                data: dataAtr,
                success: function success(response) {
                    if (response.result === "success") {
                        resultCheck = true;
                        return true;
                    } else {
                        resultCheck = false;
                        return false;
                    }
                },
                error: function error(e) {},
                complete: function complete() {
                    $('body').removeClass('is-ajaxing');
                }
            });
            return resultCheck;
        }
    }]);

    return Form;
}();

exports.Form = Form;
Form.formConfig = {
    errorsContainer: function errorsContainer(d) {
        return d.$element.siblings('.error, .form__error')[0] ? d.$element.siblings('.error, .form__error') : d.$element.closest('.form__row').find('.form__error');
    }
};
Form.defaultOptions = {
    type: 'html',
    template: 'form-response',
    reset: false,
    hide: false,
    redirectDelay: 1000
};
Form.onError = function (error, $form) {
    var options = $.extend(Form.defaultOptions, $form.data('options') || {});
    var $success = options.success ? $(options.success) : null;
    var $fail = options.fail ? $(options.fail) : null;
    $form.removeClass('is-doing-request');
    if ($fail && $fail[0]) {
        $fail.show();
        Scrolling_1.Scrolling.scrollToElement($fail, false, -100);
    }
    if ($success && $success[0]) {
        $success.hide();
    }
    if (options.response && options.type === 'json') {
        Form.renderJSON({ message: error.responseText, template: 'form-response' }, options.response);
    }
};

},{"../PushStates":11,"../Scrolling":12,"../Site":13,"../Templates":14,"../Utils":15}],53:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Formhint = function () {
    function Formhint() {
        _classCallCheck(this, Formhint);
    }

    _createClass(Formhint, null, [{
        key: "bind",
        value: function bind(selector) {
            var target = typeof selector === 'undefined' ? 'body' : selector;
            $('.formhint').off('click__toggle').on('click.click__toggle', function (e) {
                e.preventDefault();
                var toggle = $(e.currentTarget);
                if (toggle.hasClass('showed')) {
                    Formhint.hide(toggle);
                } else {
                    Formhint.show(toggle);
                }
            });
            $('.formhint').off('mouseenter__toggle').on('mouseenter.mouseenter__toggle', function (e) {
                e.preventDefault();
                var toggle = $(e.currentTarget);
                Formhint.show(toggle);
            });
            $('.formhint').off('mouseleave__toggle').on('mouseleave.mouseleave__toggle', function (e) {
                e.preventDefault();
                var toggle = $(e.currentTarget);
                Formhint.hide(toggle);
            });
        }
    }, {
        key: "show",
        value: function show(toggle) {
            var toggleText = toggle.find('.formhint__text');
            gsap.set(toggleText, { 'display': 'block', 'opcaity': '0' });
            gsap.to(toggleText, 0.5, { opacity: 1, onComplete: function onComplete() {
                    toggle.addClass('showed');
                } });
        }
    }, {
        key: "hide",
        value: function hide(toggle) {
            var toggleText = toggle.find('.formhint__text');
            gsap.to(toggleText, 0.5, { opacity: 0, onComplete: function onComplete() {
                    toggle.removeClass('showed');
                    gsap.set(toggleText, { 'display': 'none', 'opcaity': '0' });
                } });
        }
    }]);

    return Formhint;
}();

exports.Formhint = Formhint;

},{}],54:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Breakpoint_1 = require("../Breakpoint");

var Iscroll = function () {
    function Iscroll() {
        _classCallCheck(this, Iscroll);
    }

    _createClass(Iscroll, null, [{
        key: "bind",
        value: function bind(target) {
            if (!Breakpoint_1.breakpoint.desktop) {
                return;
            }
            var $target = $(typeof target !== 'undefined' ? target : 'body');
            $.each($target.find('.js-scroll'), function (i, el) {
                var $el = $(el);
                if (!$el.data('scroll')) {
                    var scroll = new IScroll(el, {
                        click: true,
                        fadeScrollbars: true,
                        interactiveScrollbars: true,
                        mouseWheel: false,
                        preventDefault: true,
                        scrollbars: true,
                        scrollX: true,
                        scrollY: false,
                        bounce: true
                    });
                    $(el).data('scroll', scroll);
                    var $items = $el.find('.js-slider-item');
                    var $bullets = $el.find('.js-slider-bullet');
                    if (Breakpoint_1.breakpoint.desktop) {
                        $bullets.on('click', function (e) {
                            var currentIndex = $bullets.index($(e.currentTarget));
                            $bullets.removeClass('is-current').eq(currentIndex).addClass('is-current');
                            scroll.scrollToElement($items[currentIndex], null, true, null);
                        });
                        scroll.on('scrollStart', function () {
                            return $bullets.removeClass('is-current');
                        });
                    }
                }
            });
        }
    }]);

    return Iscroll;
}();

exports.Iscroll = Iscroll;

},{"../Breakpoint":2}],55:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Images = function () {
    function Images() {
        _classCallCheck(this, Images);
    }

    _createClass(Images, null, [{
        key: "bind",
        value: function bind(selector) {
            var target = typeof selector === 'undefined' ? 'body' : selector;
            $(target).find('[data-src]').each(function (i, img) {
                img.setAttribute('src', img.getAttribute('data-src'));
                img.removeAttribute('data-src');
            });
            $(target).find('[data-srcset]').each(function (i, img) {
                img.setAttribute('srcset', img.getAttribute('data-srcset'));
                img.removeAttribute('data-srcset');
            });
            if ($(target).find('[data-imagefill]').length > 0) {
                console.info('Instead of `[data-imagefill]` please use css `object-fit`…');
            }
        }
    }]);

    return Images;
}();

exports.Images = Images;
Images.onError = function (e) {
    console.warn(e);
};
Images.onLoad = function (e) {
    e.target.classList.remove('is-loading');
};

},{}],56:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Lang = function () {
    function Lang() {
        _classCallCheck(this, Lang);
    }

    _createClass(Lang, null, [{
        key: "bind",
        value: function bind(target) {}
    }]);

    return Lang;
}();

exports.Lang = Lang;

},{}],57:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Popup = function () {
    function Popup() {
        _classCallCheck(this, Popup);
    }

    _createClass(Popup, null, [{
        key: "bind",
        value: function bind(target) {
            var _this = this;

            var $target = $(typeof target !== 'undefined' ? target : 'body');
            if ($target.find('.popup').length > 0) {
                if (!$target.find('.popup').hasClass('is-closed')) {
                    this.show($target.find('.popup'), $target.find('.popup__container'));
                }
            }
            $target.find('.popup__closer').off('.popup').on('click.popup', function (e) {
                var $view = $(e.currentTarget).closest('.popup');
                var $container = $view.find('.popup__container');
                _this.hide($view, $container);
            });
        }
    }, {
        key: "show",
        value: function show($view, $container) {
            gsap.set($view, { display: 'flex' });
            gsap.from($container, 0.5, {
                opacity: 0,
                ease: 'sine.out',
                onComplete: function onComplete() {}
            });
        }
    }, {
        key: "hide",
        value: function hide($view, $container) {
            gsap.to($view, 0.5, {
                opacity: 0,
                ease: 'sine.out',
                onComplete: function onComplete() {
                    gsap.set($view, { display: 'none' });
                    $view.addClass('is-closed');
                }
            });
        }
    }]);

    return Popup;
}();

exports.Popup = Popup;

},{}],58:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Cookies_1 = require("./Cookies");

var PopupNewsletter = function () {
    function PopupNewsletter() {
        _classCallCheck(this, PopupNewsletter);
    }

    _createClass(PopupNewsletter, null, [{
        key: "bind",
        value: function bind(target) {
            var _this = this;

            var $target = $(typeof target !== 'undefined' ? target : 'body');
            if ($target.find('.popup-newsletter').length > 0 && $target.find('[data-popup-newsletter]').length > 0) {
                if (!$target.find('.popup-newsletter').hasClass('is-closed')) {
                    setTimeout(function () {
                        var cookiesNewsletter = Cookies_1.Cookies.getCookie('newsletter');
                        if (cookiesNewsletter === '') {
                            setTimeout(function () {
                                _this.show($target.find('.popup-newsletter'), $target.find('.popup-newsletter__container'));
                            }, 30000);
                        }
                    }, 0);
                }
            }
            $target.find('.popup-newsletter__closer').off('.popup-newsletter').on('click.popup-newsletter', function (e) {
                var $view = $(e.currentTarget).closest('.popup-newsletter');
                var $container = $view.find('.popup-newsletter__container');
                _this.hide($view, $container);
                Cookies_1.Cookies.setCookie('newsletter', 'close', 30);
            });
        }
    }, {
        key: "show",
        value: function show($view, $container) {
            gsap.set($view, { display: 'flex' });
            gsap.from($container, 0.5, {
                opacity: 0,
                ease: 'sine.out',
                onComplete: function onComplete() {}
            });
        }
    }, {
        key: "hide",
        value: function hide($view, $container) {
            gsap.to($view, 0.5, {
                opacity: 0,
                ease: 'sine.out',
                onComplete: function onComplete() {
                    gsap.set($view, { display: 'none' });
                    $view.addClass('is-closed');
                }
            });
        }
    }]);

    return PopupNewsletter;
}();

exports.PopupNewsletter = PopupNewsletter;

},{"./Cookies":47}],59:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Handler_1 = require("../Handler");

var VisibilityState = function VisibilityState() {
    _classCallCheck(this, VisibilityState);
};

exports.VisibilityState = VisibilityState;
VisibilityState.CHANGE = 'change';
VisibilityState.HIDDEN = 'hidden';
VisibilityState.VISIBLE = 'visible';
VisibilityState.PRERENDER = 'prerender';
VisibilityState.UNLOADED = 'unloaded';

var Visibility = function (_Handler_1$Handler) {
    _inherits(Visibility, _Handler_1$Handler);

    function Visibility() {
        _classCallCheck(this, Visibility);

        var _this = _possibleConstructorReturn(this, (Visibility.__proto__ || Object.getPrototypeOf(Visibility)).call(this));

        _this.check = function () {
            var state = _this.getState();
            _this.trigger(VisibilityState.CHANGE, state);
            _this.trigger(state);
        };
        if (Modernizr.pagevisibility) {
            var visibilityChange = typeof document.mozHidden !== 'undefined' ? 'mozvisibilitychange' : 'visibilitychange';
            document.addEventListener(visibilityChange, _this.check);
            _this.check();
        }
        return _this;
    }

    _createClass(Visibility, [{
        key: "getState",
        value: function getState() {
            return Modernizr.prefixed('visibilityState', document);
        }
    }]);

    return Visibility;
}(Handler_1.Handler);

exports.Visibility = Visibility;

},{"../Handler":6}],60:[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var Scrolling_1 = require("../Scrolling");
var Site_1 = require("../Site");

var Wcag = function () {
    function Wcag() {
        _classCallCheck(this, Wcag);
    }

    _createClass(Wcag, null, [{
        key: "bind",
        value: function bind(target) {
            var _this = this;

            var $target = typeof target !== 'undefined' ? $(target) : Site_1.$body;
            $(document).off('.wcag').on('keydown.wcag', function (e) {
                var key = e.keyCode || e.which;
                if (key === 9 || key === 13 || key === 27) {
                    $('body').addClass('wcag-tab');
                }
                if (_this.firstClickTab && e.key === 'Tab') {
                    $('.skip-link a').first().focus();
                    _this.firstClickTab = false;
                }
            }).on('mousedown.wcag', function (e) {
                $('body').removeClass('wcag-tab');
            });
            $('[data-wcag-skiplink]', $target).off('.wcag').on('click.wcag', function (e) {
                var data = $(e.currentTarget).data('wcag-skiplink');
                switch (data) {
                    case "header":
                        setTimeout(function () {
                            Scrolling_1.Scrolling.scrollToElement($('#header'));
                            $('#header a').first().focus();
                        }, 10);
                        break;
                    case "content":
                        setTimeout(function () {
                            Scrolling_1.Scrolling.scrollToElement($('#content'));
                            $('#content a').first().focus();
                        }, 10);
                        break;
                    default:
                        break;
                }
            });
            $('[data-wcag]', $target).off('.wcag').on('click.wcag', function (e) {
                var data = $(e.currentTarget).data('wcag');
                switch (data) {
                    case "text-normal":
                        $('body').removeClass('wcag-text-big');
                        $('body').removeClass('wcag-text-huge');
                        break;
                    case "text-big":
                        $('body').removeClass('wcag-text-huge');
                        $('body').addClass('wcag-text-big');
                        break;
                    case "text-huge":
                        $('body').removeClass('wcag-text-big');
                        $('body').addClass('wcag-text-huge');
                        break;
                    case "contrast-standard":
                        $('body').removeClass('wcag-contrast-high');
                        break;
                    case "contrast-high":
                        $('body').addClass('wcag-contrast-high');
                        break;
                    case "skiplink-anchor":
                        $('body').removeClass('wcag-tab');
                        break;
                    default:
                        console.log('error wcag');
                        break;
                }
            });
            $("#content a[target='_blank']").each(function (i, e) {
                var href = $(e).attr('href');
                var title = $(e).attr('title');
                var ariaLabel = $(e).attr('aria-label');
                var text = 'Link otworzy się w nowym oknie';
                if (Site_1.lang == 'en') {
                    text = 'The link will open in a new window';
                } else if (Site_1.lang == 'ua') {
                    text = 'Посилання відкриється в новому вікні';
                }
                if (title == undefined) {
                    title = '';
                }
                if (ariaLabel == undefined) {
                    ariaLabel = '';
                }
                $(e).attr('title', title + ' XXX ' + text);
                $(e).attr('aria-label', ariaLabel + ' ' + text);
            });
        }
    }]);

    return Wcag;
}();

exports.Wcag = Wcag;
Wcag.firstClickTab = true;

},{"../Scrolling":12,"../Site":13}]},{},[13]);
